  (function () {
    function applyCouponCustomerHeader(headers) {
      const customerId =
        window.__copyCodeCouponUi && window.__copyCodeCouponUi.customerId;
      if (customerId) {
        headers['X-Customer-Id'] = customerId;
      }
      return headers;
    }

    // Use window-level state so when cart drawer re-renders (script runs again), we don't duplicate listeners or API calls
    const COUPONS_NS = '__copyCodeCoupons';
    if (!window[COUPONS_NS]) {
      window[COUPONS_NS] = {
        listenersAttached: false,
        loadInFlight: false,
        pendingReload: false,
        lastCartData: null,
        debounceTimer: null,
        couponSheetData: {},
        couponSheetUiAttached: false,
        manualHeightListenerAttached: false,
        // Anti-jitter state (mirrors bblunt's smooth flow):
        // - lastRenderedHtml: the exact HTML last written into #coupons_container so we
        //   can rehydrate immediately on cart-drawer re-render without re-fetching.
        // - lastRenderKey: stable hash of inputs to the last render; identical key skips DOM swap.
        // - lastCouponList / lastAppliedCode / lastCountText: cached inputs for instant rehydrate.
        // - couponListRequestId: monotonic counter so stale /coupons/list responses are dropped.
        // - couponCheckInProgress: re-entry guard for the apply/remove → cart-refresh window.
        // - widgetLastHtml / widgetLastKey: same dedup for the below-cart available-offers widget.
        lastRenderedHtml: '',
        lastRenderKey: '',
        lastCouponList: null,
        lastAppliedCode: '',
        lastCountText: '',
        widgetLastHtml: '',
        widgetLastKey: '',
        couponListRequestId: 0,
        couponCheckInProgress: false,
        // Pending Promise while a coupon-removal flow (auto or manual) is in
        // progress. A List API call started around the same time (e.g. from a
        // qty-change) awaits this before fetching, so it always runs against
        // the post-removal cart instead of racing the removal.
        couponRemovalBarrier: null,
        discountRevalidateRequestId: 0,
        discountRevalidateInFlight: false,
        discountRevalidateDebounceTimer: null,
        couponCelebration: null,
        couponCelebrationTimer: null,
        couponCelebrationPendingCart: null,
        manualCouponCelebration: null,
        manualCouponCelebrationTimer: null,
        manualInputCardScrollLock: false,
        manualCouponCarouselRenderedFor: '',
        manualCouponCelebrationShown: false,
        manualCouponError: '',
        popupInputCelebration: null,
        popupInputCelebrationTimer: null,
        popupCardCelebration: null,
        popupCardCelebrationTimer: null,
        couponSuccessAssetsPreloaded: false,
        popupInputError: '',
        popupCardError: null,
        popupApplySource: null,
        viewAllPopupListenersAttached: false,
        couponApiCartSnapshot: null,
        couponSnapshotRefreshInFlight: false,
        couponSnapshotRefreshPromise: null,
        couponSnapshotRefreshedAt: 0,
        pendingApplyCompositionChanged: false,
        splitLineNormalizationInFlight: false,
        lastSplitLineNormalizationSignature: '',
        // When a stored coupon will revalidate on cart:change, defer HVC alert DOM
        // until revalidate settles so payable text is painted once with the final price.
        highValueCartDeferForCoupon: false,
        highValueCartLastToPayCents: null,
        highValueCartLastOrderTotalCents: null,
        highValueCartLastBlocked: false,
        highValueCartHasSynced: false,
        highValueCartDomGeneration: 0,
        highValueCartLastAppliedGeneration: -1,
      };
    }

    const COUPON_APPLY_CELEBRATION_MS = 3000;
    const COUPON_LIST_CACHE_KEY = 'applied_coupon_list_cache';
    // sessionStorage: replaces the 24h localStorage TTL as the trigger that reconciles a stored coupon with the backend when a user returns.
    // Only the revalidation is session-latched — it makes an apply API call. The orphaned-free-item cart check is deliberately unlatched and runs every page load.
    const COLD_START_REVALIDATE_KEY = 'coupon_cold_start_revalidated';
    // sessionStorage: one-shot backstop so a cart that keeps re-corrupting server-side costs one reload per session instead of an infinite reload loop.
    const CART_RECOVERY_RELOAD_KEY = 'coupon_cart_recovery_reloaded';
    const COUPON_TICK_ICON_URL = 'https://cdn.shopify.com/s/files/1/0721/7558/3279/files/tickGreenCircle.svg';
    const state = window[COUPONS_NS];
    if (!state.couponSheetData) state.couponSheetData = {};
    if (typeof state.couponSheetUiAttached === 'undefined') state.couponSheetUiAttached = false;
    if (typeof state.discountRevalidateRequestId === 'undefined') state.discountRevalidateRequestId = 0;
    if (typeof state.discountRevalidateInFlight === 'undefined') state.discountRevalidateInFlight = false;
    if (typeof state.manualCouponCelebration === 'undefined') state.manualCouponCelebration = null;
    if (typeof state.manualCouponCelebrationTimer === 'undefined') state.manualCouponCelebrationTimer = null;
    if (typeof state.manualInputCardScrollLock === 'undefined') state.manualInputCardScrollLock = false;
    if (typeof state.manualCouponCarouselRenderedFor === 'undefined') state.manualCouponCarouselRenderedFor = '';
    if (typeof state.manualCouponCelebrationShown === 'undefined') state.manualCouponCelebrationShown = false;
    if (typeof state.manualCouponError === 'undefined') state.manualCouponError = '';
    if (typeof state.popupInputCelebration === 'undefined') state.popupInputCelebration = null;
    if (typeof state.popupInputCelebrationTimer === 'undefined') state.popupInputCelebrationTimer = null;
    if (typeof state.popupCardCelebration === 'undefined') state.popupCardCelebration = null;
    if (typeof state.popupCardCelebrationTimer === 'undefined') state.popupCardCelebrationTimer = null;
    if (typeof state.couponSuccessAssetsPreloaded === 'undefined') state.couponSuccessAssetsPreloaded = false;
    if (typeof state.popupInputError === 'undefined') state.popupInputError = '';
    if (typeof state.popupCardError === 'undefined') state.popupCardError = null;
    if (typeof state.popupApplySource === 'undefined') state.popupApplySource = null;
    if (typeof state.viewAllPopupListenersAttached === 'undefined') state.viewAllPopupListenersAttached = false;
    if (typeof state.couponApiCartSnapshot === 'undefined') state.couponApiCartSnapshot = null;
    if (typeof state.couponSnapshotRefreshInFlight === 'undefined') state.couponSnapshotRefreshInFlight = false;
    if (typeof state.couponSnapshotRefreshPromise === 'undefined') state.couponSnapshotRefreshPromise = null;
    if (typeof state.couponSnapshotRefreshedAt === 'undefined') state.couponSnapshotRefreshedAt = 0;
    if (typeof state.pendingApplyCompositionChanged === 'undefined') state.pendingApplyCompositionChanged = false;
    if (typeof state.splitLineNormalizationInFlight === 'undefined') state.splitLineNormalizationInFlight = false;
    if (typeof state.lastSplitLineNormalizationSignature === 'undefined') state.lastSplitLineNormalizationSignature = '';
    if (typeof state.orphanFreeItemCheckInFlight === 'undefined') state.orphanFreeItemCheckInFlight = false;
    if (typeof state.orphanFreeItemCartCleared === 'undefined') state.orphanFreeItemCartCleared = false;
    if (typeof state.unknownDiscountStripInFlight === 'undefined') state.unknownDiscountStripInFlight = false;
    if (typeof state.unknownDiscountStripped === 'undefined') state.unknownDiscountStripped = false;
    if (typeof state.coldStartRevalidateDone === 'undefined') state.coldStartRevalidateDone = false;
    if (typeof state.highValueCartDeferForCoupon === 'undefined') state.highValueCartDeferForCoupon = false;
    if (typeof state.highValueCartLastToPayCents === 'undefined') state.highValueCartLastToPayCents = null;
    if (typeof state.highValueCartLastOrderTotalCents === 'undefined') state.highValueCartLastOrderTotalCents = null;
    if (typeof state.highValueCartLastBlocked === 'undefined') state.highValueCartLastBlocked = false;
    if (typeof state.highValueCartHasSynced === 'undefined') state.highValueCartHasSynced = false;
    if (typeof state.highValueCartDomGeneration === 'undefined') state.highValueCartDomGeneration = 0;
    if (typeof state.highValueCartLastAppliedGeneration === 'undefined') {
      state.highValueCartLastAppliedGeneration = -1;
    }
    try {
      const storedDiscountForSnapshot = localStorage.getItem('applied_discount');
      if (storedDiscountForSnapshot) {
        const parsedSnapshot = JSON.parse(storedDiscountForSnapshot);
        if (parsedSnapshot && parsedSnapshot.updatedCart) {
          state.couponApiCartSnapshot = parsedSnapshot.updatedCart;
        }
        // Restore snapshot timestamp from localStorage so freshness check works after page refresh
        if (parsedSnapshot && parsedSnapshot.timestamp) {
          state.couponSnapshotRefreshedAt = parsedSnapshot.timestamp;
        }
      }
    } catch (snapshotErr) {
      /* ignore */
    }
    restoreCouponListFromPersistentCache();
    // Expose re-entry guard globally so apply/remove callers can flip it.
    if (typeof window.couponCheckInProgress === 'undefined') window.couponCheckInProgress = false;

    // Debounce and loading state - use module-level for this script run, sync with state.loadInFlight for deduplication
    let isLoadingCoupons = false;
    let lastCartData = state.lastCartData;

    function startCartActionLoader(preferredScope, fromElement) {
      var scope = null;

      if (preferredScope) {
        scope = preferredScope;
      }

      if (window.HdtCartLoader && typeof window.HdtCartLoader.getScope === 'function') {
        scope = scope || window.HdtCartLoader.getScope(fromElement);
      }

      if (!scope) {
        if (document.getElementById('CartDrawer') && document.getElementById('CartDrawer').hasAttribute('open')) {
          scope = 'cart-drawer';
        } else if (document.getElementById('hdt-page-cart')) {
          scope = 'cart-page';
        }
      }

      if (!scope) return null;

      if (window.HdtCartLoader && typeof window.HdtCartLoader.start === 'function') {
        window.HdtCartLoader.start(scope);
      } else {
        document.dispatchEvent(
          new CustomEvent('theme:loading:doing', {
            bubbles: true,
            detail: { scope: scope, fromElement: fromElement },
          })
        );
      }

      return scope;
    }

    function getPopupCartLoaderScope() {
      if (document.getElementById('hdt-page-cart')) return 'cart-page';
      return 'cart-drawer';
    }

    function startPopupOverlayLoader() {
      const root = document.getElementById('coupon_view_all_root');
      if (!root) return;
      const overlay = root.querySelector('.coupon-full-overlay');
      if (!overlay) return;
      overlay.classList.add('is-busy');
      overlay.setAttribute('aria-busy', 'true');
    }

    function endPopupOverlayLoader() {
      const root = document.getElementById('coupon_view_all_root');
      if (!root) return;
      const overlay = root.querySelector('.coupon-full-overlay');
      if (!overlay) return;
      overlay.classList.remove('is-busy');
      overlay.removeAttribute('aria-busy');
    }

    function endCartActionLoader(scope) {
      if (!scope) return;

      if (window.HdtCartLoader && typeof window.HdtCartLoader.end === 'function') {
        window.HdtCartLoader.end(scope);
      } else {
        document.dispatchEvent(
          new CustomEvent('theme:loading:done', { bubbles: true, detail: { scope: scope } })
        );
      }
    }

    const DEBOUNCE_DELAY = 800; // ms - increased to batch rapid add.js / cart.js and drawer re-renders

    function cacheCartData(cart) {
      if (!cart || typeof cart !== 'object' || !Array.isArray(cart.items)) return;
      state.cartCacheEpoch = (state.cartCacheEpoch || 0) + 1;
      if (!state.cartCacheEpochs) state.cartCacheEpochs = new WeakMap();
      state.cartCacheEpochs.set(cart, state.cartCacheEpoch);
      lastCartData = cart;
      state.lastCartData = cart;
    }

    /**
     * True when a cart passed in as a hint has since been replaced in the cache.
     * Only carts that were themselves cached can be judged: a cart arriving fresh
     * from an event (never cached) is always trusted. An empty hint never wins
     * over a cache that has items — that is the pre-add cart captured before an
     * outside add (Helium chat), and the cache can only gain items from a real cart.
     */
    function isSupersededCartHint(hint) {
      const cached = state.lastCartData;
      if (!hint || !cached || hint === cached) return false;
      if ((Number(hint.item_count) || 0) === 0 && (Number(cached.item_count) || 0) > 0) {
        return true;
      }
      const hintEpoch = state.cartCacheEpochs && state.cartCacheEpochs.get(hint);
      return typeof hintEpoch === 'number' && hintEpoch < (state.cartCacheEpoch || 0);
    }

    // Cart drawer and /cart page both render copyCode — query all roots instead of
    // getElementById so coupon renders stay in sync across duplicate markup.
    function getCouponUiRoots() {
      return Array.from(document.querySelectorAll('[data-copy-code-root]'));
    }

    function getCouponUiParts(root) {
      return {
        root: root,
        container: root.querySelector('[data-coupons-container]'),
        countText: root.querySelector('[data-offer-count-text]'),
      };
    }

    function getAllCouponUiParts() {
      return getCouponUiRoots()
        .map(getCouponUiParts)
        .filter(function (p) {
          return p.container && p.countText;
        });
    }

    function getManualCouponFields(root) {
      if (!root) return null;
      const card = root.querySelector('.coupon-input-card');
      return {
        inputField: root.querySelector('.coupon-input-card .manual-coupon-code'),
        codeDisplay: root.querySelector('.manual-coupon-display'),
        applyButton: root.querySelector('.coupon-input-card .manual-apply-btn'),
        errorEl: root.querySelector('.coupon-input-card [data-manual-coupon-error]'),
        card: card,
        source: 'carousel',
      };
    }

    function getPartnershipWidgetCouponFields() {
      const widget = document.getElementById('available_offers_widget');
      if (!widget) return null;
      const wrap = widget.querySelector('.available-offers-widget__partnership');
      if (!wrap) return null;
      return {
        inputField: wrap.querySelector('.available-offers-widget__partnership-input'),
        codeDisplay: null,
        applyButton: wrap.querySelector('.available-offers-widget__partnership-apply'),
        errorEl: wrap.querySelector('[data-partnership-coupon-error]'),
        card: wrap,
        source: 'widget',
      };
    }

    function getManualCouponFieldsFromElement(el) {
      if (el && el.closest) {
        const widget = el.closest('.available-offers-widget');
        if (widget) return getPartnershipWidgetCouponFields();
        const root = el.closest('[data-copy-code-root]');
        if (root) return getManualCouponFields(root);
      }
      return getManualCouponFields(getCouponUiRoots()[0]) || getPartnershipWidgetCouponFields();
    }

    function syncManualCouponInputs(value, exceptInput) {
      const next = String(value || '').toUpperCase();
      forEachManualCouponRoot(function (fields) {
        if (!fields.inputField || fields.inputField === exceptInput) return;
        if (fields.inputField.disabled) return;
        fields.inputField.value = next;
        syncManualApplyButtonStyle(fields);
      });
    }

    function syncManualApplyButtonStyle(fields) {
      if (!fields || !fields.applyButton) return;
      const isRemove = fields.applyButton.classList.contains('cpnBtn-remove');
      if (!isRemove) {
        fields.applyButton.classList.add('cpnBtn');
      }
      if (fields.source === 'widget') {
        fields.applyButton.classList.toggle('cpnBtn-disabled', false);
        fields.applyButton.classList.toggle(
          'available-offers-widget__partnership-apply--remove',
          isRemove
        );
        syncPartnershipWidgetIdleState(fields);
      } else {
        syncCouponInputCardIdleState(fields);
      }
    }

    // Empty partnership input stays visually disabled until the user starts typing (Figma).
    function syncPartnershipWidgetIdleState(fields) {
      const widgetFields = fields && fields.source === 'widget' ? fields : getPartnershipWidgetCouponFields();
      if (!widgetFields || !widgetFields.inputField || !widgetFields.applyButton) return;

      const row =
        (widgetFields.card &&
          widgetFields.card.querySelector('.available-offers-widget__partnership-row')) ||
        widgetFields.inputField.closest('.available-offers-widget__partnership-row');
      const isRemove = widgetFields.applyButton.classList.contains('cpnBtn-remove');
      const empty = !String(widgetFields.inputField.value || '').trim();
      const idle = !isRemove && !widgetFields.inputField.disabled && empty;

      if (row) {
        row.classList.toggle('is-disabled', idle);
        if (idle) row.classList.remove('is-applied');
      }
      widgetFields.applyButton.classList.toggle('is-disabled', idle);
      widgetFields.applyButton.style.pointerEvents = idle ? 'none' : 'auto';
      widgetFields.applyButton.setAttribute('aria-disabled', idle ? 'true' : 'false');
    }

    // Empty carousel coupon-input-card stays visually disabled until typing (same pattern as partnership-row).
    function syncCouponInputCardIdleState(fields) {
      const cardFields = fields && fields.source === 'carousel' ? fields : null;
      if (!cardFields || !cardFields.inputField || !cardFields.applyButton) return;

      const card = cardFields.card || cardFields.inputField.closest('.coupon-input-card');
      const isRemove = cardFields.applyButton.classList.contains('cpnBtn-remove');
      const empty = !String(cardFields.inputField.value || '').trim();
      const idle = !isRemove && !cardFields.inputField.disabled && empty;

      if (card) card.classList.toggle('is-disabled', idle);
      cardFields.applyButton.classList.toggle('is-disabled', idle);
      cardFields.applyButton.classList.toggle('cpnBtn-disabled', idle);
      cardFields.applyButton.style.pointerEvents = idle ? 'none' : 'auto';
      cardFields.applyButton.setAttribute('aria-disabled', idle ? 'true' : 'false');
    }

    // Applied coupon: swap the input for a static "CODE + Applied" row (Figma).
    function syncManualCouponAppliedDisplay(fields, appliedCode) {
      if (!fields || !fields.inputField) return;

      const code = String(appliedCode || '').toUpperCase();
      if (fields.source === 'widget') {
        syncPartnershipWidgetAppliedDisplay(fields, code);
        return;
      }
      if (fields.source !== 'carousel') return;

      const card = fields.card || fields.inputField.closest('.coupon-input-card');

      if (card) card.classList.toggle('is-applied', !!code);
      fields.inputField.hidden = !!code;

      if (!fields.codeDisplay) return;
      const codeEl = fields.codeDisplay.querySelector('.manual-coupon-display__code');
      if (codeEl) codeEl.textContent = code;
      fields.codeDisplay.hidden = !code;
    }

    // Partnership widget: never leave "CODE + Applied" on screen with an Apply CTA.
    function syncPartnershipWidgetAppliedDisplay(fields, appliedCode) {
      const input = fields && fields.inputField;
      const button = fields && fields.applyButton;
      if (!input || !button) return;

      const row =
        (fields.card && fields.card.querySelector('.available-offers-widget__partnership-row')) ||
        input.closest('.available-offers-widget__partnership-row');
      if (!row) return;

      const code = String(appliedCode || '').toUpperCase();
      const isApplied = !!code;
      const wasApplied =
        row.classList.contains('is-applied') || input.hidden || input.disabled;
      let appliedEl = row.querySelector('.available-offers-widget__partnership-applied');

      row.classList.toggle('is-applied', isApplied);
      input.hidden = isApplied;
      input.disabled = isApplied;

      if (isApplied) {
        input.value = code;
        if (!appliedEl) {
          appliedEl = document.createElement('span');
          appliedEl.className = 'available-offers-widget__partnership-applied';
          appliedEl.innerHTML =
            '<span class="available-offers-widget__partnership-code"></span>' +
            '<span class="available-offers-widget__partnership-applied-label">' +
              '<img src="' +
              COUPON_TICK_ICON_URL +
              '" width="12" height="12" alt="" aria-hidden="true">Applied' +
            '</span>';
          input.insertAdjacentElement('afterend', appliedEl);
        }
        const codeEl = appliedEl.querySelector('.available-offers-widget__partnership-code');
        if (codeEl) codeEl.textContent = code;
      } else {
        if (wasApplied) input.value = '';
        if (appliedEl) appliedEl.remove();
      }

      if (isApplied) {
        button.textContent = 'Remove';
        button.classList.add('cpnBtn', 'cpnBtn-remove');
        button.classList.remove('is-disabled');
        button.onclick = function () {
          window.removeManualCouponFn(this);
        };
      } else {
        button.textContent = 'Apply';
        button.classList.remove(
          'cpnBtn-remove',
          'available-offers-widget__partnership-apply--remove'
        );
        button.classList.add('cpnBtn');
        button.onclick = function () {
          window.applyManualCouponFn(this);
        };
      }
      syncManualApplyButtonStyle(fields);
    }

    function clearManualCouponError(fields) {
      if (!fields) return;
      state.manualCouponError = '';
      if (fields.inputField) fields.inputField.classList.remove('coupon-input--error');
      if (fields.errorEl) {
        fields.errorEl.hidden = true;
        fields.errorEl.innerHTML = '';
      }
      syncManualApplyButtonStyle(fields);
    }

    function setManualCouponError(fields, message) {
      if (!fields || !message) return;
      state.manualCouponError = message;
      if (fields.inputField) fields.inputField.classList.add('coupon-input--error');
      if (fields.errorEl) {
        fields.errorEl.hidden = false;
        const words = String(message).trim().split(/\s+/).filter(Boolean);
        if (words.length > 6) {
          fields.errorEl.innerHTML =
            '<marquee class="manual-coupon-error-marquee" direction="left" scrollamount="3" width="100%">' +
            escapeHtml(message) +
            '</marquee>';
        } else {
          fields.errorEl.textContent = message;
        }
      }
      syncManualApplyButtonStyle(fields);
      // Mirror error onto the other manual input surface.
      forEachManualCouponRoot(function (other) {
        if (other === fields || other.inputField === fields.inputField) return;
        if (other.inputField) other.inputField.classList.add('coupon-input--error');
        if (other.errorEl) {
          other.errorEl.hidden = false;
          other.errorEl.textContent = message;
        }
      });
    }

    // Cart qty/item changes invalidate a failed manual apply — clear persisted error state
    // so restoreManualCouponInput does not re-apply it after carousel re-render.
    function clearStaleCouponInputErrors() {
      state.manualCouponError = '';
      state.popupInputError = '';
      state.popupCardError = null;
      forEachManualCouponRoot(clearManualCouponError);
      clearPopupInputError();
    }

    function forEachManualCouponRoot(callback) {
      getCouponUiRoots().forEach(function (root) {
        const fields = getManualCouponFields(root);
        if (fields && fields.inputField && fields.applyButton) {
          callback(fields, root);
        }
      });
      const widgetFields = getPartnershipWidgetCouponFields();
      if (widgetFields && widgetFields.inputField && widgetFields.applyButton) {
        callback(widgetFields, null);
      }
    }

    function syncStaleCouponRoots() {
      const stale = getAllCouponUiParts().filter(function (p) {
        return (
          !p.container.querySelector('.coupon-card') &&
          (p.container.querySelector('[data-coupon-skeleton]') ||
            /loading offers/i.test(p.countText.textContent || ''))
        );
      });
      if (!stale.length || state.loadInFlight || isLoadingCoupons) return;
      if (rehydrateCouponsFromCache()) return;
      loadCoupons(false, state.lastCartData);
    }

    // Debounce helper function
    function debounce(func, delay, timerKey) {
      return function (...args) {
        if (!state.debounceTimers) state.debounceTimers = {};
        const key = timerKey || 'default';
        clearTimeout(state.debounceTimers[key]);
        state.debounceTimers[key] = setTimeout(() => func.apply(this, args), delay);
      };
    }

    // Function to create shimmer loading UI
    function createShimmerUI() {
      const shimmerCards = Array(3).fill(0).map(() => `
        <div class="coupon-shimmer-card">
          <div class="coupon-shimmer-panel">
            <div class="coupon-shimmer-content">
              <div class="coupon-shimmer-title"></div>
              <div class="coupon-shimmer-subtitle"></div>
              <div class="coupon-shimmer-subtitle"></div>
            </div>
          </div>
          <div class="coupon-shimmer-code-area">
            <div class="coupon-shimmer-code"></div>
            <div class="coupon-shimmer-button"></div>
          </div>
        </div>
      `).join('');
      
      return `<div class="coupon-shimmer">${shimmerCards}</div>`;
    }

    // Use the global getDeviceId function (defined in device-id-utility.liquid)
    // Fallback to inline implementation if not available
    function getDeviceId() {
      if (window.getDeviceId) {
        return window.getDeviceId();
      }

      // Fallback implementation
      let deviceId = localStorage.getItem('shp_device_id');
      if (!deviceId) {
        deviceId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          const r = (Math.random() * 16) | 0;
          const v = c === 'x' ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        });
        localStorage.setItem('shp_device_id', deviceId);
      }
      return deviceId;
    }

    // Function to get cart token from cookies
    function getCartToken() {
      const name = 'cart=';
      const decodedCookie = decodeURIComponent(document.cookie);
      const parts = decodedCookie.split('; ').find((c) => c.startsWith(name));
      if (!parts) return '';
      return parts.substring(name.length);
    }

    // Function to transform Shopify cart data to API format
    function mapCartItemForCouponApi(item) {
      return {
        id: item.id,
        properties: item.properties || {},
        quantity: item.quantity,
        variant_id: item.variant_id,
        key: item.key,
        title: item.title,
        price: item.price,
        original_price: item.original_price || item.price,
        presentment_price: item.price / 100,
        discounted_price: item.discounted_price || item.price,
        line_price: item.line_price || item.price * item.quantity,
        original_line_price: item.original_line_price || item.price * item.quantity,
        total_discount: item.total_discount || 0,
        discounts: item.discounts || [],
        sku: item.sku,
        grams: item.grams || 0,
        vendor: item.vendor,
        taxable: item.taxable !== false,
        product_id: item.product_id,
        product_has_only_default_variant: item.product_has_only_default_variant || false,
        gift_card: item.gift_card || false,
        final_price: item.final_price || item.price,
        final_line_price: item.final_line_price || item.price * item.quantity,
        url: item.url,
        featured_image: item.featured_image,
        image: item.image,
        handle: item.handle,
        requires_shipping: item.requires_shipping !== false,
        product_type: item.product_type,
        product_title: item.product_title,
        product_description: item.product_description,
        variant_title: item.variant_title,
        variant_options: item.variant_options || [],
        options_with_values: item.options_with_values || [],
        line_level_discount_allocations: item.line_level_discount_allocations || [],
        line_level_total_discount: item.line_level_total_discount || 0,
        quantity_rule: item.quantity_rule || { min: 1, max: null, increment: 1 },
        has_components: item.has_components || false,
        properties_stringified: JSON.stringify(item.properties || {}),
      };
    }

    function transformCartForAPI(cartData) {
      const cartToken = getCartToken();
      return {
        cart: {
          token: cartToken,
          note: cartData.note || '',
          attributes: cartData.attributes || {},
          original_total_price: cartData.original_total_price || cartData.total_price || 0,
          total_price: cartData.total_price || 0,
          total_discount: cartData.total_discount || 0,
          total_weight: cartData.total_weight || 0,
          item_count: cartData.item_count || 0,
          items: (cartData.items || []).map(mapCartItemForCouponApi),
          requires_shipping: cartData.requires_shipping !== false,
          currency: cartData.currency || 'INR',
          items_subtotal_price: cartData.items_subtotal_price || cartData.total_price || 0,
          cart_level_discount_applications: cartData.cart_level_discount_applications || [],
          discount_codes: cartData.discount_codes || [],
          gokwik_source_channel: 'shopify_checkout',
        },
      };
    }

    function getAppliedCouponUpdatedCart() {
      const storedDiscount = getDiscountFromStorage();
      if (!storedDiscount || !storedDiscount.code) return null;
      return storedDiscount.updatedCart || state.couponApiCartSnapshot || null;
    }

    function scaleLineItemToQuantity(item, quantity) {
      const qty = Number(quantity) || 0;
      const unitFinal =
        Number(
          item.final_price != null
            ? item.final_price
            : item.discounted_price != null
              ? item.discounted_price
              : item.price
        ) || 0;
      const unitOriginal = Number(item.original_price != null ? item.original_price : item.price) || unitFinal;
      return Object.assign({}, item, {
        quantity: qty,
        line_price: unitFinal * qty,
        original_line_price: unitOriginal * qty,
        final_line_price: unitFinal * qty,
      });
    }

    function sumDisplayCartLineTotals(items) {
      let originalTotal = 0;
      let totalPrice = 0;
      (items || []).forEach(function (item) {
        originalTotal += Number(item.original_line_price) || 0;
        totalPrice +=
          Number(item.final_line_price != null ? item.final_line_price : item.line_price) || 0;
      });
      return {
        originalTotal: originalTotal,
        totalPrice: totalPrice,
        totalDiscount: Math.max(0, originalTotal - totalPrice),
      };
    }

    /**
     * Merge live Shopify cart composition (qty, keys, new lines) with apply-API
     * updatedCart pricing. Used for display (line items) and the price summary.
     * Not for /coupons/list — that always gets the plain live cart; see
     * buildCouponListApiPayload.
     */
    function mergeShopifyCartWithUpdatedCart(shopifyCart, updatedCart, storedDiscount) {
      if (
        !shopifyCart ||
        !updatedCart ||
        !Array.isArray(updatedCart.items) ||
        !updatedCart.items.length
      ) {
        return shopifyCart;
      }

      const liveItems = shopifyCart.items || [];
      const mergedItems = [];
      const consumedLiveIndexes = {};

      function getItemIdentity(item) {
        if (!item) return '';
        if (item.variant_id != null && item.variant_id !== '') return 'v:' + String(item.variant_id);
        if (item.id != null && item.id !== '') return 'id:' + String(item.id);
        return '';
      }

      updatedCart.items.forEach(function (snapItem) {
        const snapIdentity = getItemIdentity(snapItem);
        if (!snapIdentity) return;

        const matchingIndexes = [];
        for (let i = 0; i < liveItems.length; i++) {
          if (consumedLiveIndexes[i]) continue;
          const liveIdentity = getItemIdentity(liveItems[i]);
          if (liveIdentity === snapIdentity) matchingIndexes.push(i);
        }
        if (!matchingIndexes.length) return;

        let mergedQty = 0;
        matchingIndexes.forEach(function (idx) {
          consumedLiveIndexes[idx] = true;
          mergedQty += Number(liveItems[idx] && liveItems[idx].quantity) || 0;
        });
        if (mergedQty <= 0) mergedQty = Number(snapItem.quantity) || 0;
        if (mergedQty <= 0) mergedQty = 1;

        const firstLiveItem = liveItems[matchingIndexes[0]];
        mergedItems.push(
          Object.assign(scaleLineItemToQuantity(snapItem, mergedQty), {
            key: firstLiveItem && firstLiveItem.key,
            id: firstLiveItem && firstLiveItem.id != null ? firstLiveItem.id : snapItem.id,
          })
        );
      });

      liveItems.forEach(function (liveItem, idx) {
        if (!consumedLiveIndexes[idx]) {
          mergedItems.push(liveItem);
        }
      });

      let itemCount = 0;
      mergedItems.forEach(function (item) {
        itemCount += item.quantity || 0;
      });

      const lineTotals = sumDisplayCartLineTotals(mergedItems);
      const snapshotFresh = isCouponSnapshotFresh(updatedCart, shopifyCart);
      const couponCode = storedDiscount && storedDiscount.code;

      const displayCart = Object.assign({}, shopifyCart, {
        note: updatedCart.note != null ? updatedCart.note : shopifyCart.note || '',
        attributes: shopifyCart.attributes || updatedCart.attributes || {},
        original_total_price:
          snapshotFresh && updatedCart.original_total_price != null
            ? updatedCart.original_total_price
            : lineTotals.originalTotal,
        total_price:
          snapshotFresh && updatedCart.total_price != null
            ? updatedCart.total_price
            : lineTotals.totalPrice,
        total_discount:
          snapshotFresh && updatedCart.total_discount != null
            ? updatedCart.total_discount
            : lineTotals.totalDiscount,
        total_weight: shopifyCart.total_weight || updatedCart.total_weight || 0,
        item_count: itemCount || shopifyCart.item_count,
        items: mergedItems,
        requires_shipping: updatedCart.requires_shipping !== false,
        currency: updatedCart.currency || shopifyCart.currency || 'INR',
        items_subtotal_price:
          snapshotFresh && updatedCart.items_subtotal_price != null
            ? updatedCart.items_subtotal_price
            : lineTotals.totalPrice,
        cart_level_discount_applications: [],
        discount_codes: couponCode ? [{ code: couponCode, applicable: true }] : [],
        discount: updatedCart.discount || (storedDiscount && storedDiscount.data) || null,
        _displaySource: 'updatedCart',
        // Only the matching-composition snapshot's API payable is trustworthy.
        // A leftover post-order snapshot can have total_price 0; using it on a
        // new cart is what painted To Pay as ₹0 after partnership checkout.
        _snapshotFresh: snapshotFresh,
      });

      if (updatedCart.overwritten_automatic_discount) {
        displayCart.overwritten_automatic_discount = updatedCart.overwritten_automatic_discount;
      }
      if (updatedCart.payment_offer_discount != null) {
        displayCart.payment_offer_discount = updatedCart.payment_offer_discount;
      }

      return displayCart;
    }

    /** Display cart: updatedCart when coupon active, otherwise live Shopify cart. */
    function getDisplayCart(shopifyCartHint) {
      const shopifyCart =
        shopifyCartHint && typeof shopifyCartHint.item_count !== 'undefined'
          ? shopifyCartHint
          : state.lastCartData || lastCartData;
      if (!shopifyCart) return null;

      const storedDiscount = getDiscountFromStorage();
      const updatedCart = getAppliedCouponUpdatedCart();
      if (
        storedDiscount &&
        storedDiscount.code &&
        updatedCart &&
        Array.isArray(updatedCart.items) &&
        updatedCart.items.length
      ) {
        return mergeShopifyCartWithUpdatedCart(shopifyCart, updatedCart, storedDiscount);
      }
      return shopifyCart;
    }

    function buildLinePropertiesSignature(item) {
      if (!item || !item.properties) return '{}';
      try {
        return JSON.stringify(item.properties);
      } catch (e) {
        return '{}';
      }
    }

    /**
     * Coupon-applied carts can occasionally split the same paid SKU into multiple lines.
     * Consolidate paid duplicates into one Shopify line so UI shows one paid row + free row.
     */
    function maybeNormalizeSplitPaidLines(shopifyCart) {
      if (
        !shopifyCart ||
        !Array.isArray(shopifyCart.items) ||
        !shopifyCart.items.length ||
        state.splitLineNormalizationInFlight
      ) {
        return false;
      }
      if (!getDiscountFromStorage()?.code) return false;

      const groups = {};
      shopifyCart.items.forEach(function (item) {
        if (!item || !item.key) return;
        const unitFinal =
          Number(
            item.final_price != null
              ? item.final_price
              : item.discounted_price != null
                ? item.discounted_price
                : item.price
          ) || 0;
        if (unitFinal <= 0) return; // keep free lines untouched

        const variantId = item.variant_id || item.id;
        if (!variantId) return;
        const groupKey =
          String(variantId) +
          '|' +
          unitFinal +
          '|' +
          buildLinePropertiesSignature(item);
        if (!groups[groupKey]) groups[groupKey] = [];
        groups[groupKey].push(item);
      });

      const updates = {};
      const signatureParts = [];
      Object.keys(groups).forEach(function (groupKey) {
        const lines = groups[groupKey];
        if (!lines || lines.length < 2) return;
        let totalQty = 0;
        lines.forEach(function (line) {
          totalQty += Number(line.quantity) || 0;
        });
        if (totalQty <= 0) return;

        lines.forEach(function (line, idx) {
          updates[line.key] = idx === 0 ? totalQty : 0;
        });
        signatureParts.push(
          groupKey +
            ':' +
            lines
              .map(function (line) {
                return String(line.key) + '=' + (Number(line.quantity) || 0);
              })
              .join(',')
        );
      });

      const updateKeys = Object.keys(updates);
      if (!updateKeys.length) return false;

      const signature = signatureParts.sort().join('||');
      if (!signature) return false;
      if (state.lastSplitLineNormalizationSignature === signature) return false;

      state.lastSplitLineNormalizationSignature = signature;
      state.splitLineNormalizationInFlight = true;

      const updatesArray = [];
      shopifyCart.items.forEach(function (item, idx) {
        if (!item || !item.key) return;
        if (updates[item.key] != null) {
          updatesArray[idx] = updates[item.key];
        } else {
          updatesArray[idx] = item.quantity || 0;
        }
      });

      console.log('[Cart] Merging split paid lines:', updatesArray);

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updatesArray }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Failed to normalize split paid lines');
          return res.json();
        })
        .then(function (updatedCart) {
          if (!updatedCart || typeof updatedCart !== 'object') return;
          cacheCartData(updatedCart);
          setTimeout(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: updatedCart } }));
          }, 50);
        })
        .catch(function (err) {
          console.warn('Split-line normalization failed:', err);
        })
        .finally(function () {
          setTimeout(function () {
            state.splitLineNormalizationInFlight = false;
          }, 300);
        });

      return true;
    }

    // /coupons/list answers "which coupons COULD apply to this cart?" — an
    // eligibility question about the customer's actual cart, independent of
    // whatever is applied right now. So it always gets the plain live cart,
    // with no active-discount signal attached.
    //
    // We used to send the apply-API display shape while a coupon was active
    // (discounted totals plus `discount` / `discount_codes`). The backend then
    // evaluated the rest of the list against that active coupon — and a
    // non-stackable one (OMG comes back with isStackable:false) makes every
    // other coupon return isApplicable:false. Caching that response is what
    // left the whole carousel disabled once the coupon was removed.
    //
    // Shopify's own discount_codes / cart_level_discount_applications are
    // stripped for the same reason: the list API returns [] when it sees them.
    //
    // The one exception is the top-level `appliedCoupon`: the exact coupons[]
    // entry the apply API returned. Backend uses it only to report the applied
    // coupon's saving (e.g. B1G1) in the list. Sessions stored before this
    // field existed simply omit it until their next apply / revalidate.
    function buildCouponListApiPayload(cartData) {
      const transformed = transformCartForAPI(cartData);
      transformed.cart.discount_codes = [];
      transformed.cart.cart_level_discount_applications = [];
      const storedDiscount = getDiscountFromStorage();
      if (storedDiscount && storedDiscount.code && storedDiscount.appliedCoupon) {
        transformed.appliedCoupon = storedDiscount.appliedCoupon;
      }
      return transformed;
    }

    function saveCouponListCache(coupons) {
      if (!coupons || !coupons.length) return;
      try {
        localStorage.setItem(
          COUPON_LIST_CACHE_KEY,
          JSON.stringify({ coupons: coupons, ts: Date.now() })
        );
      } catch (cacheErr) {
        /* ignore quota errors */
      }
    }

    function getCouponListCache() {
      try {
        const raw = localStorage.getItem(COUPON_LIST_CACHE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || !Array.isArray(parsed.coupons) || !parsed.coupons.length) return null;
        // No TTL: the cache persists until explicitly cleared (resetCouponListCache /
        // clearCouponListCache), so a returning customer never sees an empty carousel
        // just because time passed. `ts` is still written for debugging.
        return parsed.coupons;
      } catch (cacheErr) {
        return null;
      }
    }

    function clearCouponListCache() {
      try {
        localStorage.removeItem(COUPON_LIST_CACHE_KEY);
      } catch (cacheErr) {
        /* ignore */
      }
    }

    function resetCouponListCache() {
      state.lastCouponList = null;
      state.lastAppliedCode = '';
      state.lastRenderKey = '';
      state.lastRenderedHtml = '';
      state.lastCountText = '';
      state.viewAllCoupons = [];
      clearCouponListCache();
    }

    // Call at the start of a coupon-removal flow. Bumps couponListRequestId so
    // any List API call already in flight (dispatched before removal started)
    // gets its response dropped by fetchCouponsFromAPI's staleness check
    // instead of rendering coupon-still-applied data. Also opens a barrier that
    // loadCoupons will wait on before fetching, so a List call scheduled around
    // the same time runs only after removal (and its cart sync) finishes.
    function beginCouponRemovalBarrier() {
      state.couponListRequestId += 1;
      let release;
      state.couponRemovalBarrier = new Promise(function (resolve) {
        release = resolve;
      });
      return release;
    }

    function endCouponRemovalBarrier(release) {
      if (typeof release === 'function') release();
      state.couponRemovalBarrier = null;
    }

    // Compare cart compositions to detect if line items/quantities changed
    function isCartCompositionUnchanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) return false;
      if (!Array.isArray(cartBefore.items) || !Array.isArray(cartAfter.items)) return false;
      if (cartBefore.items.length !== cartAfter.items.length) return false;
      if (cartBefore.item_count !== cartAfter.item_count) return false;

      // Build composition maps: variant_id -> quantity
      const buildMap = function(items) {
        const map = {};
        items.forEach(function(item) {
          const key = String(item.variant_id || item.id);
          map[key] = (map[key] || 0) + (item.quantity || 0);
        });
        return map;
      };

      const beforeMap = buildMap(cartBefore.items);
      const afterMap = buildMap(cartAfter.items);

      const beforeKeys = Object.keys(beforeMap).sort();
      const afterKeys = Object.keys(afterMap).sort();

      if (beforeKeys.length !== afterKeys.length) return false;

      for (let i = 0; i < beforeKeys.length; i++) {
        if (beforeKeys[i] !== afterKeys[i]) return false;
        if (beforeMap[beforeKeys[i]] !== afterMap[afterKeys[i]]) return false;
      }

      return true;
    }

    // Re-render coupon UI from cache with updated applied state (no list API call)
    function reRenderCouponsFromCacheAfterRemove() {
      if (!state.lastCouponList || !state.lastCouponList.length) {
        // No cache available, will need to fetch
        return false;
      }

      const storeCarouselCoupons = state.lastCouponList.filter(function (coupon) {
        return String(coupon && coupon.offerType || '').toLowerCase() === 'store_offer';
      });

      // Force re-render with no applied coupon
      state.lastAppliedCode = '';
      state.lastRenderKey = ''; // Force dedup to allow write
      renderCouponsList(state.lastCouponList, storeCarouselCoupons, '');

      return true;
    }

    function restoreCouponListFromPersistentCache() {
      if (state.lastCouponList && state.lastCouponList.length) return state.lastCouponList;
      const cached = getCouponListCache();
      if (cached && cached.length) {
        state.lastCouponList = cached;
        return cached;
      }
      return null;
    }

    function isCouponSnapshotFresh(snapshot, cartData) {
      if (!snapshot || !Array.isArray(snapshot.items) || !snapshot.items.length) return false;
      const liveItems = cartData && cartData.items ? cartData.items : [];
      if (!liveItems.length || liveItems.length !== snapshot.items.length) return false;
      return liveItems.every(function (liveItem) {
        const snapItem = snapshot.items.find(function (s) {
          return s.variant_id === liveItem.variant_id || String(s.id) === String(liveItem.id);
        });
        return snapItem && Number(snapItem.quantity) === Number(liveItem.quantity);
      });
    }

    // Apply runs on user action or cart composition change (revalidateAppliedDiscount).
    // List payload uses stored updatedCart via buildCouponListApiPayload — no apply on cold start.

    // How long a settled /coupons/list response is reused for an identical payload.
    const COUPON_LIST_REUSE_MS = 5000;

    // Failed / unsuccessful responses are never reused.
    function dropCouponListMemo(entry) {
      if (state.couponListMemo === entry) state.couponListMemo = null;
    }

    // Function to fetch coupons from API.
    // Returns null if the response was superseded by a newer request so the caller
    // can bail out cleanly without overwriting newer state (mirrors bblunt's
    // couponListRequestId pattern).
    async function fetchCouponsFromAPI(cartData) {
      const requestId = ++state.couponListRequestId;
      try {
        const deviceId = getDeviceId();
        const transformedCart = buildCouponListApiPayload(cartData);

        const headers = applyCouponCustomerHeader({
          'x-source': 'web-app',
          'x-platform': 'web',
          'x-device-id': deviceId,
          'Content-Type': 'application/json',
        });

        const body = JSON.stringify(transformedCart);

        // One cart change reaches loadCoupons from several paths (drawer re-render
        // boot, cart:change debounce, pendingReload flush), each with the same cart.
        // The payload is deterministic, so share an in-flight or just-finished
        // request for an identical payload instead of hitting /coupons/list again.
        const memoKey = (headers['X-Customer-Id'] || '') + '|' + body;
        const memo = state.couponListMemo;
        let pending;
        if (
          memo &&
          memo.key === memoKey &&
          (memo.inFlight || Date.now() - memo.settledAt < COUPON_LIST_REUSE_MS)
        ) {
          pending = memo.promise;
        } else {
          pending = fetch(`https://api-v1.mamaearth.in/${themeHDN.settings.listAPIVersion}/coupons/list`, {
            method: 'POST',
            headers: headers,
            body: body,
          }).then(function (response) {
            if (!response.ok) throw new Error('Failed to fetch coupons');
            return response.json();
          });
          const entry = { key: memoKey, promise: pending, inFlight: true, settledAt: 0 };
          state.couponListMemo = entry;
          pending.then(
            function (result) {
              entry.inFlight = false;
              entry.settledAt = Date.now();
              if (!result || !result.success) dropCouponListMemo(entry);
            },
            function () {
              dropCouponListMemo(entry);
            }
          );
        }

        const result = await pending;
        if (requestId !== state.couponListRequestId) return null;
        if (!result.success || !Array.isArray(result.data)) {
          return [];
        }
        return result.data.filter(function (item) {
          if (!item) return false;
          const t = String(item.offerType || '').toLowerCase();
          return t === 'store_offer' || t === 'payment_offer';
        });
      } catch (error) {
        if (requestId !== state.couponListRequestId) return null;
        console.error('Error fetching coupons:', error);
        return [];
      }
    }

    // Helper function to escape HTML
    function escapeHtml(text) {
      const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;',
      };
      return String(text).replace(/[&<>"']/g, function (m) {
        return map[m];
      });
    }

    // Helper function to escape JavaScript strings
    function escapeJS(text) {
      return String(text)
        .replace(/\\/g, '\\\\')
        .replace(/'/g, "\\'")
        .replace(/"/g, '\\"')
        .replace(/\n/g, '\\n')
        .replace(/\r/g, '\\r');
    }

    function couponSanitizeUrl(url) {
      const u = String(url || '').trim();
      if (!u) return '';
      if (/^https?:\/\//i.test(u)) return u;
      if (u.startsWith('/')) return u;
      return '';
    }

    function getCouponSavingsLine(coupon) {
      const raw =
        coupon.savingsMessage ||
        coupon.savings_message ||
        coupon.highlightMessage ||
        coupon.highlight_message ||
        coupon.offerHighlight ||
        coupon.offer_highlight ||
        coupon.extraSavingText ||
        coupon.extra_saving_text ||
        coupon.savingsText ||
        coupon.savings_text ||
        coupon.subtitle ||
        coupon.sub_title ||
        coupon.subTitle ||
        '';
      return String(raw || '').trim();
    }

    function isCouponSaveLine(text) {
      const s = String(text || '').trim();
      if (!s) return false;
      return /^save\b/i.test(s) || /\bwith this offer\b/i.test(s) || /\bwith this code\b/i.test(s);
    }

    /** Prefer dedicated savings fields; API often sends the save line in `message`. */
    function resolveCouponSavingsLine(coupon) {
      const dedicated = getCouponSavingsLine(coupon);
      if (dedicated) return dedicated;
      const msg = String(coupon.message || '').trim();
      if (isCouponSaveLine(msg)) return msg;
      return '';
    }

    function resolveCouponDisplayMessage(coupon, savingsLine) {
      const msg = String(coupon.message || '').trim();
      if (!msg) return '';
      if (savingsLine && msg === savingsLine) return '';
      if (savingsLine && isCouponSaveLine(msg)) return '';
      return msg;
    }

    /** Green savings line: entire line green; currency amount wrapped in <strong>. */
    function formatCouponSavingsLineHtml(savingsLine) {
      const s = String(savingsLine || '').trim();
      if (!s) return '';

      const ranges = [];
      const amountRe = /(?:₹|\u20B9|Rs\.?\s*|INR\s*)[\d,]+(?:\.\d+)?/gi;
      let match;
      while ((match = amountRe.exec(s)) !== null) {
        ranges.push({ start: match.index, end: match.index + match[0].length, text: match[0] });
      }

      if (!ranges.length && /^save\b/i.test(s)) {
        const saveMatch = s.match(/^save\s+((?:₹|\u20B9|Rs\.?\s*|INR\s*)?[\d,]+(?:\.\d+)?)/i);
        if (saveMatch && saveMatch.index != null && saveMatch[1]) {
          const start = saveMatch.index + saveMatch[0].length - saveMatch[1].length;
          ranges.push({ start: start, end: start + saveMatch[1].length, text: saveMatch[1] });
        }
      }

      if (!ranges.length) return escapeHtml(s);

      ranges.sort(function (a, b) {
        return a.start - b.start;
      });

      let html = '';
      let lastIndex = 0;
      ranges.forEach(function (range) {
        if (range.start < lastIndex) return;
        html += escapeHtml(s.slice(lastIndex, range.start));
        html += '<strong class="coupon-savings__amount">' + escapeHtml(range.text) + '</strong>';
        lastIndex = range.end;
      });
      html += escapeHtml(s.slice(lastIndex));
      return html;
    }

    function isCouponCelebrationActive() {
      return !!(state.couponCelebration && Date.now() < state.couponCelebration.until);
    }

    function isCouponEntryValid(couponEntry) {
      return !!(couponEntry && couponEntry.isValid === true);
    }

    function findCouponEntryInApplyResult(result, code) {
      const normalizedCode = String(code || '').toLowerCase();
      if (!normalizedCode) return null;
      const coupons =
        result && result.data && Array.isArray(result.data.coupons) ? result.data.coupons : [];
      return (
        coupons.find(function (c) {
          return String(c.code || c.title || '').toLowerCase() === normalizedCode;
        }) || null
      );
    }

    function resolveValidAppliedCoupon(result, code) {
      const entry = findCouponEntryInApplyResult(result, code);
      return isCouponEntryValid(entry) ? entry : null;
    }

    function findInvalidCouponEntry(result, code) {
      const entry = findCouponEntryInApplyResult(result, code);
      if (!entry || isCouponEntryValid(entry)) return null;
      return entry;
    }

    function clearAllCouponApplyCelebrations() {
      if (state.couponCelebrationTimer) {
        clearTimeout(state.couponCelebrationTimer);
        state.couponCelebrationTimer = null;
      }
      const carouselCode = state.couponCelebration && state.couponCelebration.code;
      state.couponCelebration = null;
      state.couponCelebrationPendingCart = null;
      if (carouselCode) hideCouponApplyCelebration(carouselCode);

      if (state.manualCouponCelebrationTimer) {
        clearTimeout(state.manualCouponCelebrationTimer);
        state.manualCouponCelebrationTimer = null;
      }
      state.manualCouponCelebration = null;
      state.manualInputCardScrollLock = false;
      state.manualCouponCarouselRenderedFor = '';
      state.manualCouponCelebrationShown = false;
      hideManualCouponCelebration();

      if (state.popupInputCelebrationTimer) {
        clearTimeout(state.popupInputCelebrationTimer);
        state.popupInputCelebrationTimer = null;
      }
      if (state.popupCardCelebrationTimer) {
        clearTimeout(state.popupCardCelebrationTimer);
        state.popupCardCelebrationTimer = null;
      }
      hidePopupInputCelebration();
      if (state.popupCardCelebration && state.popupCardCelebration.code) {
        hidePopupCardCelebration(state.popupCardCelebration.code);
      }
      state.popupInputCelebration = null;
      state.popupCardCelebration = null;
    }

    function formatCouponCelebrationSavings(discountData, savingsLine) {
      const line = String(savingsLine || '').trim();
      const fromLine = line.match(/(?:₹|\u20B9|Rs\.?\s*|INR\s*)([\d,]+(?:\.\d+)?)/i);
      if (fromLine) return '₹' + fromLine[1].replace(/,/g, '');
      const amt = Number(discountData && discountData.total_discount);
      if (isFinite(amt) && amt > 0) {
        const formatted = formatMoneyFromDiscountTotalPrice(amt);
        return formatted || '₹' + amt.toFixed(2);
      }
      return '';
    }

    // Shared coupon-apply success popup (Figma: All Final Pages 1 / 26590:3300).
    // Replaces the per-card confetti overlays: every apply surface (carousel
    // card, manual input, view-all tray input/card) now celebrates through this
    // one centered dialog. The existing celebration state machines are untouched
    // — they still own timing, cart refresh and re-render sequencing; only the
    // rendered surface changed.
    const COUPON_SUCCESS_CLOSE_ICON =
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M20.4894 3.51075C15.8086 -1.17002 8.19199 -1.17048 3.51075 3.51075C-1.17048 8.19199 -1.17002 15.8081 3.51075 20.4894C8.19153 25.1706 15.8081 25.1706 20.4894 20.4894C25.1701 15.8081 25.1701 8.19153 20.4894 3.51075ZM16.7344 16.7344C16.3738 17.095 15.7892 17.095 15.4286 16.7344L12.0001 13.3059L8.40855 16.8974C8.04793 17.258 7.46335 17.258 7.10272 16.8974C6.74209 16.5368 6.74209 15.9522 7.10272 15.5916L10.6942 12.0001L7.26572 8.57155C6.90509 8.21092 6.90509 7.62588 7.26572 7.26572C7.62635 6.90509 8.21092 6.90509 8.57155 7.26572L12.0001 10.6942L15.2651 7.42918C15.6257 7.06855 16.2103 7.06855 16.5709 7.42918C16.9316 7.78981 16.9316 8.37438 16.5709 8.73501L13.3059 12.0001L16.7344 15.4286C17.095 15.7892 17.095 16.3738 16.7344 16.7344Z" fill="#CCCCCC"/>' +
      '</svg>';

    function ensureCouponSuccessPopup() {
      patchCartDrawerForCouponSheets();
      let root = document.getElementById('coupon_success_popup_root');
      if (root) {
        bindCouponSheetPointerGuards(root);
        return mountCouponSheetToBody(root);
      }

      root = document.createElement('div');
      root.id = 'coupon_success_popup_root';
      root.hidden = true;
      root.innerHTML =
        '<div class="coupon-success-overlay" aria-hidden="true" role="presentation">' +
        '<div class="coupon-success-backdrop" tabindex="-1"></div>' +
        '<div class="coupon-success-float">' +
        '<button type="button" class="coupon-success-close" aria-label="Close">' +
        COUPON_SUCCESS_CLOSE_ICON +
        '</button>' +
        '<div class="coupon-success-popup" role="dialog" aria-modal="true" aria-labelledby="coupon_success_headline">' +
        '<div class="coupon-success-popup__anim">' +
        '<span class="coupon-success-popup__tick" aria-hidden="true"></span>' +
        '<p class="coupon-success-popup__congrats">Congratulations</p>' +
        '<p class="coupon-success-popup__headline" id="coupon_success_headline" data-success-headline></p>' +
        '</div>' +
        '<div class="coupon-success-popup__cashback" data-success-cashback hidden>' +
        '<span class="coupon-success-popup__cashback-text" data-success-cashback-text></span>' +
        '</div>' +
        '</div>' +
        '</div></div>';

      mountCouponSheetToBody(root);
      bindCouponSheetPointerGuards(root);

      const overlay = root.querySelector('.coupon-success-overlay');
      const backdrop = root.querySelector('.coupon-success-backdrop');
      const closeBtn = root.querySelector('.coupon-success-close');

      overlay.addEventListener('click', function (e) {
        if (e.target === backdrop) dismissCouponSuccessPopup();
      });
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        dismissCouponSuccessPopup();
      });

      return root;
    }

    function buildCouponSuccessHeadline(code, savedText) {
      const upper = String(code || '').toUpperCase();
      if (!upper) return savedText ? 'Coupon applied and you saved ' + savedText : 'Coupon applied successfully';
      if (!savedText) return upper + ' applied successfully';
      return upper + ' applied and you saved ' + savedText;
    }

    // Cashback rides on the apply response when present, otherwise falls back to
    // the same cart/storage lookup the header saving banner uses.
    function resolveCouponSuccessCashback(discountData) {
      const direct =
        discountData && (discountData.cashback_data || discountData.cashbackData);
      return resolveCashbackBannerContent(direct || getCashbackDataFromCart(state.lastCartData));
    }

    function openCouponSuccessPopup(opts) {
      const options = opts || {};
      const root = ensureCouponSuccessPopup();
      const overlay = root.querySelector('.coupon-success-overlay');
      if (!overlay) return false;

      const headlineEl = root.querySelector('[data-success-headline]');
      if (headlineEl) {
        headlineEl.textContent = buildCouponSuccessHeadline(options.code, options.savedText);
      }

      const cashbackEl = root.querySelector('[data-success-cashback]');
      const cashbackTextEl = root.querySelector('[data-success-cashback-text]');
      if (cashbackEl && cashbackTextEl) {
        const cashback = resolveCouponSuccessCashback(options.discountData);
        if (cashback && cashback.html) {
          cashbackTextEl.innerHTML = cashback.html;
          cashbackEl.hidden = false;
        } else if (cashback && cashback.text) {
          cashbackTextEl.textContent = cashback.text;
          cashbackEl.hidden = false;
        } else {
          cashbackTextEl.textContent = '';
          cashbackEl.hidden = true;
        }
      }

      overlay.dataset.source = options.source || '';
      if (overlay.classList.contains('is-open')) return true;

      root.hidden = false;
      overlay.style.display = 'flex';
      overlay.setAttribute('aria-hidden', 'false');
      // Next frame so the opening transition runs from the closed state.
      window.requestAnimationFrame(function () {
        overlay.classList.add('is-open');
      });
      syncCartDrawerFocusTrapForCouponSheets();
      return true;
    }

    // `source` scopes the close to the surface that opened the popup, so a stray
    // hide from another celebration path cannot dismiss a live one. Omit it to
    // force-close.
    function closeCouponSuccessPopup(source) {
      const root = document.getElementById('coupon_success_popup_root');
      if (!root) return;
      const overlay = root.querySelector('.coupon-success-overlay');
      if (!overlay || !overlay.classList.contains('is-open')) return;
      if (source && overlay.dataset.source !== source) return;

      overlay.classList.remove('is-open');
      const popup = root.querySelector('.coupon-success-popup');
      let finished = false;
      function finishClose(ev) {
        if (ev && ev.propertyName && ev.propertyName !== 'transform') return;
        if (finished) return;
        finished = true;
        if (popup) popup.removeEventListener('transitionend', finishClose);
        if (!overlay.classList.contains('is-open')) {
          overlay.setAttribute('aria-hidden', 'true');
          overlay.style.display = 'none';
          overlay.dataset.source = '';
          root.hidden = true;
          syncCartDrawerFocusTrapForCouponSheets();
        }
      }
      if (popup) popup.addEventListener('transitionend', finishClose);
      window.setTimeout(finishClose, 400);
    }

    // Closing early must not strand the pending cart refresh / re-render that a
    // celebration timer owns. Collapsing `until` to now and re-scheduling makes
    // each timer fire its own end path immediately.
    function endActiveCouponCelebrationsNow() {
      const now = Date.now();
      if (state.couponCelebration) {
        state.couponCelebration.until = now;
        scheduleCouponCelebrationEnd();
      }
      if (state.manualCouponCelebration) {
        state.manualCouponCelebration.until = now;
        scheduleManualCouponCelebrationEnd();
      }
      if (state.popupInputCelebration) {
        state.popupInputCelebration.until = now;
        schedulePopupInputCelebrationEnd();
      }
      if (state.popupCardCelebration) {
        state.popupCardCelebration.until = now;
        schedulePopupCardCelebrationEnd();
      }
    }

    function dismissCouponSuccessPopup() {
      closeCouponSuccessPopup();
      endActiveCouponCelebrationsNow();
    }

    // The popup's GIFs are CSS backgrounds inside a hidden root, so the browser
    // does not fetch them until the popup is first shown — on a slow connection
    // the 3s celebration window can expire before the tick has painted. Warm
    // them into the HTTP cache ahead of time instead. Reading the URL off the
    // element's computed style keeps CSS the single source of truth, including
    // the theme-settings override; computed style resolves the url() without
    // rendering the element, so nothing is fetched until we ask for it here.
    function preloadCouponSuccessAssets() {
      if (state.couponSuccessAssetsPreloaded) return;
      if (typeof window.Image !== 'function') return;
      const root = ensureCouponSuccessPopup();
      if (!root) return;
      state.couponSuccessAssetsPreloaded = true;

      ['.coupon-success-popup__tick', '.coupon-success-popup__anim'].forEach(function (selector) {
        const el = root.querySelector(selector);
        if (!el) return;
        const bg = window.getComputedStyle(el).backgroundImage;
        const match = /url\(\s*["']?(.*?)["']?\s*\)/.exec(bg || '');
        const url = match && match[1];
        if (!url || url === 'none') return;
        const img = new Image();
        img.decoding = 'async';
        img.src = url;
      });
    }

    function schedulePreloadCouponSuccessAssets() {
      if (state.couponSuccessAssetsPreloaded) return;
      const run = function () {
        try {
          preloadCouponSuccessAssets();
        } catch (err) {
          console.error('Error preloading coupon success assets:', err);
        }
      };
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(run, { timeout: 2000 });
      } else {
        setTimeout(run, 300);
      }
    }

    function findCouponCardElement(code) {
      const c = String(code || '').toLowerCase();
      if (!c) return null;
      return document.querySelector('.coupon-card[data-coupon-code="' + c + '"]');
    }

    function showCouponApplyCelebration(code, discountData, savingsLine) {
      return openCouponSuccessPopup({
        source: 'carousel',
        code: code,
        savedText: formatCouponCelebrationSavings(discountData, savingsLine),
        discountData: discountData,
      });
    }

    function hideCouponApplyCelebration() {
      closeCouponSuccessPopup('carousel');
    }

    function getCarouselAppliedCodeForRender(storedAppliedCode) {
      if (isCouponCelebrationActive() || isManualCouponCelebrationActive()) return '';
      return storedAppliedCode || '';
    }

    function carouselHasCouponCards() {
      const parts = getAllCouponUiParts();
      return parts.length > 0 && parts.some(function (p) {
        return p.container && p.container.querySelector('.coupon-card') !== null;
      });
    }

    function refreshManualCouponCarouselUi(coupons, storeCarouselCoupons, appliedCouponCode) {
      const parts = getAllCouponUiParts();
      if (!parts.length) return false;

      const carouselCoupons = storeCarouselCoupons || [];
      const couponCount = carouselCoupons.length;
      const newCountText =
        'Available offer' + (couponCount > 1 ? 's' : '') + ' for you (' + couponCount + ')';

      parts.forEach(function (p) {
        if (p.countText && p.countText.textContent !== newCountText) {
          p.countText.textContent = newCountText;
        }
        if (p.container) p.container.setAttribute('aria-busy', 'false');
      });

      if (coupons && coupons.length) state.viewAllCoupons = coupons;
      state.viewAllAppliedCouponCode = appliedCouponCode || '';
      state.lastAppliedCode = appliedCouponCode || '';

      renderAvailableOffersWidget(
        coupons || state.viewAllCoupons || state.lastCouponList || [],
        carouselCoupons,
        appliedCouponCode
      );
      initManualCouponInput();
      restoreManualCouponInput();
      resumeManualCouponCelebrationAfterRender();
      ensureManualCouponInputCardInView('auto');
      return true;
    }

    function orderCarouselCouponsWithAppliedFirst(coupons, appliedCode) {
      if (!appliedCode || !coupons || !coupons.length) return coupons;
      const normalizedApplied = String(appliedCode).toLowerCase();
      let appliedIndex = -1;
      for (let i = 0; i < coupons.length; i++) {
        if (coupons[i] && String(coupons[i].code || '').toLowerCase() === normalizedApplied) {
          appliedIndex = i;
          break;
        }
      }
      if (appliedIndex <= 0) return coupons;
      const ordered = coupons.slice();
      ordered.unshift(ordered.splice(appliedIndex, 1)[0]);
      return ordered;
    }

    // Partnership coupon: single gate from theme settings + channel + optional CDP AB.
    function isPartnershipCouponActive() {
      if (
        window.MamaearthChannel &&
        typeof window.MamaearthChannel.isPartnershipCouponActive === 'function'
      ) {
        return window.MamaearthChannel.isPartnershipCouponActive();
      }
      return false;
    }

    function shouldShowPartnershipCouponTypeFirst() {
      return isPartnershipCouponActive();
    }

    function finalizeCouponApplyCelebration(opts) {
      const options = opts || {};
      const compositionChanged =
        options.compositionChanged === true || state.pendingApplyCompositionChanged === true;
      state.pendingApplyCompositionChanged = false;

      if (options.syncPopupInput !== false && options.fromPopupTray) {
        syncViewAllPopupInputState();
      }
      if (options.cardCode) {
        hidePopupCardCelebration(options.cardCode);
      }
      if (options.carouselCode) {
        hideCouponApplyCelebration(options.carouselCode);
      }

      window.couponCheckInProgress = false;
      state.couponCheckInProgress = false;

      const applied = getDiscountFromStorage()?.code?.toLowerCase() || '';
      state.lastAppliedCode = applied;
      state.lastRenderKey = '';

      if (compositionChanged) {
        if (typeof window.loadCoupons === 'function') {
          window.loadCoupons(true, state.lastCartData);
        }
      } else if (state.lastCouponList && state.lastCouponList.length) {
        const storeCarouselCoupons = state.lastCouponList.filter(function (coupon) {
          return String(coupon && coupon.offerType || '').toLowerCase() === 'store_offer';
        });
        renderCouponsList(state.lastCouponList, storeCarouselCoupons, applied);
      } else if (typeof window.loadCoupons === 'function') {
        window.loadCoupons(true, state.lastCartData);
      }

      if (options.refreshPopupBody) {
        refreshViewAllPopupBodyIfOpen();
      }
    }

    function scheduleCouponCelebrationEnd() {
      if (state.couponCelebrationTimer) {
        clearTimeout(state.couponCelebrationTimer);
        state.couponCelebrationTimer = null;
      }
      if (!state.couponCelebration) return;
      const remaining = Math.max(0, state.couponCelebration.until - Date.now());
      const code = state.couponCelebration.code;
      state.couponCelebrationTimer = setTimeout(async function () {
        const pendingCart = state.couponCelebrationPendingCart;
        state.couponCelebrationPendingCart = null;
        if (pendingCart) {
          try {
            await refreshCart(pendingCart);
          } catch (refreshErr) {
            console.error('Error refreshing cart after coupon celebration:', refreshErr);
          }
        }
        state.couponCelebration = null;
        state.couponCelebrationTimer = null;
        finalizeCouponApplyCelebration({ carouselCode: code });
      }, remaining);
    }

    function resumeCouponCelebrationAfterRender() {
      const cel = state.couponCelebration;
      if (!cel || Date.now() >= cel.until) return;
      const storedCode = getDiscountFromStorage()?.code?.toLowerCase() || '';
      if (!storedCode || storedCode !== String(cel.code || '').toLowerCase()) return;
      showCouponApplyCelebration(cel.code, cel.discountData, cel.savingsLine);
      scheduleCouponCelebrationEnd();
    }

    function isManualCouponCelebrationActive() {
      return !!(state.manualCouponCelebration && Date.now() < state.manualCouponCelebration.until);
    }

    function showManualCouponCelebration(code, discountData, savingsLine) {
      openCouponSuccessPopup({
        source: 'manual',
        code: code,
        savedText: formatCouponCelebrationSavings(discountData, savingsLine),
        discountData: discountData,
      });
    }

    function hideManualCouponCelebration() {
      closeCouponSuccessPopup('manual');
    }

    function scheduleManualCouponCelebrationEnd() {
      if (state.manualCouponCelebrationTimer) {
        clearTimeout(state.manualCouponCelebrationTimer);
        state.manualCouponCelebrationTimer = null;
      }
      if (!state.manualCouponCelebration) return;
      const remaining = Math.max(0, state.manualCouponCelebration.until - Date.now());
      state.manualCouponCelebrationTimer = setTimeout(function () {
        state.manualCouponCelebration = null;
        state.manualCouponCelebrationTimer = null;
        state.manualInputCardScrollLock = false;
        state.manualCouponCarouselRenderedFor = '';
        state.manualCouponCelebrationShown = false;
        hideManualCouponCelebration();
        window.couponCheckInProgress = false;
        state.couponCheckInProgress = false;
        if (typeof window.loadCoupons === 'function') window.loadCoupons(true);
      }, remaining);
    }

    function showManualCouponCelebrationOnce() {
      const cel = state.manualCouponCelebration;
      if (!cel || Date.now() >= cel.until) return false;
      if (state.manualCouponCelebrationShown) return false;
      const storedCode = getDiscountFromStorage()?.code?.toLowerCase() || '';
      if (!storedCode || storedCode !== String(cel.code || '').toLowerCase()) return false;
      if (!document.querySelector('.coupon-input-card')) return false;

      showManualCouponCelebration(cel.code, cel.discountData, cel.savingsLine);
      state.manualCouponCelebrationShown = true;
      if (!state.manualCouponCelebrationTimer) {
        scheduleManualCouponCelebrationEnd();
      }
      return true;
    }

    function finishManualCouponApplyPresentation() {
      initManualCouponInput();
      restoreManualCouponInput();
      showManualCouponCelebrationOnce();
      refreshAvailableOffersWidgetFromCache();
      ensureManualCouponInputCardInView('auto');
    }

    function resumeManualCouponCelebrationAfterRender() {
      if (!showManualCouponCelebrationOnce()) return;
      ensureManualCouponInputCardInView('auto');
    }

    function scrollManualCouponInputCardIntoView(scrollBehavior) {
      const behavior = scrollBehavior || 'auto';
      getCouponUiRoots().forEach(function (root) {
        const container = root.querySelector('[data-coupons-container]');
        const card = root.querySelector('.coupon-input-card');
        if (!container || !card) return;

        const maxScroll = Math.max(0, container.scrollWidth - container.clientWidth);
        const cardLeft = card.offsetLeft;
        const padding = 12;
        let target = cardLeft - padding;
        if (target > maxScroll) target = maxScroll;
        if (target < 0) target = 0;
        container.scrollTo({ left: target, behavior: behavior });
      });
    }

    function ensureManualCouponInputCardInView(scrollBehavior) {
      if (!state.manualInputCardScrollLock && !isManualCouponCelebrationActive()) return;
      requestAnimationFrame(function () {
        scrollManualCouponInputCardIntoView(scrollBehavior || 'auto');
      });
    }

    // --- View-all popup tray (Next.js OffersTray parity) ---

    function isViewAllPopupOpen() {
      const root = document.getElementById('coupon_view_all_root');
      if (!root || root.hidden) return false;
      const overlay = root.querySelector('.coupon-full-overlay');
      return !!(overlay && overlay.classList.contains('is-open'));
    }

    function getViewAllPopupElements() {
      const root = document.getElementById('coupon_view_all_root');
      if (!root) return null;
      return {
        root: root,
        input: root.querySelector('#viewall_coupon_code_input'),
        applyBtn: root.querySelector('#viewall_coupon_apply_btn'),
        inputWrap: root.querySelector('.coupon-full-input-wrap'),
        inputError: root.querySelector('[data-popup-input-error]'),
        body: root.querySelector('#coupon_full_body'),
      };
    }

    function syncViewAllPopupAppliedCode() {
      const stored = getDiscountFromStorage();
      state.viewAllAppliedCouponCode = stored && stored.code ? String(stored.code).toLowerCase() : '';
    }

    function clearPopupInputError() {
      state.popupInputError = '';
      const els = getViewAllPopupElements();
      if (!els || !els.inputError) return;
      els.inputError.hidden = true;
      els.inputError.innerHTML = '';
    }

    function setPopupInputError(message) {
      if (!message) return;
      state.popupInputError = String(message);
      state.popupApplySource = 'text';
      const els = getViewAllPopupElements();
      if (!els || !els.inputError) return;
      els.inputError.hidden = false;
      els.inputError.textContent = message;
    }

    function isPopupInputCelebrationActive() {
      return !!(state.popupInputCelebration && Date.now() < state.popupInputCelebration.until);
    }

    function isPopupCardCelebrationActive() {
      return !!(state.popupCardCelebration && Date.now() < state.popupCardCelebration.until);
    }

    function hidePopupInputCelebration() {
      closeCouponSuccessPopup('popup-input');
    }

    function showPopupInputCelebration(code, discountData, savingsLine) {
      return openCouponSuccessPopup({
        source: 'popup-input',
        code: code,
        savedText: formatCouponCelebrationSavings(discountData, savingsLine),
        discountData: discountData,
      });
    }

    function renderOutsideCouponsFromCache(appliedCouponCode) {
      if (!state.lastCouponList || !state.lastCouponList.length) return false;
      const applied = appliedCouponCode != null
        ? String(appliedCouponCode).toLowerCase()
        : (getDiscountFromStorage()?.code?.toLowerCase() || '');
      state.lastAppliedCode = applied;
      state.lastRenderKey = '';
      const storeCarouselCoupons = state.lastCouponList.filter(function (coupon) {
        return String(coupon && coupon.offerType || '').toLowerCase() === 'store_offer';
      });
      return renderCouponsList(state.lastCouponList, storeCarouselCoupons, applied);
    }

    // Covers the short gap where loadCoupons runs before a re-rendered drawer's
    // [data-copy-code-root] is in the DOM. Bounded: copyCode.liquid only renders
    // the root when the cart has items, so with an empty cart the root never
    // appears and an unbounded retry polled every 150ms forever (and its stray
    // calls queued extra /coupons/list fetches via pendingReload on first add).
    // Once the drawer does render, cart:change / cart:drawer:render reload it.
    const OUTSIDE_COUPONS_RETRY_MAX = 8;

    function scheduleOutsideCouponsLoadRetry(delayMs, cartHint) {
      const knownCart = state.lastCartData || cartHint;
      if (knownCart && (Number(knownCart.item_count) || 0) === 0) {
        state.outsideRetryCount = 0;
        return;
      }
      if (state.outsideRetryTimer) return;
      if ((state.outsideRetryCount || 0) >= OUTSIDE_COUPONS_RETRY_MAX) return;
      state.outsideRetryCount = (state.outsideRetryCount || 0) + 1;
      state.outsideRetryTimer = setTimeout(function () {
        state.outsideRetryTimer = null;
        if (typeof window.loadCoupons === 'function') {
          window.loadCoupons(true, cartHint || state.lastCartData);
        }
      }, delayMs || 150);
    }

    // After popup input/card celebration ends (or is closed early), match the
    // in-carousel celebration end: re-render from cache unless line items changed.
    function finalizePopupTrayApplyWindow(opts) {
      const options = opts || {};
      finalizeCouponApplyCelebration({
        fromPopupTray: true,
        syncPopupInput: options.syncPopupInput,
        refreshPopupBody: options.refreshPopupBody,
        cardCode: options.cardCode,
        compositionChanged: options.compositionChanged,
      });
    }

    function schedulePopupInputCelebrationEnd() {
      if (state.popupInputCelebrationTimer) {
        clearTimeout(state.popupInputCelebrationTimer);
        state.popupInputCelebrationTimer = null;
      }
      if (!state.popupInputCelebration) return;
      const remaining = Math.max(0, state.popupInputCelebration.until - Date.now());
      state.popupInputCelebrationTimer = setTimeout(function () {
        state.popupInputCelebration = null;
        state.popupInputCelebrationTimer = null;
        hidePopupInputCelebration();
        finalizePopupTrayApplyWindow();
        closeCouponViewAllSheet();
      }, remaining);
    }

    function hidePopupCardCelebration() {
      closeCouponSuccessPopup('popup-card');
    }

    function showPopupCardCelebration(code, savingsLine) {
      return openCouponSuccessPopup({
        source: 'popup-card',
        code: code,
        savedText: formatCouponCelebrationSavings(null, savingsLine),
      });
    }

    function schedulePopupCardCelebrationEnd() {
      if (state.popupCardCelebrationTimer) {
        clearTimeout(state.popupCardCelebrationTimer);
        state.popupCardCelebrationTimer = null;
      }
      if (!state.popupCardCelebration) return;
      const remaining = Math.max(0, state.popupCardCelebration.until - Date.now());
      const code = state.popupCardCelebration.code;
      state.popupCardCelebrationTimer = setTimeout(function () {
        state.popupCardCelebration = null;
        state.popupCardCelebrationTimer = null;
        finalizePopupTrayApplyWindow({ syncPopupInput: false, refreshPopupBody: true, cardCode: code });
        closeCouponViewAllSheet();
      }, remaining);
    }

    function clearPopupTrayCelebrations() {
      const hadPendingPopupApply =
        isPopupInputCelebrationActive() ||
        isPopupCardCelebrationActive() ||
        !!(state.popupInputCelebrationTimer || state.popupCardCelebrationTimer);
      if (state.popupInputCelebrationTimer) {
        clearTimeout(state.popupInputCelebrationTimer);
        state.popupInputCelebrationTimer = null;
      }
      if (state.popupCardCelebrationTimer) {
        clearTimeout(state.popupCardCelebrationTimer);
        state.popupCardCelebrationTimer = null;
      }
      if (state.popupInputCelebration) {
        hidePopupInputCelebration();
        state.popupInputCelebration = null;
      }
      if (state.popupCardCelebration) {
        hidePopupCardCelebration(state.popupCardCelebration.code);
        state.popupCardCelebration = null;
      }
      if (hadPendingPopupApply) {
        finalizePopupTrayApplyWindow({ syncPopupInput: false });
      }
    }

    function resumePopupTrayCelebrationsAfterRender() {
      const storedCode = getDiscountFromStorage()?.code?.toLowerCase() || '';
      const inputCel = state.popupInputCelebration;
      if (
        inputCel &&
        Date.now() < inputCel.until &&
        storedCode &&
        storedCode === String(inputCel.code || '').toLowerCase()
      ) {
        showPopupInputCelebration(inputCel.code, inputCel.discountData, inputCel.savingsLine);
        schedulePopupInputCelebrationEnd();
      }
      const cardCel = state.popupCardCelebration;
      if (
        cardCel &&
        Date.now() < cardCel.until &&
        storedCode &&
        storedCode === String(cardCel.code || '').toLowerCase()
      ) {
        showPopupCardCelebration(cardCel.code, cardCel.savingsLine);
        schedulePopupCardCelebrationEnd();
      }
    }

    function syncViewAllPopupInputState() {
      const els = getViewAllPopupElements();
      if (!els || !els.input || !els.applyBtn) return;
      const stored = getDiscountFromStorage();
      const applied = stored && stored.code ? String(stored.code).toLowerCase() : '';
      const hasInputError = !!(state.popupInputError && state.popupApplySource === 'text');

      if (applied && !hasInputError) {
        els.input.value = applied.toUpperCase();
        els.input.disabled = true;
        els.applyBtn.textContent = 'Remove';
        els.applyBtn.classList.remove('is-disabled');
        els.applyBtn.style.pointerEvents = 'auto';
      } else if (!isPopupInputCelebrationActive()) {
        els.input.disabled = false;
        els.applyBtn.textContent = 'Apply';
        const empty = !String(els.input.value || '').trim();
        els.applyBtn.classList.toggle('is-disabled', empty);
        els.applyBtn.style.pointerEvents = empty ? 'none' : 'auto';
      }
    }

    function buildViewAllPopupBodyHtml() {
      const coupons = Array.isArray(state.viewAllCoupons) ? state.viewAllCoupons : [];
      const appliedCouponCode = String(
        state.viewAllAppliedCouponCode || (getDiscountFromStorage() && getDiscountFromStorage().code) || ''
      ).toLowerCase();

      const paymentCoupons = [];
      const storeCoupons = [];
      coupons.forEach(function (coupon) {
        const offerType = String(coupon.offerType || '').toLowerCase();
        if (offerType === 'payment_offer') paymentCoupons.push(coupon);
        else storeCoupons.push(coupon);
      });

      const bestCoupons = [];
      const otherCoupons = [];
      storeCoupons.forEach(function (coupon) {
        if (bestCoupons.length === 0 && coupon.isApplicable !== false) bestCoupons.push(coupon);
        else otherCoupons.push(coupon);
      });

      let html = '';
      html += renderCouponSection('Best offer', bestCoupons, appliedCouponCode);
      html += renderCouponSection('Other offers', otherCoupons, appliedCouponCode);
      html += renderCouponSection('Payment offers', paymentCoupons, appliedCouponCode);
      if (!html) html = '<div class="coupon-full-empty">No offers available right now.</div>';
      return html;
    }

    function refreshViewAllPopupBodyIfOpen() {
      const els = getViewAllPopupElements();
      if (!els || !els.body || !isViewAllPopupOpen()) return;
      syncViewAllPopupAppliedCode();
      els.body.innerHTML = buildViewAllPopupBodyHtml();
      resumePopupTrayCelebrationsAfterRender();
    }

    function buildCouponCardFooterHTML(couponCode, isApplicable, isApplied) {
      const upper = escapeHtml(String(couponCode || '').toUpperCase());
      const safeCode = escapeHtml(couponCode);
      const safeJS = escapeJS(couponCode);

      if (isApplied) {
        return (
          '<div class="coupon-code-status">' +
          '<span class="cpnCode">' +
          upper +
          '</span><span class="coupon-applied-status">' +
          '<img class="coupon-applied-status__icon" src="' +
          COUPON_TICK_ICON_URL +
          '" width="12" height="12" alt="" aria-hidden="true">' +
          'Applied</span></div>' +
          '<span class="cpnBtn cpnBtn-remove" onclick="window.removeCouponFn(\'' +
          safeJS +
          '\', this)" data-code="' +
          safeCode +
          '">Remove</span>'
        );
      }
      if (!isApplicable) {
        return (
          '<span class="cpnCode">' +
          upper +
          '</span><span class="cpnBtn cpnBtn-disabled">Apply</span>'
        );
      }
      return (
        '<span class="cpnCode">' +
        upper +
        '</span><span class="cpnBtn" onclick="window.applyCouponFn(\'' +
        safeJS +
        '\', this)" data-code="' +
        safeCode +
        '">Apply</span>'
      );
    }

    /** Bullet lines from API `additionalDetails` (popup list only). */
    function getCouponAdditionalDetailsBullets(coupon) {
      const raw = coupon.additionalDetails || coupon.additional_details;
      if (!Array.isArray(raw)) return [];
      return raw
        .map(function (item) {
          return String(item || '').trim();
        })
        .filter(Boolean);
    }

    /** Offer sheet description: first `additionalDetails` line. */
    function getCouponSheetDescription(coupon) {
      const bullets = getCouponAdditionalDetailsBullets(coupon);
      return bullets.length ? bullets[0] : '';
    }

    /** Round messy API currency amounts inside coupon `message` text. */
    function formatCouponMessageCurrency(text) {
      const s = String(text || '').trim();
      if (!s) return '';
      return s.replace(/(?:₹|\u20B9)\s*([\d,]+(?:\.\d+)?)/gi, function (match, num) {
        const n = parseFloat(String(num).replace(/,/g, ''));
        if (!isFinite(n)) return match;
        return '₹' + Math.round(n).toLocaleString('en-IN');
      });
    }

    /** Offer sheet action row: API `message` (save line or eligibility hint). */
    function getCouponSheetActionMessage(coupon) {
      const raw = String(coupon.message || coupon.applyMessage || '').trim();
      return formatCouponMessageCurrency(raw);
    }

    function renderCouponFullItemBulletsHtml(bullets) {
      if (!bullets || !bullets.length) return '';
      let html = '<ul class="coupon-full-item__bullets">';
      bullets.forEach(function (line) {
        html += '<li>' + escapeHtml(line) + '</li>';
      });
      html += '</ul>';
      return html;
    }

    /** Split API message into bullet lines for the applied-offer card. */
    function splitCouponMessageToBullets(message) {
      const s = String(message || '').trim();
      if (!s) return [];
      const byNl = s.split(/\r?\n/).map(function (x) {
        return x.replace(/^\s*[•\-\*]\s*/, '').trim();
      }).filter(Boolean);
      if (byNl.length > 1) return byNl;
      const one = byNl[0] || s;
      if (one.indexOf('•') !== -1) {
        return one
          .split('•')
          .map(function (x) {
            return x.trim();
          })
          .filter(Boolean);
      }
      return [one];
    }

    /** Green footer line: prefer “Save ₹… with this code” (reference UI). */
    function formatAppliedFooterSaveLine(savingsLine) {
      let s = String(savingsLine || '').trim().replace(/^\s*[•\-\*]\s*/, '');
      if (!s) return '';
      s = s.replace(/\bwith this offer\b/gi, 'with this code').replace(/\bthis offer\b/gi, 'this code');
      if (!/^save\b/i.test(s)) {
        s = 'Save ' + s.replace(/^save\s+/i, '');
      }
      return s;
    }

    function getCouponDetailsUrl(coupon) {
      const fromApi =
        coupon.detailsUrl ||
        coupon.details_url ||
        coupon.termsUrl ||
        coupon.terms_url ||
        coupon.tncUrl ||
        coupon.tnc_url ||
        coupon.viewDetailsUrl ||
        coupon.view_details_url ||
        '';
      const apiTrim = String(fromApi || '').trim();
      if (apiTrim) return couponSanitizeUrl(apiTrim);
      const fb = (window.__copyCodeCouponUi && window.__copyCodeCouponUi.viewDetailsFallbackUrl) || '';
      return couponSanitizeUrl(fb);
    }

    function getCouponDetailsText(coupon) {
      const raw =
        coupon.details ||
        coupon.terms ||
        coupon.longDescription ||
        coupon.long_description ||
        coupon.tncText ||
        coupon.tnc_text ||
        coupon.offerDetails ||
        coupon.offer_details ||
        '';
      return String(raw || '').trim();
    }

    function getCouponEligibilityHint(coupon) {
      const raw =
        coupon.eligibilityMessage ||
        coupon.eligibility_message ||
        coupon.nonApplicableReason ||
        coupon.non_applicable_reason ||
        coupon.hint ||
        coupon.howToApply ||
        coupon.how_to_apply ||
        coupon.cartHint ||
        coupon.cart_hint ||
        '';
      const t = String(raw || '').trim();
      if (t) return t;
      const msg = String(coupon.message || '').trim();
      if (msg) return msg;
      return 'Add eligible items to your cart to use this offer.';
    }

    function mountCouponSheetToBody(root) {
      // Keep sheets on document.body so position:fixed covers the cart drawer
      // header. Mounting inside #CartDrawer puts them under part="body", whose
      // contain:layout makes fixed overlays stop below "Your cart".
      // Always re-append so DOM order beats the cart drawer when both clamp to
      // the same max z-index (2147483647).
      if (root) {
        document.body.appendChild(root);
      }
      return root;
    }

    function isCouponSheetEventTarget(target) {
      if (!target || typeof target.closest !== 'function') return false;
      return !!(
        target.closest('#coupon_view_all_root') ||
        target.closest('#coupon_offer_sheet_root') ||
        target.closest('#coupon_success_popup_root')
      );
    }

    // Cart drawer FocusTrap treats body-mounted sheets as outside clicks and
    // calls closeDialog() — which also eats the first tap on Back. Same pattern
    // as the price-summary sheet patch in cart-drawer.liquid.
    function patchCartDrawerForCouponSheets() {
      const drawer = document.getElementById('CartDrawer');
      if (!drawer || drawer.__couponSheetsPatched) return;
      drawer.__couponSheetsPatched = true;

      const originalHide = drawer.hideForOutsideClickTarget
        ? drawer.hideForOutsideClickTarget.bind(drawer)
        : function (target) {
            return !drawer.contains(target);
          };
      const originalAllow = drawer.allowOutsideClickForTarget
        ? drawer.allowOutsideClickForTarget.bind(drawer)
        : function () {
            return false;
          };

      drawer.hideForOutsideClickTarget = function (target) {
        if (isCouponSheetEventTarget(target)) return false;
        return originalHide(target);
      };
      drawer.allowOutsideClickForTarget = function (target) {
        if (isCouponSheetEventTarget(target)) return true;
        return originalAllow(target);
      };
    }

    // Body-mounted coupon sheets sit outside FocusTrap containers
    // ([CartDrawer, shadowRoot]). Without adding them, focusin steals focus
    // from #viewall_coupon_code_input back into the drawer.
    function syncCartDrawerFocusTrapForCouponSheets() {
      const drawer = document.getElementById('CartDrawer');
      if (!drawer) return;
      const trap = drawer.focusTrap;
      if (!trap || typeof trap.updateContainerElements !== 'function') return;

      const containers = [drawer];
      if (drawer.shadowRoot) containers.push(drawer.shadowRoot);

      const viewAll = document.getElementById('coupon_view_all_root');
      if (viewAll && !viewAll.hidden) containers.push(viewAll);

      const offerSheet = document.getElementById('coupon_offer_sheet_root');
      if (offerSheet && !offerSheet.hidden) containers.push(offerSheet);

      const successPopup = document.getElementById('coupon_success_popup_root');
      if (successPopup && !successPopup.hidden) containers.push(successPopup);

      trap.updateContainerElements(containers);
    }

    function bindCouponSheetPointerGuards(root) {
      if (!root || root.dataset.pointerGuardsBound === 'true') return;
      root.dataset.pointerGuardsBound = 'true';
      // Bubble phase only — capture+stop would block child handlers (e.g. Back).
      ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(function (evt) {
        root.addEventListener(
          evt,
          function (e) {
            e.stopPropagation();
          },
          { passive: true }
        );
      });
    }

    function isCouponViewAllSheetOpen() {
      const root = document.getElementById('coupon_view_all_root');
      if (!root || root.hidden) return false;
      const overlay = root.querySelector('.coupon-full-overlay');
      return !!(overlay && overlay.classList.contains('is-open'));
    }

    function ensureCouponOfferSheet() {
      patchCartDrawerForCouponSheets();
      let root = document.getElementById('coupon_offer_sheet_root');
      if (root) {
        bindCouponSheetPointerGuards(root);
        return mountCouponSheetToBody(root);
      }

      root = document.createElement('div');
      root.id = 'coupon_offer_sheet_root';
      root.hidden = true;
      root.innerHTML =
        '<div class="coupon-offer-sheet-overlay" aria-hidden="true" role="presentation">' +
        '<div class="coupon-offer-sheet-backdrop" tabindex="-1"></div>' +
        '<div class="coupon-offer-sheet-float">' +
        '<div class="coupon-offer-sheet-stack">' +
        '<button type="button" class="coupon-offer-sheet-close" aria-label="Close">' +
        '<span class="coupon-offer-sheet-close-icon" aria-hidden="true">&times;</span></button>' +
        '<div class="coupon-offer-sheet" role="dialog" aria-modal="true" aria-labelledby="coupon_offer_sheet_title">' +
        '<div class="coupon-offer-sheet-inner">' +
        '<h2 id="coupon_offer_sheet_title" class="coupon-offer-sheet-h2">Offer Details</h2>' +
        '<h3 class="coupon-offer-sheet-offer-title" data-sheet-offer-title></h3>' +
        '<p class="coupon-offer-sheet-desc" data-sheet-desc></p>' +
        '<div class="coupon-offer-sheet-code" data-sheet-code-display></div>' +
        '<a class="coupon-offer-sheet-external" data-sheet-external href="#" target="_blank" rel="noopener noreferrer" hidden>Full terms</a>' +
        '<hr class="coupon-offer-sheet-rule" aria-hidden="true">' +
        '<div class="coupon-offer-sheet-action">' +
        '<p class="coupon-offer-sheet-hint" data-sheet-hint></p>' +
        '<button type="button" class="coupon-offer-sheet-apply" data-sheet-apply></button>' +
        '</div>' +
        '<hr class="coupon-offer-sheet-rule" aria-hidden="true">' +
        '<ul class="coupon-offer-sheet-foot">' +
        '<li><span class="coupon-offer-sheet-check" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.5 4.5L6.5 11.5L2.5 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>Other T&amp;C may apply</li>' +
        '<li><span class="coupon-offer-sheet-check" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.5 4.5L6.5 11.5L2.5 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>This Offer is personalised for you</li>' +
        '</ul>' +
        '</div></div></div></div></div>';

      mountCouponSheetToBody(root);
      bindCouponSheetPointerGuards(root);

      const overlay = root.querySelector('.coupon-offer-sheet-overlay');
      const backdrop = root.querySelector('.coupon-offer-sheet-backdrop');
      const closeBtn = root.querySelector('.coupon-offer-sheet-close');

      overlay.addEventListener('click', function (e) {
        if (e.target === backdrop) {
          closeCouponOfferSheet();
        }
      });
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeCouponOfferSheet();
      });

      root.addEventListener('click', function (e) {
        const applyEl = e.target.closest('.coupon-offer-sheet-apply');
        if (!applyEl) return;
        e.preventDefault();
        if (applyEl.disabled || applyEl.classList.contains('is-muted')) return;
        const codeRaw = applyEl.getAttribute('data-sheet-code');
        if (!codeRaw) return;
        const codeLower = codeRaw.toLowerCase();
        const cardSel = '.coupon-card[data-coupon-code="' + codeLower + '"]';

        if (applyEl.classList.contains('is-remove')) {
          const rb = document.querySelector(cardSel + ' .cpnBtn-remove');
          window.removeCouponFn(codeRaw, rb || null);
        } else {
          const ab = document.querySelector(cardSel + ' .cpnBtn:not(.cpnBtn-disabled):not(.cpnBtn-remove)');
          if (ab) window.applyCouponFn(codeRaw, ab);
          else window.applyCouponFn(codeRaw, applyEl);
        }
        closeCouponOfferSheet();
      });

      return root;
    }

    function closeCouponOfferSheet() {
      const root = document.getElementById('coupon_offer_sheet_root');
      if (!root) return;
      const overlay = root.querySelector('.coupon-offer-sheet-overlay');
      if (!overlay || !overlay.classList.contains('is-open')) return;

      overlay.classList.remove('is-open');
      document.body.style.overflow = '';

      const float = root.querySelector('.coupon-offer-sheet-float');
      let finished = false;
      function finishClose(ev) {
        if (ev && ev.propertyName && ev.propertyName !== 'transform') return;
        if (finished) return;
        finished = true;
        float.removeEventListener('transitionend', onTe);
        if (!overlay.classList.contains('is-open')) {
          overlay.setAttribute('aria-hidden', 'true');
          overlay.style.display = 'none';
          root.hidden = true;
          syncCartDrawerFocusTrapForCouponSheets();
        }
      }
      function onTe(ev) {
        finishClose(ev);
      }
      float.addEventListener('transitionend', onTe);
      window.setTimeout(finishClose, 400);
    }

    function openCouponOfferSheet(card) {
      if (!card) return;
      const codeAttr = card.getAttribute('data-coupon-code');
      if (!codeAttr) return;

      const payload = Object.assign({}, state.couponSheetData[codeAttr] || {});
      const listCoupon = (state.lastCouponList || []).find(function (c) {
        return String(c.code || '').toLowerCase() === codeAttr;
      });
      if (listCoupon) {
        payload.title = payload.title || listCoupon.title || '';
        payload.description = payload.description || getCouponSheetDescription(listCoupon);
        payload.actionMessage = payload.actionMessage || getCouponSheetActionMessage(listCoupon);
        payload.code = payload.code || listCoupon.code || '';
        if (payload.isApplicable == null) payload.isApplicable = listCoupon.isApplicable !== false;
      }
      payload.isApplicable = !card.classList.contains('coupon-not-applicable');
      payload.isApplied = !!card.querySelector('.cpnBtn-remove');

      const root = ensureCouponOfferSheet();
      const overlay = root.querySelector('.coupon-offer-sheet-overlay');
      const inner = root.querySelector('.coupon-offer-sheet-inner');

      const elOfferTitle = root.querySelector('[data-sheet-offer-title]');
      const elDesc = root.querySelector('[data-sheet-desc]');
      const elExternal = root.querySelector('[data-sheet-external]');
      const elCode = root.querySelector('[data-sheet-code-display]');
      const elHint = root.querySelector('[data-sheet-hint]');
      const elApply = root.querySelector('[data-sheet-apply]');

      const offerTitleText = payload.title || '';
      elOfferTitle.textContent = offerTitleText;
      elOfferTitle.style.display = offerTitleText ? '' : 'none';

      const descText = String(payload.description || '').trim();
      elDesc.textContent = descText;
      elDesc.style.display = descText ? '' : 'none';

      const dUrl = couponSanitizeUrl(payload.detailsUrl || '');
      if (dUrl) {
        elExternal.setAttribute('href', dUrl);
        elExternal.hidden = false;
      } else {
        elExternal.hidden = true;
        elExternal.removeAttribute('href');
      }

      elCode.textContent = (payload.code || '').toString().toUpperCase();

      const actionMessage = String(payload.actionMessage || payload.message || '').trim();
      const isSaveAction = payload.isApplicable && isCouponSaveLine(actionMessage);
      elHint.classList.remove('coupon-offer-sheet-hint--savings', 'coupon-offer-sheet-hint--muted');
      if (actionMessage) {
        elHint.innerHTML = isSaveAction
          ? formatCouponSavingsLineHtml(actionMessage)
          : escapeHtml(actionMessage);
        elHint.hidden = false;
        if (isSaveAction) elHint.classList.add('coupon-offer-sheet-hint--savings');
        else if (!payload.isApplicable) elHint.classList.add('coupon-offer-sheet-hint--muted');
      } else {
        elHint.textContent = '';
        elHint.hidden = true;
      }

      inner.classList.toggle('coupon-offer-sheet-inner--inactive', !payload.isApplicable);

      elApply.setAttribute('data-sheet-code', payload.code || codeAttr);
      elApply.classList.remove('is-remove', 'is-muted', 'is-active');
      elApply.disabled = false;

      if (!payload.isApplicable) {
        elApply.textContent = 'Apply';
        elApply.classList.add('is-muted');
        elApply.disabled = true;
      } else if (payload.isApplied) {
        elApply.textContent = 'Remove';
        elApply.classList.add('is-remove');
      } else {
        elApply.textContent = 'Apply';
        elApply.classList.add('is-active');
      }

      root.hidden = false;
      overlay.style.display = 'flex';
      overlay.setAttribute('aria-hidden', 'false');
      syncCartDrawerFocusTrapForCouponSheets();

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          overlay.classList.add('is-open');
        });
      });
      document.body.style.overflow = 'hidden';
    }

    function onCouponSheetEscape(e) {
      if (e.key !== 'Escape') return;
      const root = document.getElementById('coupon_offer_sheet_root');
      if (!root) return;
      const overlay = root.querySelector('.coupon-offer-sheet-overlay');
      if (overlay && overlay.classList.contains('is-open')) {
        closeCouponOfferSheet();
      }
    }

    function attachCouponSheetUiOnce() {
      if (state.couponSheetUiAttached) return;
      state.couponSheetUiAttached = true;
      document.addEventListener('click', function (e) {
        const trigger = e.target.closest('.coupon-view-details');
        if (!trigger) return;
        const card = trigger.closest('.coupon-card');
        if (!card) return;
        e.preventDefault();
        openCouponOfferSheet(card);
      });
      document.addEventListener('keydown', onCouponSheetEscape);
    }

    function getCouponCategory(coupon) {
      const raw =
        coupon.category ||
        coupon.offerCategory ||
        coupon.offer_category ||
        coupon.group ||
        coupon.groupName ||
        '';
      return String(raw || '').trim().toLowerCase();
    }

    function couponButtonHTML(coupon, isApplied) {
      const couponCode = String(coupon.code || '');
      const safeCode = escapeHtml(couponCode);
      const safeJSCode = escapeJS(couponCode);
      const isApplicable = coupon.isApplicable !== false;
      if (isApplied) {
        return (
          '<span class="cpnBtn cpnBtn-remove" onclick="window.removeCouponFn(\'' +
          safeJSCode +
          '\', this)" data-code="' +
          safeCode +
          '">Remove</span>'
        );
      }
      if (!isApplicable) {
        return '<span class="cpnBtn cpnBtn-disabled">Apply</span>';
      }
      return (
        '<span class="cpnBtn" onclick="window.applyCouponFn(\'' +
        safeJSCode +
        '\', this)" data-code="' +
        safeCode +
        '">Apply</span>'
      );
    }

    function getPopupCouponCardError(couponCode) {
      if (
        state.popupCardError &&
        state.popupApplySource === 'card' &&
        String(state.popupCardError.code || '').toLowerCase() === String(couponCode || '').toLowerCase()
      ) {
        return String(state.popupCardError.message || '');
      }
      return '';
    }

    function buildCouponListItem(coupon, appliedCouponCode) {
      const couponCode = String(coupon.code || '');
      const couponTitle = String(coupon.title || '');
      const isApplicable = coupon.isApplicable !== false;
      const isApplied = appliedCouponCode && couponCode.toLowerCase() === appliedCouponCode;
      const savingsLine = resolveCouponSavingsLine(coupon);
      const couponMessage = resolveCouponDisplayMessage(coupon, savingsLine);
      const actionLine = isApplicable ? savingsLine : getCouponEligibilityHint(coupon);
      const cardError = getPopupCouponCardError(couponCode);
      const codeAttr = ' data-coupon-code="' + escapeHtml(couponCode.toLowerCase()) + '"';

      if (isApplied) {
        let bullets = getCouponAdditionalDetailsBullets(coupon);
        if (!bullets.length) bullets = splitCouponMessageToBullets(couponMessage);
        const footerSave = formatAppliedFooterSaveLine(savingsLine);
        const checkSvg =
          '<svg class="coupon-full-item__check" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
          '<circle cx="7.59961" cy="8" r="6" fill="#64BA47" stroke="#64BA47" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '<path d="M4.7998 7.9999L6.3998 9.5999L9.5998 6.3999" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>';
        let html =
          '<div class="coupon-full-item coupon-full-item--applied"' +
          codeAttr +
          '>';
        html += '<div class="coupon-full-item__head">';
        html += '<div class="coupon-full-item__head-text">';
        html += '<div class="coupon-full-item__title">' + escapeHtml(couponTitle) + '</div>';
        if (savingsLine) {
          html += '<div class="coupon-full-item__save-text">' + formatCouponSavingsLineHtml(savingsLine) + '</div>';
        }
        html += '</div></div>';
        html += renderCouponFullItemBulletsHtml(bullets);
        html += '<div class="coupon-full-item__applied-strip">';
        html += '<span class="coupon-full-item__applied-code">' + escapeHtml(couponCode.toUpperCase()) + '</span>';
        html += '<span class="coupon-full-item__applied-status">' + checkSvg + 'Applied</span>';
        html += '</div>';
        html += '<div class="coupon-full-item__footer">';
        if (footerSave) {
          html += '<div class="coupon-full-item__footer-save">' + formatCouponSavingsLineHtml(footerSave) + '</div>';
        } else {
          html += '<div class="coupon-full-item__footer-fill"></div>';
        }
        html += couponButtonHTML(coupon, isApplied);
        html += '</div>';
        if (cardError) {
          html += '<div class="coupon-full-item__error">' + escapeHtml(cardError) + '</div>';
        }
        html += '</div>';
        return html;
      }

      const bullets = getCouponAdditionalDetailsBullets(coupon);
      let html =
        '<div class="coupon-full-item' + (!isApplicable ? ' coupon-not-applicable' : '') + '"' + codeAttr + '>' +
        '<div class="coupon-full-item__title">' + escapeHtml(couponTitle) + '</div>';
      if (bullets.length) {
        html += renderCouponFullItemBulletsHtml(bullets);
      } else if (couponMessage) {
        html += '<div class="coupon-full-item__msg">• ' + escapeHtml(couponMessage) + '</div>';
      }
      html +=
        '<div class="coupon-full-item__code-row">' +
        '<span class="coupon-full-item__code">' + escapeHtml(couponCode.toUpperCase()) + '</span>' +
        '</div>';
      html += '<div class="coupon-full-item__action-row">';
      html += '<div class="coupon-full-item__save' + (isApplicable ? '' : ' is-muted') + '">' + (isApplicable && savingsLine ? formatCouponSavingsLineHtml(actionLine) : escapeHtml(actionLine || '')) + '</div>';
      html += couponButtonHTML(coupon, isApplied);
      html += '</div>';
      if (cardError) {
        html += '<div class="coupon-full-item__error">' + escapeHtml(cardError) + '</div>';
      }
      html += '</div>';
      return html;
    }

    function renderCouponSection(title, coupons, appliedCouponCode) {
      if (!coupons || !coupons.length) return '';
      let html = '<div class="coupon-full-section">';
      if (title) html += '<div class="coupon-full-section__title">' + escapeHtml(title) + '</div>';
      coupons.forEach(function (coupon) {
        html += buildCouponListItem(coupon, appliedCouponCode);
      });
      html += '</div>';
      return html;
    }

    function findCouponByCode(coupons, code) {
      const normalized = String(code || '').toLowerCase();
      if (!normalized || !coupons || !coupons.length) return null;
      return (
        coupons.find(function (c) {
          return c && String(c.code || '').toLowerCase() === normalized;
        }) || null
      );
    }

    function buildAppliedCouponWidgetOffer(appliedCouponCode) {
      const code = String(appliedCouponCode || '').trim();
      if (!code) return null;

      const stored = getDiscountFromStorage();
      const celebration = state.manualCouponCelebration;
      const source =
        (stored && stored.data) ||
        (celebration && celebration.discountData) ||
        {};

      const title = String(
        source.title ||
          source.message ||
          source.discount_title ||
          source.description ||
          (celebration && celebration.savingsLine) ||
          ''
      ).trim();

      return {
        code: code,
        title: title,
        isApplicable: true,
      };
    }

    function resolveAvailableOffersWidgetOffer(allCoupons, storeCoupons, appliedCouponCode) {
      const safeAppliedCode = String(appliedCouponCode || '').toLowerCase();
      const allStoreCoupons = storeCoupons || [];
      const applicableStoreCoupons = allStoreCoupons.filter(function (c) {
        return c && c.isApplicable !== false;
      });

      let bestOffer = null;
      if (safeAppliedCode) {
        bestOffer =
          findCouponByCode(storeCoupons, safeAppliedCode) ||
          findCouponByCode(allCoupons, safeAppliedCode) ||
          buildAppliedCouponWidgetOffer(appliedCouponCode);
      }
      if (!bestOffer) {
        bestOffer = applicableStoreCoupons[0] || null;
      }

      return {
        bestOffer: bestOffer,
        applicableCount: applicableStoreCoupons.length,
        totalStoreCouponCount: allStoreCoupons.length,
      };
    }

    function refreshAvailableOffersWidgetFromCache(appliedCouponCode) {
      const applied =
        appliedCouponCode != null
          ? String(appliedCouponCode).toLowerCase()
          : getDiscountFromStorage()?.code?.toLowerCase() || '';
      const storeCarouselCoupons = (state.lastCouponList || []).filter(function (coupon) {
        return String(coupon && coupon.offerType || '').toLowerCase() === 'store_offer';
      });
      renderAvailableOffersWidget(state.lastCouponList || [], storeCarouselCoupons, applied);
    }

    // Render the "Available offers (N)" widget that sits below the cart items.
    // The header is always shown; the body (offer row + Apply/Remove) is hidden
    // when there is no applied coupon and no applicable store offer.
    // The heading count reflects TOTAL store offers.
    // Also surfaces manually applied coupons that are not in the store-offer list.
    // Partnership mode inserts a coupon input between header and body (Figma).
    function renderAvailableOffersWidget(allCoupons, storeCoupons, appliedCouponCode) {
      const widget = document.getElementById('available_offers_widget');
      if (!widget) return;

      const partnershipActive = isPartnershipCouponActive();
      const safeAppliedCode = String(appliedCouponCode || '').toLowerCase();
      const resolved = resolveAvailableOffersWidgetOffer(allCoupons, storeCoupons, appliedCouponCode);
      const bestOffer = resolved.bestOffer;
      const applicableCount = resolved.applicableCount;
      const totalStoreCouponCount = resolved.totalStoreCouponCount;

      let displayOfferCount = totalStoreCouponCount;
      let bodyHTML = '';
      let widgetRenderKey = '';

      if (bestOffer) {
        const code = String(bestOffer.code || '');
        const title = String(bestOffer.title || '');
        const safeCode = escapeHtml(code);
        const safeJSCode = escapeJS(code);
        const safeTitle = escapeHtml(title);
        const isApplied = !!safeAppliedCode && code.toLowerCase() === safeAppliedCode;
        const appliedInStoreList = !!(safeAppliedCode && findCouponByCode(storeCoupons, safeAppliedCode));
        const isInputCardAppliedOnWidget =
          isApplied && !appliedInStoreList && !findCouponByCode(allCoupons, safeAppliedCode);
        displayOfferCount = appliedInStoreList
          ? totalStoreCouponCount
          : Math.max(totalStoreCouponCount, isApplied ? 1 : 0);

        const buttonHTML = isApplied
          ? '<button type="button" class="available-offers-widget__apply available-offers-widget__apply--remove" data-code="' + safeCode + '" onclick="window.removeCouponFn && window.removeCouponFn(\'' + safeJSCode + '\', this)">Remove</button>'
          : '<button type="button" class="available-offers-widget__apply" data-code="' + safeCode + '" onclick="window.applyCouponFn && window.applyCouponFn(\'' + safeJSCode + '\', this)">Apply</button>';

        bodyHTML =
          '<div class="available-offers-widget__body">' +
            '<div class="available-offers-widget__row">' +
              '<div class="available-offers-widget__main">' +
                (isApplied ? '' : '<div class="available-offers-widget__ribbon">Special offer for you</div>') +
                '<div class="available-offers-widget__copy">' +
                  (isInputCardAppliedOnWidget
                    ? '<span class="available-offers-widget__copy-text"><strong>' + escapeHtml(code.toUpperCase()) + '</strong> applied</span>'
                    : (safeTitle ? '<span class="available-offers-widget__copy-text">' + safeTitle + '</span>' : '') +
                      (code ? '<span class="available-offers-widget__copy-code"> with code <strong>' + safeCode + '</strong></span>' : '')) +
                '</div>' +
              '</div>' +
              buttonHTML +
            '</div>' +
          '</div>';

        const widgetCopyKey = isInputCardAppliedOnWidget ? code.toLowerCase() + ':applied' : title;
        widgetRenderKey = code.toLowerCase() + '|' + (isApplied ? '1' : '0') + '|' + applicableCount + '|' + widgetCopyKey;
      } else {
        bodyHTML = '<div class="available-offers-widget__body" hidden></div>';
        widgetRenderKey = '_header_only_|' + totalStoreCouponCount;
      }

      const storedCode =
        (getDiscountFromStorage() && getDiscountFromStorage().code
          ? String(getDiscountFromStorage().code).toUpperCase()
          : '') ||
        (safeAppliedCode ? safeAppliedCode.toUpperCase() : '');
      const partnershipInputValue = escapeHtml(storedCode);
      const partnershipHasApplied = !!storedCode;
      const partnershipIdle = !partnershipHasApplied;

      // Partnership + applied coupon: the input row carries the applied state, so the
      // offer row below it is redundant (Figma).
      if (partnershipActive && partnershipHasApplied) {
        bodyHTML = '<div class="available-offers-widget__body" hidden></div>';
      }

      const partnershipInputHTML = partnershipActive
        ? '<div class="available-offers-widget__partnership">' +
            '<div class="available-offers-widget__partnership-row' +
            (partnershipIdle ? ' is-disabled' : ' is-applied') +
            '">' +
              '<input type="text" class="available-offers-widget__partnership-input" placeholder="Have a coupon code? Enter it" autocomplete="off" value="' +
              partnershipInputValue +
              '"' +
              (partnershipHasApplied ? ' disabled hidden' : '') +
              ' />' +
              (partnershipHasApplied
                ? '<span class="available-offers-widget__partnership-applied">' +
                    '<span class="available-offers-widget__partnership-code">' + partnershipInputValue + '</span>' +
                    '<span class="available-offers-widget__partnership-applied-label">' +
                      '<img src="' + COUPON_TICK_ICON_URL + '" width="12" height="12" alt="" aria-hidden="true">Applied' +
                    '</span>' +
                  '</span>'
                : '') +
              (partnershipHasApplied
                ? '<button type="button" class="available-offers-widget__partnership-apply cpnBtn cpnBtn-remove" onclick="window.removeManualCouponFn && window.removeManualCouponFn(this)">Remove</button>'
                : '<button type="button" class="available-offers-widget__partnership-apply cpnBtn is-disabled" aria-disabled="true" onclick="window.applyManualCouponFn && window.applyManualCouponFn(this)">Apply</button>') +
            '</div>' +
            '<div class="available-offers-widget__partnership-error" data-partnership-coupon-error hidden aria-live="polite"></div>' +
          '</div>'
        : '';

      widgetRenderKey += '|p:' + (partnershipActive ? '1' : '0') + '|c:' + storedCode;

      const html =
        '<div class="available-offers-widget__inner">' +
          '<button type="button" class="available-offers-widget__header" aria-label="View all offers" onclick="window.couponViewAllFn && window.couponViewAllFn()">' +
            '<span class="available-offers-widget__header-left">' +
              '<span class="available-offers-widget__ticket-icon" aria-hidden="true">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">' +
                  '<g clip-path="url(#aow_clip0_33973_267)">' +
                    '<path d="M14.8632 5.61292L14.8632 7.38219" stroke="#1D1D1D" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
                    '<path d="M14.8632 10.9569V12.7262" stroke="#1D1D1D" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
                    '<path d="M14.8632 16.3009V18.0702" stroke="#1D1D1D" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
                    '<path d="M4.9159 4.63106L18.8534 4.63106C19.395 4.63106 19.8825 4.82965 20.2616 5.13657C20.6408 5.47959 20.8393 5.93093 20.8393 6.40033L20.8393 10.0723C20.2977 10.0723 19.8103 10.2709 19.4311 10.5778C19.052 10.8847 18.8534 11.3722 18.8534 11.8416C18.8534 12.311 19.052 12.7623 19.4312 13.1053C19.8103 13.4484 20.3158 13.6289 20.8393 13.6108L20.8393 17.3189C20.8393 17.7883 20.6408 18.2396 20.2616 18.5827C19.8825 18.9257 19.377 19.1062 18.8534 19.0882L4.9159 19.0882C4.37429 19.0882 3.86878 18.9076 3.48965 18.5646C3.11052 18.2216 2.91193 17.7703 2.91193 17.3009L2.91193 13.6289C3.45354 13.6289 3.941 13.4303 4.32013 13.1234C4.69926 12.7804 4.89785 12.329 4.89785 11.8596C4.89785 11.3902 4.69925 10.9389 4.32013 10.5959C3.941 10.2528 3.43549 10.0723 2.91193 10.0903L2.91193 6.41839C2.91193 5.94899 3.11052 5.49764 3.48965 5.15462C3.86878 4.8116 4.37429 4.63106 4.9159 4.63106Z" stroke="#1D1D1D" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
                  '</g>' +
                  '<defs><clipPath id="aow_clip0_33973_267"><rect width="24" height="24" fill="white"/></clipPath></defs>' +
                '</svg>' +
              '</span>' +
              '<span class="available-offers-widget__title">Available offers (' + displayOfferCount + ')</span>' +
            '</span>' +
            '<span class="available-offers-widget__chevron" aria-hidden="true">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none">' +
                '<path d="M1.5 1L8.5 8L1.5 15" stroke="#111" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg>' +
            '</span>' +
          '</button>' +
          partnershipInputHTML +
          bodyHTML +
        '</div>';

      // Dedup: only re-write innerHTML when the rendered output actually changes.
      // Stops the section re-render → identical widget rebuild flicker on every cart:change.
      if (state.widgetLastKey === widgetRenderKey && state.widgetLastHtml === html && !widget.hidden) {
        return;
      }
      widget.innerHTML = html;
      widget.hidden = false;
      state.widgetLastHtml = html;
      state.widgetLastKey = widgetRenderKey;

      if (partnershipActive) {
        initManualCouponInput();
        if (state.manualCouponError) {
          const widgetFields = getPartnershipWidgetCouponFields();
          if (widgetFields) setManualCouponError(widgetFields, state.manualCouponError);
        }
      }
    }

    function upgradeViewAllPopupStructure() {
      const root = document.getElementById('coupon_view_all_root');
      if (!root) return;
      const header = root.querySelector('.coupon-full-header');
      const bar = root.querySelector('.coupon-full-input-bar');
      const wrap = root.querySelector('.coupon-full-input-wrap');
      if (!bar || !wrap) return;

      if (header && bar && !root.querySelector('.coupon-full-saving-slot')) {
        const savingSlot = document.createElement('div');
        savingSlot.className = 'coupon-full-saving-slot';
        header.parentNode.insertBefore(savingSlot, bar);
      }

      if (!bar.querySelector('.coupon-full-input-manager')) {
        const manager = document.createElement('div');
        manager.className = 'coupon-full-input-manager';
        bar.insertBefore(manager, wrap);
        manager.appendChild(wrap);
      }

      const manager = bar.querySelector('.coupon-full-input-manager');
      if (manager && !manager.querySelector('[data-popup-input-error]')) {
        const err = document.createElement('div');
        err.className = 'coupon-full-input-error';
        err.setAttribute('data-popup-input-error', '');
        err.hidden = true;
        err.setAttribute('aria-live', 'polite');
        manager.appendChild(err);
      }

      const input = root.querySelector('#viewall_coupon_code_input');
      if (input) input.placeholder = 'Enter coupon code here';
    }

    function attachViewAllPopupListenersOnce() {
      const els = getViewAllPopupElements();
      if (!els || !els.input || !els.applyBtn) return;
      // The popup root can be recreated after cart drawer section re-renders.
      // Bind listeners per live input element (not once globally), otherwise
      // the new input won't update Apply button state on typing.
      if (els.input.dataset.viewAllListenersBound === '1') return;
      els.input.dataset.viewAllListenersBound = '1';
      state.viewAllPopupListenersAttached = true;

      els.input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (typeof window.applyViewAllCouponFn === 'function') {
            window.applyViewAllCouponFn(els.applyBtn);
          }
        }
      });
      els.input.addEventListener('input', function () {
        const pos = els.input.selectionStart;
        els.input.value = String(els.input.value || '').toUpperCase();
        if (typeof pos === 'number') {
          try {
            els.input.setSelectionRange(pos, pos);
          } catch (err) {
            /* ignore */
          }
        }
        clearPopupInputError();
        state.popupCardError = null;
        syncViewAllPopupInputState();
      });
    }

    function ensureCouponViewAllSheet() {
      patchCartDrawerForCouponSheets();
      let root = document.getElementById('coupon_view_all_root');
      if (root) {
        mountCouponSheetToBody(root);
        bindCouponSheetPointerGuards(root);
        upgradeViewAllPopupStructure();
        attachViewAllPopupListenersOnce();
        return root;
      }

      root = document.createElement('div');
      root.id = 'coupon_view_all_root';
      root.hidden = true;
      root.innerHTML =
        '<div class="coupon-full-overlay" aria-hidden="true">' +
          '<div class="coupon-full-sheet">' +
            '<div class="coupon-full-header">' +
              '<button type="button" class="coupon-full-back" aria-label="Back">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">' +
                  '<path d="M0.292893 6.65691C-0.0976311 7.04743 -0.0976311 7.6806 0.292893 8.07112L6.65685 14.4351C7.04738 14.8256 7.68054 14.8256 8.07107 14.4351C8.46159 14.0446 8.46159 13.4114 8.07107 13.0209L2.41421 7.36401L8.07107 1.70716C8.46159 1.31664 8.46159 0.68347 8.07107 0.292946C7.68054 -0.0975785 7.04738 -0.0975785 6.65685 0.292946L0.292893 6.65691ZM12.3902 8.36401C12.9425 8.36401 13.3902 7.9163 13.3902 7.36401C13.3902 6.81173 12.9425 6.36401 12.3902 6.36401V7.36401V8.36401ZM1 7.36401V8.36401H12.3902V7.36401V6.36401H1V7.36401Z" fill="#1D1D1D"/>' +
                '</svg>' +
              '</button>' +
              '<div class="coupon-full-title">Available offers</div>' +
            '</div>' +
            '<div class="coupon-full-saving-slot"></div>' +
            '<div class="coupon-full-input-bar">' +
              '<div class="coupon-full-input-manager">' +
                '<div class="coupon-full-input-wrap">' +
                  '<input type="text" id="viewall_coupon_code_input" class="coupon-full-input" placeholder="Enter coupon code here" autocomplete="off" />' +
                  '<button type="button" id="viewall_coupon_apply_btn" class="coupon-full-input-apply is-disabled" onclick="window.applyViewAllCouponFn && window.applyViewAllCouponFn(this)">Apply</button>' +
                '</div>' +
                '<div class="coupon-full-input-error" data-popup-input-error hidden aria-live="polite"></div>' +
              '</div>' +
            '</div>' +
            '<div class="coupon-full-body" id="coupon_full_body"></div>' +
          '</div>' +
        '</div>';

      mountCouponSheetToBody(root);
      bindCouponSheetPointerGuards(root);

      const back = root.querySelector('.coupon-full-back');
      back.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeCouponViewAllSheet();
      });

      upgradeViewAllPopupStructure();
      attachViewAllPopupListenersOnce();

      return root;
    }

    function closeCouponViewAllSheet() {
      const root = document.getElementById('coupon_view_all_root');
      if (!root) return;
      clearPopupTrayCelebrations();
      state.popupInputError = '';
      state.popupCardError = null;
      state.popupApplySource = null;
      clearPopupInputError();
      const overlay = root.querySelector('.coupon-full-overlay');
      if (!overlay) return;
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.style.display = 'none';
      root.hidden = true;
      syncCartDrawerFocusTrapForCouponSheets();
    }

    function openCouponViewAllSheet() {
      patchCartDrawerForCouponSheets();
      const root = ensureCouponViewAllSheet();
      upgradeViewAllPopupStructure();
      attachViewAllPopupListenersOnce();
      clearPopupInputError();
      const overlay = root.querySelector('.coupon-full-overlay');
      const body = root.querySelector('#coupon_full_body');
      const title = root.querySelector('.coupon-full-title');
      if (!overlay || !body || !title) return;

      const coupons = Array.isArray(state.viewAllCoupons) ? state.viewAllCoupons : [];
      syncViewAllPopupAppliedCode();
      title.textContent = 'Available offers (' + coupons.length + ')';

      const popupInput = root.querySelector('#viewall_coupon_code_input');
      const popupApplyBtn = root.querySelector('#viewall_coupon_apply_btn');
      const stored = getDiscountFromStorage();
      const appliedCode = stored && stored.code ? String(stored.code) : '';

      if (popupInput) {
        if (appliedCode) {
          syncViewAllPopupInputState();
        } else {
          popupInput.value = '';
          popupInput.disabled = false;
          popupInput.classList.remove('coupon-full-input--error');
        }
      }
      if (popupApplyBtn) {
        popupApplyBtn.textContent = appliedCode ? 'Remove' : 'Apply';
        popupApplyBtn.style.pointerEvents = 'auto';
      }

      body.innerHTML = buildViewAllPopupBodyHtml();
      resumePopupTrayCelebrationsAfterRender();
      syncCartHeaderSaving(state.lastCartData || lastCartData);

      root.hidden = false;
      overlay.style.display = 'block';
      overlay.setAttribute('aria-hidden', 'false');
       syncCartDrawerFocusTrapForCouponSheets();
      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
      });
    }

    // Function to build coupon card HTML (stacked gray shell + white detail panel)
    function buildCouponCard(coupon, isApplied = false) {
      const couponCode = coupon.code || '';
      const couponTitle = coupon.title || '';
      const isApplicable = coupon.isApplicable !== false;
      const showAsApplicable = isApplicable || isApplied;
      const savingsLine = resolveCouponSavingsLine(coupon);
      const couponMessage = resolveCouponDisplayMessage(coupon, savingsLine);
      const detailsUrl = getCouponDetailsUrl(coupon);
      const detailsText = getCouponDetailsText(coupon);

      let cardHTML =
        '<div class="coupon-card gXMwoP' +
        (!showAsApplicable ? ' coupon-not-applicable' : '') +
        (isApplied ? ' coupon-card--applied' : '') +
        '" data-coupon-code="' +
        escapeHtml(couponCode.toLowerCase()) +
        '">';
      cardHTML += '<div class="coupon-wrapper">';

      cardHTML += '<div class="coupon-panel">';
      cardHTML += '<div class="coupon-content">';
      cardHTML += '<h3>' + escapeHtml(couponTitle) + '</h3>';
      if (couponMessage) {
        cardHTML += '<div class="subHeading"><p>' + escapeHtml(couponMessage) + '</p></div>';
      }
      if (savingsLine) {
        cardHTML +=
          '<p class="coupon-savings' +
          (showAsApplicable ? '' : ' coupon-savings--muted') +
          '">' +
          formatCouponSavingsLineHtml(savingsLine) +
          '</p>';
      }
      cardHTML +=
        '<button type="button" class="coupon-view-details">View details</button>';
      cardHTML += '</div>';
      cardHTML += '</div>';

      cardHTML += '<div class="coupon-code-area">';
      cardHTML += '<div class="coupon-row">';
      cardHTML += buildCouponCardFooterHTML(couponCode, isApplicable, isApplied);

      cardHTML += '</div>';
      cardHTML += '</div>';

      cardHTML += '</div>';
      cardHTML += '</div>';

      if (couponCode) {
        state.couponSheetData[String(couponCode).toLowerCase()] = {
          title: couponTitle,
          description: getCouponSheetDescription(coupon),
          actionMessage: getCouponSheetActionMessage(coupon),
          message: couponMessage,
          savings: savingsLine,
          details: detailsText,
          detailsUrl: detailsUrl,
          code: couponCode,
          isApplicable: showAsApplicable,
          isApplied: isApplied,
          eligibilityHint: getCouponEligibilityHint(coupon),
        };
      }

      return cardHTML;
    }

    // Function to apply coupon via API
    async function applyCouponAPI(couponCode, cartData) {
      // Backstop for the idle preload at boot: gives the GIFs the API
      // round-trip as a head start if they are not cached yet.
      schedulePreloadCouponSuccessAssets();
      try {
        const deviceId = getDeviceId();
        const transformedCart = transformCartForAPI(cartData);

        // Clear Shopify discount fields to prevent conflicts with backend validation
        // This is especially important during revalidation after page refresh where
        // Shopify cart still has discount_codes/cart_level_discount_applications set
        transformedCart.cart.discount_codes = [];
        transformedCart.cart.cart_level_discount_applications = [];
        
        // DO NOT include stored discount data during revalidation
        // The backend interprets this as "another discount code" and rejects with:
        // "This code cannot be used with other discount codes"
        // The /apply API should validate the coupon against a clean cart state

        // Add couponCodes to the payload
        const payload = {
          ...transformedCart,
          couponCodes: [couponCode],
        };

        const headers = applyCouponCustomerHeader({
          'x-source': 'web-app',
          'x-platform': 'web',
          'x-device-id': deviceId,
          'Content-Type': 'application/json',
        });

        const response = await fetch('https://api-v1.mamaearth.in/v1/coupons/apply', {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error('Failed to apply coupon');
        }

        const result = await response.json();
        return result;
      } catch (error) {
        console.error('Error applying coupon:', error);
        return { success: false, error: error.message };
      }
    }

    // Function to remove coupon via API
    async function removeCouponAPI(couponCode, cartData) {
      try {
        const deviceId = getDeviceId();
        const transformedCart = transformCartForAPI(cartData);

        // Add discount info from localStorage if available
        const storedDiscount = getDiscountFromStorage();
        if (storedDiscount && storedDiscount.data) {
          transformedCart.cart.discount = storedDiscount.data;
        }

        // Add couponCodes to the payload
        const payload = {
          ...transformedCart,
          couponCodes: [couponCode],
        };

        const headers = applyCouponCustomerHeader({
          'x-source': 'web-app',
          'x-platform': 'web',
          'x-device-id': deviceId,
          'Content-Type': 'application/json',
        });

        const response = await fetch('https://api-v1.mamaearth.in/v1/coupons/remove', {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error('Failed to remove coupon');
        }

        const result = await response.json();
        return result;
      } catch (error) {
        console.error('Error removing coupon:', error);
        return { success: false, error: error.message };
      }
    }

    // Checkout reads discount_code from cookie only — never persist discount on cart attributes.
    async function clearDiscountCartAttributes() {
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              discount_code: '',
              discount_amount: '',
              discounted_total: '',
              discount_type: '',
              discount_applied: '',
            },
          }),
        });

        if (!response.ok) {
          throw new Error('Failed to clear cart discount attributes');
        }

        const cart = await response.json();
        cacheCartData(cart);
        return cart;
      } catch (error) {
        console.error('Error clearing cart discount attributes:', error);
        return null;
      }
    }

    // Function to save discount to localStorage
    function saveDiscountToStorage(discountData, couponCode, updatedCart, appliedCoupon) {
      const discountInfo = {
        code: couponCode,
        amount: discountData.total_discount || 0,
        total: discountData.total_price || 0,
        data: discountData,
        updatedCart: updatedCart || null,
        // The coupons[] entry from /coupons/apply, sent as-is to /coupons/list
        // so it can report this coupon's saving (see buildCouponListApiPayload).
        appliedCoupon: appliedCoupon || null,
        timestamp: Date.now(),
      };
      localStorage.setItem('applied_discount', JSON.stringify(discountInfo));
      
      // Always update snapshot timestamp, even if updatedCart is null
      // This ensures the snapshot freshness check works on page refresh
      state.couponSnapshotRefreshedAt = Date.now();
      
      if (updatedCart) {
        state.couponApiCartSnapshot = updatedCart;
      }
    }

    // Function to get discount from localStorage
    function getDiscountFromStorage() {
      try {
        const stored = localStorage.getItem('applied_discount');
        if (!stored) return null;

        const discountInfo = JSON.parse(stored);
        // No TTL: the applied coupon persists until it is explicitly removed
        // (clearDiscountFromStorage, via the remove flows or revalidation finding
        // it invalid). `timestamp` is still written for debugging.
        return discountInfo;
      } catch (e) {
        return null;
      }
    }

    // Function to clear discount from storage
    function clearDiscountFromStorage() {
      localStorage.removeItem('applied_discount');
      state.couponApiCartSnapshot = null;
      state.couponSnapshotRefreshedAt = 0;
      clearCouponListCache();
    }

    /**
     * Drop every coupon-session artifact without touching the Shopify cart.
     *
     * Called from orderSuccess (and empty-cart recovery) so a completed order's
     * applied_discount snapshot / discount_code cookie cannot paint or re-apply
     * onto the next cart. Must not POST /cart.js — GoKwik may still be clearing
     * the token, and a mutation here would race the shopper's next add-to-cart.
     */
    function clearCouponSessionState() {
      state.discountRevalidateRequestId += 1;
      cancelRevalidateDebounce();
      state.highValueCartDeferForCoupon = false;
      try {
        deleteCookieAllScopes('discount_code');
      } catch (e) {
        document.cookie = 'discount_code=; path=/; max-age=0';
      }
      clearDiscountFromStorage();
      clearFreeProductsFromStorage();
      resetCouponListCache();
      window.appliedDiscount = null;
      window.updatedCartToPayAmount = null;
      try {
        hideFreeProductsInCart();
        const discountRow = document.querySelector('.applied-coupon-discount');
        if (discountRow) discountRow.remove();
        restoreManualCouponInput();
      } catch (uiErr) {
        /* storage is already clear */
      }
    }

    /**
     * A leftover coupon on an empty cart is never valid. After partnership
     * checkout the cold-start latch is already spent, so revalidateAppliedDiscount
     * would not run on homepage boot — and the next ATC would re-apply the old
     * code / overlay its ₹0 snapshot. Only acts on a cart we already have
     * (no extra /cart.js); the init chain feeds the cart it just fetched.
     */
    function discardCouponSessionIfCartEmpty(cartHint) {
      if (!getDiscountFromStorage()?.code) return;
      const cart = cartHint || state.lastCartData;
      if (!cart || typeof cart.item_count === 'undefined') return;
      if (Number(cart.item_count) > 0) return;
      clearCouponSessionState();
    }

    // ---------------------------------------------------------------------
    // Free product (GWP) helpers
    //
    // The /v2/coupons/apply response can include `coupons[*].free_products`
    // when the applied coupon adds a gift-with-purchase line that isn't
    // part of the Shopify cart yet. We surface those items at the top of
    // the cart drawer with a FREE pill (see .applied-free-product styles).
    // If the free product's product_id / variant_id already matches a cart
    // line item, we skip the standalone freebie card to avoid duplicates.
    //
    // Persistence: we mirror the discount pattern and stash the free
    // products under `applied_free_products` keyed to the coupon code, so
    // that the section re-render from `cart:refresh` doesn't wipe the
    // injected DOM — `restoreFreeProductsInCart` repaints from cache.
    // ---------------------------------------------------------------------

    function freeProductsEscapeHtml(value) {
      if (value == null) return '';
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function freeProductsExtractImage(item) {
      if (!item) return '';
      const candidate =
        item.image ||
        item.image_url ||
        item.imageUrl ||
        item.featured_image ||
        item.featuredImage ||
        item.product_image ||
        item.thumbnail ||
        '';
      if (!candidate) return '';
      if (typeof candidate === 'string') return candidate;
      return candidate.url || candidate.src || '';
    }

    function freeProductsExtractTitle(item) {
      if (!item) return '';
      // `title` on Shopify variant rows can include the variant suffix
      // (e.g. "… - 30 ml"), which matches the design — prefer it.
      return (
        item.title ||
        item.product_title ||
        item.name ||
        item.productTitle ||
        item.product_name ||
        ''
      );
    }

    function freeProductsExtractPrice(item) {
      if (!item) return null;
      // Shopify-style price fields are always in minor units (paise).
      // Sample payload: price: 8800 → ₹88.
      const shopifyCentFields = [
        'original_price',
        'price',
        'final_price',
        'line_price',
        'final_line_price',
        'compare_at_price',
      ];
      for (let i = 0; i < shopifyCentFields.length; i++) {
        const raw = item[shopifyCentFields[i]];
        if (raw != null) {
          const num = Number(raw);
          if (isFinite(num)) return num / 100;
        }
      }
      // Non-Shopify fallbacks where the API gives rupees directly.
      const altFields = ['selling_price', 'mrp', 'sellingPrice'];
      for (let i = 0; i < altFields.length; i++) {
        const raw = item[altFields[i]];
        if (raw != null) {
          const num = Number(raw);
          if (isFinite(num)) return num;
        }
      }
      return null;
    }

    function freeProductsExtractQuantity(item) {
      if (!item) return 1;
      const raw =
        item.free_quantity != null ? item.free_quantity :
        item.gwp_free_quantity != null ? item.gwp_free_quantity :
        item.quantity != null ? item.quantity :
        1;
      const num = Number(raw);
      return isFinite(num) && num > 0 ? Math.floor(num) : 1;
    }

    function freeProductsExtractUrl(item) {
      if (!item) return '';
      if (item.handle) return '/products/' + item.handle;
      if (!item.url) return '';
      let url = String(item.url).trim();
      if (!url) return '';
      // Strip protocol + host (e.g. "bblunt-com.myshopify.com/products/foo")
      // so the link resolves on the current storefront instead of the dev
      // myshopify domain returned by the API.
      url = url.replace(/^https?:\/\//i, '');
      const slashIdx = url.indexOf('/');
      if (slashIdx === -1) return url.charAt(0) === '/' ? url : '';
      return url.substring(slashIdx);
    }

    function saveFreeProductsToStorage(freeProducts, couponCode) {
      try {
        const list = Array.isArray(freeProducts) ? freeProducts : [];
        if (!list.length) {
          localStorage.removeItem('applied_free_products');
          return;
        }
        localStorage.setItem(
          'applied_free_products',
          JSON.stringify({
            code: couponCode || '',
            items: list,
            timestamp: Date.now(),
          })
        );
      } catch (e) {
        /* ignore quota / serialization issues */
      }
    }

    function getFreeProductsFromStorage() {
      try {
        const stored = localStorage.getItem('applied_free_products');
        if (!stored) return null;
        const info = JSON.parse(stored);
        // No TTL: freebies persist until explicitly cleared. They can't outlive their
        // discount regardless — restoreFreeProductsInCart drops them whenever
        // getDiscountFromStorage() returns nothing, and the remove flows call
        // clearFreeProductsFromStorage directly.
        if (!Array.isArray(info.items) || info.items.length === 0) return null;
        return info;
      } catch (e) {
        return null;
      }
    }

    function clearFreeProductsFromStorage() {
      localStorage.removeItem('applied_free_products');
    }

    function getCartItemsForFreeProductCheck() {
      const cart = state.lastCartData || lastCartData;
      return cart && Array.isArray(cart.items) ? cart.items : null;
    }

    function freeProductComparableIds(freeProduct) {
      if (!freeProduct) return [];
      const ids = [];
      ['product_id', 'variant_id', 'id'].forEach(function (field) {
        const val = freeProduct[field];
        if (val != null && val !== '') ids.push(String(val));
      });
      return ids;
    }

    function cartLineComparableIds(cartItem) {
      if (!cartItem) return [];
      const ids = [];
      ['product_id', 'variant_id', 'id'].forEach(function (field) {
        const val = cartItem[field];
        if (val != null && val !== '') ids.push(String(val));
      });
      return ids;
    }

    /** True when the apply-API free product matches any cart line (paid or free). */
    function freeProductMatchesCartLine(freeProduct, cartItem) {
      const freeIds = freeProductComparableIds(freeProduct);
      const lineIds = cartLineComparableIds(cartItem);
      if (!freeIds.length || !lineIds.length) return false;
      return freeIds.some(function (fid) {
        return lineIds.indexOf(fid) !== -1;
      });
    }

    /** Drop freebies whose product/variant id already exists as a cart line item. */
    function filterFreeProductsNotInCart(freeProducts, cartItems) {
      const list = Array.isArray(freeProducts) ? freeProducts.filter(Boolean) : [];
      if (!list.length) return [];
      if (!Array.isArray(cartItems) || !cartItems.length) return list;
      return list.filter(function (fp) {
        return !cartItems.some(function (item) {
          return freeProductMatchesCartLine(fp, item);
        });
      });
    }

    function syncFreeProductsUi(freeProducts, couponCode, cartHint) {
      const list = Array.isArray(freeProducts) ? freeProducts.filter(Boolean) : [];
      const cartItems =
        (cartHint && Array.isArray(cartHint.items) && cartHint.items) ||
        getCartItemsForFreeProductCheck();

      if (!list.length) {
        clearFreeProductsFromStorage();
        hideFreeProductsInCart();
        return;
      }

      saveFreeProductsToStorage(list, couponCode);

      const toShow = filterFreeProductsNotInCart(list, cartItems);
      if (!toShow.length) {
        hideFreeProductsInCart();
        return;
      }

      showFreeProductsInCart(toShow, couponCode);
    }

    function buildFreeProductCardHtml(item) {
      const title = freeProductsEscapeHtml(freeProductsExtractTitle(item));
      const image = freeProductsExtractImage(item);
      const safeImage = freeProductsEscapeHtml(image);
      const price = freeProductsExtractPrice(item);
      const quantity = freeProductsExtractQuantity(item);
      const url = freeProductsExtractUrl(item);
      const safeUrl = freeProductsEscapeHtml(url);

      const priceText =
        price != null
          ? '₹' + price.toFixed(price % 1 === 0 ? 0 : 2)
          : '';
      const qtyText = quantity > 1 ? ' × ' + quantity : '';
      const priceHtml = priceText
        ? '<div class="applied-free-product__price"><span class="applied-free-product__price-cut">' + priceText + '</span>' +
          (qtyText ? '<span class="applied-free-product__qty">' + qtyText + '</span>' : '') +
          '</div>'
        : qtyText
          ? '<div class="applied-free-product__price">Qty:' + qtyText + '</div>'
          : '';

      const imgHtml = image
        ? '<img class="applied-free-product__img" src="' + safeImage + '" alt="' + title + '" loading="lazy" width="60" height="60">'
        : '<span class="applied-free-product__img applied-free-product__img--placeholder" aria-hidden="true"></span>';

      const titleNode = safeUrl
        ? '<a class="applied-free-product__title" href="' + safeUrl + '">' + title + '</a>'
        : '<div class="applied-free-product__title">' + title + '</div>';

      return (
        '<div class="applied-free-product" data-freebie-source="coupon-api">' +
          '<div class="applied-free-product__media">' + imgHtml + '</div>' +
          '<div class="applied-free-product__info">' +
            titleNode +
            priceHtml +
          '</div>' +
          '<div class="applied-free-product__tag">FREE</div>' +
        '</div>'
      );
    }

    function getFreeProductsHostContainers() {
      // Cart drawer renders the items wrapper in the main DOM. The shadow
      // DOM side-cart (GoKwik) keeps its own copy, so paint both when
      // present — keeps the FREE pill visible regardless of which cart
      // surface the user is looking at.
      const hosts = [];
      const main = document.querySelector('.hdt-mini-cart__items');
      if (main) hosts.push(main);
      const mainCart = document.querySelector('.hdt-cart-items');
      if (mainCart) hosts.push(mainCart);
      const shadow = document.querySelector('shadow-dom-container')?.shadowRoot;
      if (shadow) {
        const shadowMain = shadow.querySelector('.hdt-mini-cart__items');
        if (shadowMain) hosts.push(shadowMain);
      }
      return hosts;
    }

    function hideCouponApiFreeProductsInCart() {
      const selector = '.applied-free-products-wrap[data-freebie-source="coupon-api"]';
      document.querySelectorAll(selector).forEach((node) => node.remove());
      const shadow = document.querySelector('shadow-dom-container')?.shadowRoot;
      if (shadow) {
        shadow.querySelectorAll(selector).forEach((node) => node.remove());
      }
    }

    function hideFreeProductsInCart() {
      hideCouponApiFreeProductsInCart();
    }

    function showFreeProductsInCart(freeProducts, couponCode) {
      hideCouponApiFreeProductsInCart();
      const list = Array.isArray(freeProducts) ? freeProducts.filter(Boolean) : [];
      if (!list.length) return;

      const cardsHtml = list.map(buildFreeProductCardHtml).join('');
      const wrapHtml =
        '<div class="applied-free-products-wrap" data-freebie-source="coupon-api" data-coupon-code="' +
        freeProductsEscapeHtml(couponCode || '') +
        '">' +
        cardsHtml +
        '</div>';

      getFreeProductsHostContainers().forEach((host) => {
        // Insert right after the "Cart item (X)" title so the free
        // product sits at the top of the items list, matching the design.
        const title = host.querySelector('.cart_title');
        const tmp = document.createElement('div');
        tmp.innerHTML = wrapHtml;
        const node = tmp.firstElementChild;
        if (!node) return;
        if (title && title.parentNode === host) {
          title.insertAdjacentElement('afterend', node);
        } else {
          host.insertAdjacentElement('afterbegin', node);
        }
      });
    }

    async function restoreFreeProductsInCart() {
      const stored = getFreeProductsFromStorage();
      if (!stored || !stored.items || stored.items.length === 0) {
        hideFreeProductsInCart();
        return;
      }
      // If the discount has been cleared but the free products are still
      // cached, drop them — they should never outlive the coupon.
      const storedDiscount = getDiscountFromStorage();
      if (!storedDiscount) {
        clearFreeProductsFromStorage();
        hideFreeProductsInCart();
        return;
      }
      let cartItems = getCartItemsForFreeProductCheck();
      // A fresh tab/session has no cached cart yet. filterFreeProductsNotInCart
      // treats an unknown cart as "show everything," which would incorrectly
      // paint the freebie card even when the free item is already a real cart
      // line (the common case once a coupon is applied). Fetch the live cart
      // so the dedup check has real data instead of failing open.
      if (!cartItems) {
        try {
          const response = await fetch('/cart.js');
          if (response.ok) {
            const freshCart = await response.json();
            cacheCartData(freshCart);
            cartItems = Array.isArray(freshCart.items) ? freshCart.items : null;
          }
        } catch (fetchErr) {
          /* fall through — handled by the fail-closed check below */
        }
      }
      // Fail closed. filterFreeProductsNotInCart treats an unknown cart as "show
      // everything", so without this a failed /cart.js call would paint the freebie
      // card next to the real cart line that already represents it. Skipping a render
      // is recoverable — the next one with cart data repaints it; a phantom duplicate
      // freebie is not. An empty cart is handled here too: with nothing purchased
      // there is no GWP to show.
      if (!cartItems || !cartItems.length) {
        hideFreeProductsInCart();
        return;
      }
      const toShow = filterFreeProductsNotInCart(stored.items, cartItems);
      if (!toShow.length) {
        hideFreeProductsInCart();
        return;
      }
      showFreeProductsInCart(toShow, stored.code);
    }

    // Function to refresh the cart (simplified - don't replace entire drawer).
    // Dispatches a single cart:refresh — the theme's CartDrawer listener handles
    // section re-fetch + drawer re-render and fires its own cart:drawer:render
    // afterwards. The previous version also dispatched cart:change with an
    // empty `sections: {}`, which caused on_cart_change_fn in global.js to try
    // to parse `undefined` as HTML on top of the cart:refresh re-render — two
    // stacked re-renders per coupon apply was the biggest source of visible
    // jitter. Single event eliminates that.
    async function refreshCart(cartHint) {
      try {
        let cartData = cartHint || state.lastCartData || lastCartData;
        if (!cartData || typeof cartData.item_count === 'undefined') {
          const response = await fetch('/cart.js');
          if (!response.ok) throw new Error('Failed to fetch cart');
          cartData = await response.json();
        }
        cacheCartData(cartData);
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cartData } }));
      } catch (error) {
        console.error('Error refreshing cart:', error);
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: { sections: {} } } }));
      }
    }

    /**
     * Coupon apply API returns discount.total_price in INR (rupees), e.g. 1049 = ₹1,049.
     * Shopify cart totals use paise (e.g. 144900 = ₹1,449). Values >= 10000 are treated
     * as paise for legacy callers; smaller whole numbers are rupees.
     */
    function formatMoneyFromDiscountTotalPrice(raw) {
      const rawNum = Number(raw);
      if (!isFinite(rawNum)) return null;
      const isWhole = Math.abs(rawNum - Math.round(rawNum)) < 1e-9;
      const cents =
        isWhole && rawNum >= 10000 ? Math.round(rawNum) : Math.round(rawNum * 100);
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }
      return '₹' + (cents / 100).toFixed(2);
    }

    function formatMoneyFromCartCents(cents) {
      const raw = Number(cents);
      if (!isFinite(raw)) return null;
      const rounded = Math.round(raw);
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(rounded);
      }
      return '₹' + (rounded / 100).toFixed(2);
    }

    const SHIPPING_FEE_CENTS =
      (window.__copyCodeCouponUi && window.__copyCodeCouponUi.shippingFeeCents) || 4000;
    const FREE_SHIPPING_THRESHOLD_CENTS =
      (window.__copyCodeCouponUi && window.__copyCodeCouponUi.freeShippingThresholdCents) || 39900;
    const PREPAID_DISCOUNT_PERCENT =
      (window.__copyCodeCouponUi && window.__copyCodeCouponUi.prepaidDiscountPercent) || 5;
    const PREPAID_DISCOUNT_MAX_CENTS =
      (window.__copyCodeCouponUi && window.__copyCodeCouponUi.prepaidDiscountMaxCents) || 5000;
    const HIGH_VALUE_CART_ENABLED =
      !!(window.__copyCodeCouponUi && window.__copyCodeCouponUi.highValueCartRestrictionEnabled);
    const HIGH_VALUE_CART_MAX_PAYABLE_CENTS = Number(
      (window.__copyCodeCouponUi && window.__copyCodeCouponUi.highValueCartMaxPayableCartCents) || 0
    );

    function getCartOrderTotalCents(cart) {
      if (!cart) return 0;
      if (cart._displaySource === 'updatedCart') {
        const netSubtotal = getCartNetSubtotalCents(cart);
        const itemDiscount = computeOfferDiscountCentsFromCart(cart);
        const reconstructedTotal = netSubtotal + itemDiscount;
        if (reconstructedTotal > 0) return reconstructedTotal;
      }
      const orderTotal = Number(cart.original_total_price);
      return isFinite(orderTotal) && orderTotal > 0 ? orderTotal : Number(cart.total_price) || 0;
    }

    function getCartNetSubtotalCents(cart) {
      if (!cart) return 0;
      if (
        cart._displaySource === 'updatedCart' &&
        cart._snapshotFresh &&
        cart.discount &&
        cart.discount.total_price != null
      ) {
        return discountAmountToCents(cart.discount.total_price);
      }
      return Number(cart.total_price) || 0;
    }

    function computeCartTotals(cart) {
      const orderTotalCents = getCartOrderTotalCents(cart);
      const netSubtotalCents = getCartNetSubtotalCents(cart);
      const shippingCents =
        netSubtotalCents > FREE_SHIPPING_THRESHOLD_CENTS ? 0 : SHIPPING_FEE_CENTS;
      const prepaidDiscountRaw = Math.round(netSubtotalCents * PREPAID_DISCOUNT_PERCENT / 100);
      const prepaidDiscountCents = Math.min(prepaidDiscountRaw, PREPAID_DISCOUNT_MAX_CENTS);
      const toPayCents = netSubtotalCents + shippingCents - prepaidDiscountCents;
      return { orderTotalCents, netSubtotalCents, shippingCents, prepaidDiscountCents, toPayCents };
    }

    /**
     * Cart totals exactly as syncPriceSummaryFromCart paints them — the
     * applied-coupon display cart run through computeCartTotals — plus the
     * shipping constants behind them. Exposed so code outside this file
     * (analytics, the contextual offers sheet) shows the drawer's numbers.
     */
    function getCartTotals(shopifyCartHint) {
      const cart = getDisplayCart(shopifyCartHint);
      if (!cart || typeof cart.item_count === 'undefined') return null;
      return Object.assign(computeCartTotals(cart), {
        shippingFeeCents: SHIPPING_FEE_CENTS,
        freeShippingThresholdCents: FREE_SHIPPING_THRESHOLD_CENTS,
      });
    }

    let highValueCartApplyTimer = null;

    // Seed from Liquid SSR once so the first drawer re-render does not wipe a blocked state.
    try {
      if (
        !state.highValueCartHasSynced &&
        window.__hdtHighValueCartRestrictionConfig &&
        typeof window.__hdtHighValueCartRestrictionConfig.shouldBlock === 'boolean'
      ) {
        state.highValueCartLastBlocked = !!window.__hdtHighValueCartRestrictionConfig.shouldBlock;
      }
    } catch (e) {
      /* ignore */
    }

    /** Threshold gate: discounted payable (To Pay), not undiscounted original total. */
    function shouldBlockCheckoutWithPayableCents(payableCents) {
      return (
        HIGH_VALUE_CART_ENABLED &&
        HIGH_VALUE_CART_MAX_PAYABLE_CENTS > 0 &&
        Number(payableCents) > HIGH_VALUE_CART_MAX_PAYABLE_CENTS
      );
    }

    function updateHighValueCartAlertMessage() {
      const alertEl = document.getElementById("high_value_cart_alert");
      const alertMessageEl = alertEl
        ? alertEl.querySelector(".hdt-high-value-cart-alert__message")
        : null;
      if (!alertMessageEl || typeof state.highValueCartLastToPayCents !== "number") return;

      const headingTemplate =
        (window.__copyCodeCouponUi &&
          window.__copyCodeCouponUi.highValueCartAlertHeadingTemplate) ||
        "Order Limit %threshold% Reached";
      const template =
        (window.__copyCodeCouponUi &&
          window.__copyCodeCouponUi.highValueCartAlertMessageTemplate) ||
        "";

      const maxMoney = String(formatMoneyFromCartCents(HIGH_VALUE_CART_MAX_PAYABLE_CENTS) || "").replace(/\.00/g, "");
      const payableMoney = String(formatMoneyFromCartCents(state.highValueCartLastToPayCents) || "").replace(/\.00/g, "");
      const replacePlaceholders = function (value) {
        return String(value || "")
          .split("%threshold%")
          .join(maxMoney)
          .split("%payable_total%")
          .join(payableMoney);
      };
      const headingText = replacePlaceholders(headingTemplate);
      const bodyText = replacePlaceholders(template);
      const headingEl = alertMessageEl.querySelector(".hdt-high-value-cart-alert__heading");
      const bodyEl = alertMessageEl.querySelector(".hdt-high-value-cart-alert__body");
      if (headingEl || bodyEl) {
        if (headingEl) headingEl.textContent = headingText;
        if (bodyEl) bodyEl.textContent = bodyText;
      } else {
        alertMessageEl.textContent = [headingText, bodyText].filter(Boolean).join("\n");
      }
    }

    function applyHighValueCartRestrictionDOM(shouldBlock) {
      const alertEl = document.getElementById("high_value_cart_alert");

      // Alert visibility shares the same HVC shouldBlock as checkout-disable.
      if (alertEl) {
        alertEl.hidden = !shouldBlock;
        alertEl.setAttribute("aria-hidden", shouldBlock ? "false" : "true");
        if (shouldBlock) updateHighValueCartAlertMessage();
      }

      [
        document.querySelector("#CartDrawer .hdt-mini-cart__bottom-wrap"),
        document.querySelector("#hdt-page-cart .hdt-page-cart__bottom-wrap"),
      ].forEach(function (el) {
        if (el) el.classList.toggle("high_value_cart_alert_active", shouldBlock);
      });

      const proceedWrapper = document.getElementById("proceed_to_checkout_btn");
      if (proceedWrapper) {
        proceedWrapper.setAttribute(
          "data-hvc-should-block",
          shouldBlock ? "true" : "false",
        );
        proceedWrapper.classList.toggle("hdt-high-value-cart--blocked", shouldBlock);

        const payBtn = proceedWrapper.querySelector(".hdt-mini-cart__checkout-pay");
        if (payBtn) {
          payBtn.disabled = shouldBlock;
          payBtn.setAttribute("aria-disabled", shouldBlock ? "true" : "false");
        }

        const checkoutButtons = proceedWrapper.querySelectorAll(
          ".gokwik-checkout button, .shopifycheckoutbtn, .hdt-main-cart__button-checkout",
        );
        checkoutButtons.forEach(function (btn) {
          const wasDisabledByRestriction = btn.dataset.hvcDisabled === "true";

          if (shouldBlock) {
            btn.dataset.hvcDisabled = "true";
            btn.disabled = true;
            btn.classList.add("disabled");
            btn.setAttribute("aria-disabled", "true");
          } else {
            btn.setAttribute("aria-disabled", "false");

            if (wasDisabledByRestriction) {
              delete btn.dataset.hvcDisabled;
              btn.disabled = false;
              btn.classList.remove("disabled");
            }
          }
        });
      }
    }

    function applyHighValueCartRestriction(shouldBlock, options) {
      var force = options && options.force;
      shouldBlock = !!shouldBlock;

      state.highValueCartLastBlocked = shouldBlock;
      window.__hdtHighValueCartRestrictionBlocked = shouldBlock;

      window.__hdtHighValueCartRestrictionShouldBlock = function () {
        if (state.highValueCartLastToPayCents == null) return state.highValueCartLastBlocked;
        return shouldBlockCheckoutWithPayableCents(state.highValueCartLastToPayCents);
      };

      if (
        !force &&
        state.highValueCartLastAppliedGeneration === state.highValueCartDomGeneration
      ) {
        return;
      }

      state.highValueCartLastAppliedGeneration = state.highValueCartDomGeneration;
      applyHighValueCartRestrictionDOM(shouldBlock);
    }

    function scheduleReapplyHighValueCartRestriction() {
      clearTimeout(highValueCartApplyTimer);
      highValueCartApplyTimer = setTimeout(function () {
        var shouldBlock = shouldBlockCheckoutWithPayableCents(state.highValueCartLastToPayCents);
        if (
          shouldBlock === state.highValueCartLastBlocked &&
          state.highValueCartLastAppliedGeneration === state.highValueCartDomGeneration
        ) {
          return;
        }
        applyHighValueCartRestriction(shouldBlock, { force: true });
      }, 520);
    }

    function flushHighValueCartAfterCouponSettle() {
      if (!state.highValueCartDeferForCoupon) return;
      state.highValueCartDeferForCoupon = false;
      const shopifyCart = state.lastCartData || lastCartData;
      if (!shopifyCart || typeof shopifyCart.item_count === 'undefined') return;
      const displayCart = getDisplayCart(shopifyCart);
      const totals = computeCartTotals(displayCart || shopifyCart);
      // Post-discount settle: recheck HVC against discounted To Pay.
      syncHighValueCartRestriction(totals.toPayCents);
    }

    /**
     * Single HVC path for checkout-disable + alert.
     * Always gates on discounted payable (toPayCents) — including after a coupon apply.
     */
    function syncHighValueCartRestriction(toPayCents) {
      state.highValueCartLastToPayCents = toPayCents;
      state.highValueCartHasSynced = true;

      var shouldBlock = shouldBlockCheckoutWithPayableCents(toPayCents);

      if (shouldBlock === state.highValueCartLastBlocked) {
        if (shouldBlock) updateHighValueCartAlertMessage();
        return;
      }

      state.highValueCartDomGeneration++;
      applyHighValueCartRestriction(shouldBlock);
      scheduleReapplyHighValueCartRestriction();
    }

    // After cart drawer DOM replacement (cart:change → replaceChildren → cart:drawer:render),
    // immediately restore the correct restriction state on the fresh DOM.
    function reapplyHighValueCartRestrictionOnDrawerRender() {
      state.highValueCartDomGeneration++;

      var blocked = state.highValueCartLastBlocked;
      if (!state.highValueCartHasSynced) {
        var proceedEl = document.getElementById('proceed_to_checkout_btn');
        if (proceedEl && proceedEl.getAttribute('data-hvc-should-block') === 'true') {
          blocked = true;
        } else if (
          window.__hdtHighValueCartRestrictionConfig &&
          window.__hdtHighValueCartRestrictionConfig.shouldBlock
        ) {
          blocked = true;
        }
        state.highValueCartLastBlocked = blocked;
      }

      applyHighValueCartRestrictionDOM(blocked);
      state.highValueCartLastAppliedGeneration = state.highValueCartDomGeneration;

      if (!blocked) {
        var proceedWrapper = document.getElementById("proceed_to_checkout_btn");
        if (proceedWrapper) {
          proceedWrapper.querySelectorAll(
            ".gokwik-checkout button, .shopifycheckoutbtn, .hdt-main-cart__button-checkout"
          ).forEach(function (btn) {
            btn.disabled = false;
            btn.classList.remove("disabled");
            btn.setAttribute("aria-disabled", "false");
            delete btn.dataset.hvcDisabled;
          });
        }
      }
    }

    function removeItemsDiscountRow() {
      const row = document.querySelector('.items-discount-row');
      if (row) row.remove();
    }

    function cartAttributesObject(cart) {
      const a = cart && cart.attributes;
      if (!a) return {};
      if (typeof a === 'string') {
        try {
          return JSON.parse(a);
        } catch (e) {
          return {};
        }
      }
      return a;
    }

    function cartHasDiscountAttributes(cart) {
      const attrs = cartAttributesObject(cart);
      if (attrs.discount_applied === 'true' || attrs.discount_applied === true) return true;
      if (attrs.discount_code) return true;
      if (attrs.discount_amount != null && attrs.discount_amount !== '') return true;
      return false;
    }

    /** Strip legacy discount_* cart attributes (checkout uses cookie only). */
    async function ensureDiscountCartAttributesClean(cartHint) {
      let cart = cartHint;
      if (!cart || typeof cart.item_count === 'undefined') {
        try {
          const res = await fetch('/cart.js');
          if (!res.ok) return null;
          cart = await res.json();
          cacheCartData(cart);
        } catch (e) {
          return null;
        }
      }
      if (!cartHasDiscountAttributes(cart)) return cart;
      return (await clearDiscountCartAttributes()) || cart;
    }

    /**
     * Expire a cookie across every scope it might have been set on.
     *
     * A `document.cookie` deletion only matches on the (name, path, domain)
     * triple, so a host-only delete silently leaves a `.example.com` cookie in
     * place — and vice versa. We don't know which variant Shopify used, so try
     * host-only plus each parent domain up to (but not including) the TLD.
     *
     * Note: this cannot remove an HttpOnly cookie. If Shopify marks `cart`
     * HttpOnly on this storefront the write is a silent no-op, and /cart/clear.js
     * emptying the line items is all the reset you get. Verify in DevTools →
     * Application → Cookies rather than assuming it worked.
     */
    function deleteCookieAllScopes(name) {
      const host = window.location.hostname;
      const parts = host.split('.');
      // null = no Domain attribute at all (host-only cookie)
      const scopes = [null, host];
      for (let i = 0; i < parts.length - 1; i++) {
        scopes.push('.' + parts.slice(i).join('.'));
      }
      scopes.forEach(function (domain) {
        document.cookie =
          name +
          '=; path=/; max-age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
          (domain ? '; domain=' + domain : '');
      });
    }

    /**
     * A gift-with-purchase line a coupon put in the Shopify cart.
     *
     * Keyed on the shape a real corrupted cart actually has (B1G1 "omg" on a
     * ₹449 face wash): Shopify splits the variant into two lines with the same
     * variant_id and different keys, and zeroes the second one —
     *
     *   original_price: 44900, final_price: 0, total_discount: 44900,
     *   line_level_discount_allocations: [{ amount: 44900,
     *     discount_application: { type: 'discount_code', title: 'omg',
     *       value: '100.0', value_type: 'percentage' } }]
     *
     * So the freebie is *discounted* to zero, not natively priced at zero:
     * `original_price === 0` would never match it. It has to be `final_price`.
     *
     * The allocation check is what keeps this from firing on Shopify automatic
     * discounts, which also produce final_price: 0 but carry a discount_application
     * of type 'automatic' / 'script' rather than 'discount_code'. Without it, an
     * automatic "buy X get Y free" promo would look identical to an orphaned GWP
     * and we would empty a perfectly good cart.
     */
    function isFreeCartLine(item) {
      if (!item) return false;
      const finalPrice = Number(item.final_price != null ? item.final_price : item.price);
      if (!isFinite(finalPrice) || finalPrice !== 0) return false;
      return (item.line_level_discount_allocations || []).some(function (alloc) {
        const app = (alloc && alloc.discount_application) || {};
        return app.type === 'discount_code' && Number(alloc.amount) > 0;
      });
    }

    function cartHasFreeLineItem(cart) {
      return !!(cart && Array.isArray(cart.items) && cart.items.some(isFreeCartLine));
    }

    /**
     * Repaint after a cart recovery, on the cart page only.
     *
     * `refreshCart` dispatches `cart:refresh`, which CartDrawer listens for — it
     * re-fetches its own section from the server, so the drawer is already
     * correct. CartPageForm (global.js) listens only to `cart:change`, and reads
     * `detail.cart.sections[...]`, so it cannot be driven from here without a
     * Section Rendering payload — dispatching `cart:change` without one throws.
     * The result is a half-updated cart page: price summary and coupon cards
     * refresh, but the item rows keep rendering the pre-recovery cart.
     *
     * A reload is the honest fix rather than a partial repaint, because the clear
     * path also rotates the cart token — after which the server-rendered markup,
     * global.js's `fetchCart`, and the section HTML all reference a cart that no
     * longer exists. This runs at boot, so there is no user input to lose.
     *
     * Two guards against a reload loop, because both callers can otherwise
     * re-detect the same condition on the next load and reload again:
     *  - callers only invoke this once they have VERIFIED the cart changed
     *  - a sessionStorage one-shot, so a cart that keeps re-corrupting server-side
     *    costs one reload per session rather than an infinite cycle
     *
     * Returns true when a reload was started, so callers can skip UI work that is
     * about to be thrown away.
     */
    function reloadAfterCartRecovery() {
      if (!document.querySelector('wrapp-hdt-cart-page-form')) return false;
      try {
        if (sessionStorage.getItem(CART_RECOVERY_RELOAD_KEY) === '1') return false;
        sessionStorage.setItem(CART_RECOVERY_RELOAD_KEY, '1');
      } catch (e) {
        // Storage unavailable (private mode): skip rather than risk a loop we
        // have no way to detect. Rows stay stale until the shopper navigates.
        return false;
      }
      window.location.reload();
      return true;
    }

    /**
     * A discount code is bound to the Shopify cart that the theme has no record
     * of applying.
     *
     * This theme never puts codes on the Shopify cart — nothing calls
     * `/discount/CODE`, and the normal flow goes through the coupon service plus
     * the `discount_code` cookie (see the note above clearDiscountCartAttributes:
     * "Checkout reads discount_code from cookie only"). So for a healthy shopper
     * `discount_codes` is empty, and anything in it arrived from outside that
     * flow — a legacy token, an app, or a Shopify discount link.
     *
     * IMPORTANT: read this off a real /cart.js response, never off the coupon
     * API's `updatedCart`. The service returns `discount_codes: []` even when the
     * live cart has a code applied (it infers the conflict from the line-level
     * allocations instead), so a check against the snapshot always reports clean.
     */
    function cartHasUnknownDiscountCode(cart) {
      if (!cart || !Array.isArray(cart.discount_codes) || !cart.discount_codes.length) return false;
      return !getDiscountFromStorage()?.code;
    }

    /**
     * Strip discount codes the theme didn't apply, keeping the line items.
     *
     * A stale code doesn't just desync the UI — it hard-blocks every coupon
     * apply. The service responds:
     *
     *   { isValid: false, reason: 'COUPON_APPLY_ERROR',
     *     error_message: 'This code cannot be used with other discount codes.
     *                     Please remove any additional codes.' }
     *
     * ...and there is no UI anywhere that lets the shopper remove the other code.
     * It also silently discounts every order they place (a stale MAMA20 was
     * taking 20% off indefinitely), so this is margin leakage as well as a
     * broken coupon flow.
     *
     * `POST /cart/update.js { discount: '' }` clears all codes without touching
     * line items, so unlike the clear-cart fallback below this costs the shopper
     * nothing. Runs first for exactly that reason: on a GWP cart it reverts the
     * zeroed freebie to full price, which means clearCartIfFreeItemHasNoCoupon
     * then finds nothing to do and the cart survives.
     *
     * Returns the post-strip cart, or null if nothing was done.
     */
    async function stripUnknownDiscountCodes(cartHint) {
      if (state.unknownDiscountStripInFlight) return null;
      if (state.unknownDiscountStripped) return null;
      if (window.couponCheckInProgress || state.couponCheckInProgress) return null;
      if (state.discountRevalidateInFlight) return null;

      let cart = cartHint;
      if (!cart || !Array.isArray(cart.discount_codes)) return null;
      if (!cartHasUnknownDiscountCode(cart)) return null;

      state.unknownDiscountStripInFlight = true;
      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: '' }),
        });
        if (!res.ok) throw new Error('Failed to strip cart discount codes');
        const updated = await res.json();

        // Re-check the guards: the request above is an await, and an apply that
        // started meanwhile would have legitimately put a code on the cart.
        if (window.couponCheckInProgress || state.couponCheckInProgress) return null;

        state.unknownDiscountStripped = true;
        cacheCartData(updated);

        // Leave localStorage alone — there was nothing in it to clear, that
        // being the whole reason we treated the code as unknown.
        document.cookie = 'discount_code=; path=/; max-age=0';
        resetCouponListCache();

        // Verified: the code is actually gone, not just reported as accepted.
        // Only then is a reload safe — if Shopify kept the code, reloading would
        // re-detect it and loop, so fall through and let the clear fallback run.
        const codeActuallyGone =
          Array.isArray(updated.discount_codes) && updated.discount_codes.length === 0;
        if (codeActuallyGone && reloadAfterCartRecovery()) return updated;

        await refreshCart(updated);
        await syncCartDrawerToPayFromShopifyCart(updated);
        return updated;
      } catch (error) {
        console.error('Error stripping unknown cart discount codes:', error);
        return null;
      } finally {
        state.unknownDiscountStripInFlight = false;
      }
    }

    /**
     * Orphaned-GWP guard. Runs on every page load.
     *
     * A free line item only belongs in the cart for as long as the coupon that
     * granted it is applied. If `applied_discount` is missing from localStorage —
     * or is present but carries no code — while the Shopify cart still holds a
     * free line, that freebie has outlived its coupon and the shopper would
     * otherwise reach checkout with a gift they no longer qualify for. Empty the
     * cart via /cart/clear.js and tear the coupon session down with it.
     *
     * Deliberately NOT latched per session. A session latch was worse than no
     * latch: the free line only appears once the cart qualifies, so a shopper
     * returning with a reduced cart would burn the single check at boot — while
     * the cart still looked clean — and stay blind for the rest of the session
     * even after re-adding items brought the free line back. Re-checking every
     * page load costs one localStorage read and an array scan over the cart we
     * already fetched, and cannot loop: clearing rotates the cart token, so the
     * replacement cart carries no discount code to re-detect.
     *
     * Still skipped while an apply/remove/revalidation is in flight — those flows
     * briefly have the free line in the cart before the discount lands in
     * storage, and firing here would wipe a cart mid-apply.
     */
    async function clearCartIfFreeItemHasNoCoupon(cartHint) {
      // Page-scoped, not session-scoped: `state` lives on window, so this resets
      // on every navigation. It only stops a second clear within one page render
      // (initCouponsAndDiscount runs twice — DOMContentLoaded plus the snippet's
      // boot call — and each starts its own chain holding a pre-clear cart).
      if (state.orphanFreeItemCartCleared) return null;
      if (state.orphanFreeItemCheckInFlight) return null;
      if (window.couponCheckInProgress || state.couponCheckInProgress) return null;
      if (state.discountRevalidateInFlight) return null;

      // A coupon is live, so any free line is legitimately backed.
      const stored = getDiscountFromStorage();
      if (stored && stored.code) return null;

      state.orphanFreeItemCheckInFlight = true;
      try {
        let cart = cartHint;
        if (!cart || typeof cart.item_count === 'undefined') {
          const res = await fetch('/cart.js');
          if (!res.ok) return null;
          cart = await res.json();
          cacheCartData(cart);
        }

        // Re-check the guards: the cart fetch above is an await, so an apply
        // could have started (and written the discount) while it was in flight.
        if (window.couponCheckInProgress || state.couponCheckInProgress) return null;
        const storedNow = getDiscountFromStorage();
        if (storedNow && storedNow.code) return null;

        if (!cart.item_count || !cartHasFreeLineItem(cart)) return null;

        const clearRes = await fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        });
        if (!clearRes.ok) throw new Error('Failed to clear cart');
        const clearedCart = await clearRes.json();

        state.orphanFreeItemCartCleared = true;
        cacheCartData(clearedCart);

        // /cart/clear.js empties the line items but keeps the same cart token.
        // If the corruption is attached to the token itself rather than its
        // contents, that isn't enough — drop the `cart` cookie so Shopify issues
        // a brand-new token on the next request. Must happen after the POST,
        // whose own response re-sets it.
        deleteCookieAllScopes('cart');

        // No cart means no coupon session — drop the same state the remove flow does.
        deleteCookieAllScopes('discount_code');
        clearDiscountFromStorage();
        clearFreeProductsFromStorage();
        resetCouponListCache();

        const discountRow = document.querySelector('.applied-coupon-discount');
        if (discountRow) discountRow.remove();
        hideFreeProductsInCart();
        window.appliedDiscount = null;

        // Verified empty before reloading — and the token was just rotated, so a
        // reload is the only way to get the cart page's server-rendered rows,
        // global.js's fetchCart and the section markup onto the new cart.
        if (!clearedCart.item_count && reloadAfterCartRecovery()) return clearedCart;

        await refreshCart(clearedCart);
        await syncCartDrawerToPayFromShopifyCart(clearedCart);
        return clearedCart;
      } catch (error) {
        console.error('Error clearing cart with orphaned free item:', error);
        return null;
      } finally {
        state.orphanFreeItemCheckInFlight = false;
      }
    }

    function hasAppliedCouponOnCart(cart) {
      if (cart && cart._displaySource === 'updatedCart') return true;
      const attrs = cartAttributesObject(cart);
      if (attrs.discount_applied === 'true' || attrs.discount_applied === true) return true;
      const codes = cart.discount_codes || [];
      if (codes.some(function (c) {
        return c.applicable;
      })) {
        return true;
      }
      return (cart.cart_level_discount_applications || []).length > 0;
    }

    function computeLineItemsDiscountCents(cart) {
      let total = 0;
      (cart.items || []).forEach(function (item) {
        const orig = Number(item.original_line_price) || 0;
        const fin = item.final_line_price != null ? Number(item.final_line_price) : orig;
        total += Math.max(0, orig - fin);
      });
      return total;
    }

    function computeCouponLineDiscountCents(cart) {
      let total = 0;
      (cart.items || []).forEach(function (item) {
        (item.line_level_discount_allocations || []).forEach(function (alloc) {
          const app = alloc.discount_application || {};
          if (app.type === 'discount_code') {
            total += Number(alloc.amount) || 0;
          }
        });
      });
      return total;
    }

    /** Product/compare-at savings only — excludes coupon line allocations. */
    function computeProductItemsDiscountCents(cart) {
      return Math.max(0, computeLineItemsDiscountCents(cart) - computeCouponLineDiscountCents(cart));
    }

    function removeDynamicPriceSummaryDiscountRows(subtotalContainer) {
      if (!subtotalContainer) return;
      subtotalContainer
        .querySelectorAll(
          '.items-discount-row, .applied-coupon-discount, .prepaid-discount-row, [data-cart-summary-discount]'
        )
        .forEach(function (row) {
          row.remove();
        });
    }

    function paintItemsDiscountRow(cents, subtotalContainer) {
      const amount = Number(cents);
      if (!amount || amount <= 0 || !subtotalContainer) return;

      const formatted = '-' + formatMoneyFromCartCents(amount);
      const row = document.createElement('div');
      row.className = 'hdt-price-summary__row hdt-price-summary__row--discount items-discount-row';
      row.innerHTML =
        '<span>Items Discount</span>' +
        '<span class="hdt-price-summary__discount hdt-money">' +
        formatted +
        '</span>';
      insertPriceSummaryRowBeforeShipping(row, subtotalContainer);
    }

    function insertPriceSummaryRowBeforeDivider(row, subtotalContainer) {
      const divider =
        subtotalContainer && subtotalContainer.querySelector('.hdt-price-summary__divider');
      if (divider && divider.parentNode) {
        divider.parentNode.insertBefore(row, divider);
        return true;
      }
      return false;
    }

    function paintPrepaidDiscountRow(cents, subtotalContainer) {
      const amount = Number(cents);
      if (!amount || amount <= 0 || !subtotalContainer) return;

      const row = document.createElement('div');
      row.className =
        'hdt-price-summary__row hdt-price-summary__row--discount prepaid-discount-row';
      row.innerHTML =
        '<span>Prepaid Discount</span>' +
        '<span class="hdt-price-summary__discount hdt-money">-' +
        formatMoneyFromCartCents(amount) +
        '</span>';
      insertPriceSummaryRowBeforeDivider(row, subtotalContainer);
    }

    function discountAmountToCents(raw) {
      const rawNum = Number(raw);
      if (!isFinite(rawNum)) return 0;
      const isWhole = Math.abs(rawNum - Math.round(rawNum)) < 1e-9;
      return isWhole && rawNum >= 10000 ? Math.round(rawNum) : Math.round(rawNum * 100);
    }

    function meaningfulCartDiscountCents(raw) {
      const cents = Math.round(Number(raw));
      return isFinite(cents) && cents >= 1 ? cents : 0;
    }

    function computeOfferDiscountCentsFromCart(cart) {
      if (cart && cart._displaySource === 'updatedCart') {
        const totalDiscount = meaningfulCartDiscountCents(cart.total_discount);
        if (totalDiscount > 0) return totalDiscount;
        if (cart.discount && cart.discount.total_discount != null) {
          const couponDiscount = discountAmountToCents(cart.discount.total_discount);
          if (couponDiscount > 0) return couponDiscount;
        }
        const orig = Number(cart.original_total_price) || 0;
        const net = Number(cart.total_price) || 0;
        if (orig > net) return orig - net;
      }

      let total = 0;

      (cart.cart_level_discount_applications || []).forEach(function (app) {
        const amt =
          app.total_allocated_amount != null
            ? Number(app.total_allocated_amount)
            : Number(app.amount || 0);
        if (amt > 0) total += amt;
      });
      if (total > 0) return total;

      (cart.items || []).forEach(function (item) {
        (item.line_level_discount_allocations || []).forEach(function (alloc) {
          const app = alloc.discount_application || {};
          if (app.type === 'discount_code') {
            const amt = Number(alloc.amount) || 0;
            if (amt > 0) total += amt;
          }
        });
      });
      if (total > 0) return total;

      const attrs = cartAttributesObject(cart);
      const attrAmt = Number(attrs.discount_amount);
      if (attrAmt > 0) return Math.round(attrAmt * 100);

      return meaningfulCartDiscountCents(cart.total_discount);
    }

    function paintOfferDiscountRow(cart, subtotalContainer) {
      const amt = computeOfferDiscountCentsFromCart(cart);
      if (!amt || amt <= 0 || !subtotalContainer) return;

      const applicableCode = (cart.discount_codes || []).find(function (c) {
        return c.applicable;
      });
      const attrs = cartAttributesObject(cart);
      const couponCode =
        (applicableCode && applicableCode.code) || attrs.discount_code || 'offer';

      const row = document.createElement('div');
      row.className =
        'hdt-price-summary__row hdt-price-summary__row--discount applied-coupon-discount';
      row.setAttribute('data-cart-summary-discount', '');
      row.setAttribute('data-coupon-code', String(couponCode).toLowerCase());
      row.innerHTML =
        '<span>' + (cart && cart._displaySource === 'updatedCart' ? 'Item Discounts' : 'Offer Discount') + '</span>' +
        '<span class="hdt-price-summary__discount hdt-money">-' +
        formatMoneyFromCartCents(amt) +
        '</span>';
      insertPriceSummaryRowBeforeShipping(row, subtotalContainer);
    }

    function computeHeaderSavingCents(cart) {
      if (!cart) return 0;
      let total = computeProductItemsDiscountCents(cart);
      if (hasAppliedCouponOnCart(cart)) {
        total += computeOfferDiscountCentsFromCart(cart);
      }
      if (Number(cart.item_count) > 0) {
        total += computeCartTotals(cart).prepaidDiscountCents;
      }
      return total;
    }

    function buildHeaderSavingBanner() {
      const banner = document.createElement('div');
      banner.className = 'hdt-mini-cart__header-saving';
      banner.setAttribute('role', 'status');
      banner.setAttribute('aria-live', 'polite');
      banner.innerHTML =
        '<div class="hdt-mini-cart__header-saving-row">' +
        '<span class="hdt-mini-cart__header-saving-icon" aria-hidden="true"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.8 8.3999L9.64043 15.5999L7.19995 13.1456" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
        '<span class="hdt-mini-cart__header-saving-message">You saved <strong></strong> on this order</span>' +
        '</div>' +
        '<div class="hdt-mini-cart__header-cashback-row">' +
        '<span class="hdt-mini-cart__header-cashback-icon" aria-hidden="true"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.8 8.3999L9.64043 15.5999L7.19995 13.1456" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
        '<span class="hdt-mini-cart__header-cashback-message"></span>' +
        '</div>';
      return banner;
    }

    function updateHeaderSavingBanner(banner, savingCents, cashbackContent) {
      if (!banner) return false;

      const savingRow = banner.querySelector('.hdt-mini-cart__header-saving-row');
      const cashbackRow = banner.querySelector('.hdt-mini-cart__header-cashback-row');
      const hasSaving = Number(savingCents) > 0;
      const hasCashback = !!cashbackContent;

      if (savingRow) {
        if (hasSaving) {
          const formatted = formatMoneyFromCartCents(savingCents);
          const strong = savingRow.querySelector('strong');
          if (strong && formatted) strong.textContent = formatted;
          savingRow.style.display = 'flex';
        } else {
          savingRow.style.display = 'none';
        }
      }

      if (cashbackRow) {
        const messageEl = cashbackRow.querySelector('.hdt-mini-cart__header-cashback-message');
        if (hasCashback) {
          if (messageEl) {
            if (cashbackContent.html) {
              messageEl.innerHTML = cashbackContent.html;
            } else {
              messageEl.textContent = cashbackContent.text || '';
            }
          }
          cashbackRow.style.display = 'flex';
        } else {
          if (messageEl) {
            messageEl.textContent = '';
            messageEl.innerHTML = '';
          }
          cashbackRow.style.display = 'none';
        }
      }

      return hasSaving || hasCashback;
    }

    function ensureHeaderSavingBannerStructure(banner) {
      if (!banner) return null;
      if (
        banner.querySelector('.hdt-mini-cart__header-saving-row') &&
        banner.querySelector('.hdt-mini-cart__header-cashback-row')
      ) {
        return banner;
      }
      const upgraded = buildHeaderSavingBanner();
      banner.replaceWith(upgraded);
      return upgraded;
    }

    function syncHeaderSavingSlot(slot, savingCents, cashbackContent) {
      if (!slot) return;
      const showBanner = Number(savingCents) > 0 || !!cashbackContent;
      let banner = slot.querySelector('.hdt-mini-cart__header-saving');

      if (!showBanner) {
        if (banner) banner.remove();
        return;
      }
      if (!banner) {
        banner = buildHeaderSavingBanner();
        slot.appendChild(banner);
      } else {
        banner = ensureHeaderSavingBannerStructure(banner);
      }
      updateHeaderSavingBanner(banner, savingCents, cashbackContent);
    }

    function getCashbackDataFromCart(cart) {
      const discount = cart && cart.discount;
      if (discount) {
        if (discount.cashback_data) return discount.cashback_data;
        if (discount.cashbackData) return discount.cashbackData;
      }
      const stored = getDiscountFromStorage();
      if (stored && stored.data) {
        return stored.data.cashback_data || stored.data.cashbackData || null;
      }
      return null;
    }

    function resolveCashbackBannerContent(cashbackData) {
      if (!cashbackData || typeof cashbackData !== 'object') return null;

      const amount = Number(cashbackData.amount);
      if (isFinite(amount) && amount > 0) {
        const formattedAmount =
          Math.abs(amount - Math.round(amount)) < 1e-9
            ? String(Math.round(amount))
            : String(amount);
        return {
          html:
            'Cashback of <strong>₹' +
            formattedAmount +
            '</strong> to be credited after delivery',
        };
      }

      const customMessage =
        cashbackData.custom_message != null ? String(cashbackData.custom_message).trim() : '';
      if (customMessage) return { text: customMessage };

      return null;
    }

    function syncCartHeaderSaving(cart) {
      if (!cart || typeof cart.item_count === 'undefined') return;

      const displayCart = getDisplayCart(cart) || cart;
      const savingCents = computeHeaderSavingCents(displayCart);
      const cashbackContent = resolveCashbackBannerContent(getCashbackDataFromCart(displayCart));
      const showBanner = savingCents > 0 || !!cashbackContent;

      const drawer = document.getElementById('CartDrawer');
      if (drawer) {
        let banner = drawer.querySelector('.hdt-mini-cart__header-saving');

        if (!showBanner) {
          if (banner) banner.remove();
        } else {
          if (!banner) {
            banner = buildHeaderSavingBanner();
            const threshold = drawer.querySelector('.hdt-mini-cart__threshold');
            const wrap = drawer.querySelector('.hdt-mini-cart__wrap');
            if (threshold) {
              drawer.insertBefore(banner, threshold);
            } else if (wrap) {
              drawer.insertBefore(banner, wrap);
            } else {
              drawer.appendChild(banner);
            }
          } else {
            banner = ensureHeaderSavingBannerStructure(banner);
          }
          updateHeaderSavingBanner(banner, savingCents, cashbackContent);
        }
      }

      const popupSlot = document.querySelector('#coupon_view_all_root .coupon-full-saving-slot');
      syncHeaderSavingSlot(popupSlot, savingCents, cashbackContent);
    }

    function buildLineItemPriceHtml(item) {
      const finalPrice =
        Number(
          item.final_price != null
            ? item.final_price
            : item.discounted_price != null
              ? item.discounted_price
              : item.price
        ) || 0;
      const originalPrice = Number(item.original_price != null ? item.original_price : item.price) || finalPrice;
      const lineFinal =
        item.final_line_price != null ? Number(item.final_line_price) : finalPrice * (item.quantity || 1);

      if (finalPrice === 0 || lineFinal === 0) {
        const originalText = formatMoneyFromCartCents(originalPrice);
        return (
          '<div class="hdt-price__item hdt-price__list hdt-price__item--free hdt-price-wrapp">' +
          '<hdt-compare-at-price class="hdt-compare-at-price">' +
          '<span class="hdt-money">' + originalText + '</span>' +
          '</hdt-compare-at-price>' +
          '<span class="hdt-line-item-free-label">FREE</span></div>'
        );
      }

      const saleFormatted = formatMoneyFromCartCents(finalPrice);
      const compareFormatted = formatMoneyFromCartCents(originalPrice);
      const showCompare = originalPrice > finalPrice;
      const discountPct = showCompare
        ? Math.round(((originalPrice - finalPrice) * 100) / originalPrice)
        : 0;

      let html = '<div class="hdt-price__item hdt-price__list hdt-price-wrapp">';
      html +=
        '<hdt-price class="hdt-price"><span class="sr-only">Sale price</span>' +
        '<span class="hdt-money">' +
        saleFormatted +
        '</span></hdt-price>';
      if (showCompare) {
        html +=
          '<hdt-compare-at-price class="hdt-compare-at-price"><span class="sr-only">Regular price</span>' +
          '<span class="hdt-money">' +
          compareFormatted +
          '</span></hdt-compare-at-price>';
      }
      if (discountPct > 0) {
        html += '<span class="hdt-line-discount-percentage">' + discountPct + '%OFF</span>';
      }
      html += '</div>';
      return html;
    }

    /** Paint line-item prices from display cart (updatedCart when coupon active, native cart otherwise). */
    function syncCartLineItemPrices(displayCart) {
      if (!displayCart || !Array.isArray(displayCart.items)) return;

      displayCart.items.forEach(function (item) {
        const variantId = item.variant_id;
        if (!variantId) return;

        document
          .querySelectorAll('hdt-line-item[data-variant-id="' + variantId + '"]')
          .forEach(function (lineEl) {
            const priceWrap = lineEl.querySelector('.hdt-mini-cart__price');
            if (!priceWrap) return;
            priceWrap.innerHTML = buildLineItemPriceHtml(item);
          });
      });
    }

    /** Single source of truth: price summary + line items mirror display cart (updatedCart when coupon active). */
    function syncPriceSummaryFromCart(shopifyCartHint) {
      const shopifyCart =
        shopifyCartHint && typeof shopifyCartHint.item_count !== 'undefined'
          ? shopifyCartHint
          : state.lastCartData || lastCartData;
      const cart = getDisplayCart(shopifyCart);
      if (!cart || typeof cart.item_count === 'undefined') return;

      syncCartLineItemPrices(cart);

      const totals = computeCartTotals(cart);
      // HVC threshold: discounted To Pay (rechecks after coupon apply via same path).
      syncHighValueCartRestriction(totals.toPayCents);
      const toPay = formatMoneyFromCartCents(totals.toPayCents);

      document.querySelectorAll('.hdt-cart-totals-discounts').forEach(function (subtotalContainer) {
        syncShippingDisplayInPriceSummary(cart, subtotalContainer);

        const orderTotalEl = subtotalContainer.querySelector('[data-price-summary-order-total]');
        const orderTotalCents = totals.orderTotalCents;
        if (orderTotalEl) {
          orderTotalEl.textContent = formatMoneyFromCartCents(orderTotalCents);
        } else {
          const firstMoney = subtotalContainer.querySelector('.hdt-price-summary__row .hdt-money');
          if (firstMoney) firstMoney.textContent = formatMoneyFromCartCents(orderTotalCents);
        }

        removeDynamicPriceSummaryDiscountRows(subtotalContainer);

        const itemsDisc = computeProductItemsDiscountCents(cart);
        const hasCoupon = hasAppliedCouponOnCart(cart);
        const offerDisc = hasCoupon ? computeOfferDiscountCentsFromCart(cart) : 0;

        if (offerDisc > 0) {
          paintOfferDiscountRow(cart, subtotalContainer);
        } else if (itemsDisc > 0) {
          paintItemsDiscountRow(itemsDisc, subtotalContainer);
        }

        if (cart.item_count > 0) {
          paintPrepaidDiscountRow(totals.prepaidDiscountCents, subtotalContainer);
        }
      });

      if (toPay) updateCartDrawerToPayDisplays(toPay);

      syncCartHeaderSaving(cart);
    }

    function getPriceSummaryShippingRow(subtotalContainer) {
      return (
        (subtotalContainer &&
          subtotalContainer.querySelector('.hdt-price-summary__row--shipping')) ||
        null
      );
    }

    /** Insert a summary row between Order Total and Shipping. */
    function insertPriceSummaryRowBeforeShipping(row, subtotalContainer) {
      const shippingRow = getPriceSummaryShippingRow(subtotalContainer);
      if (shippingRow && shippingRow.parentNode) {
        shippingRow.parentNode.insertBefore(row, shippingRow);
        return true;
      }
      const divider = subtotalContainer && subtotalContainer.querySelector('.hdt-price-summary__divider');
      if (divider && divider.parentNode) {
        divider.parentNode.insertBefore(row, divider);
        return true;
      }
      return false;
    }

    /** Line-item savings from cart.js when no coupon is applied. */
    function showItemsDiscountRow(totalDiscountCents) {
      const amount = Number(totalDiscountCents);
      if (!amount || amount <= 0) {
        removeItemsDiscountRow();
        return;
      }

      const subtotalContainer = document.querySelector('.hdt-cart-totals-discounts');
      if (!subtotalContainer) return;

      removeItemsDiscountRow();
      paintItemsDiscountRow(amount, subtotalContainer);
    }

    function syncShippingDisplayInPriceSummary(cart, subtotalContainer) {
      const root = subtotalContainer || document;
      const shippingWrap = root.querySelector(
        '.hdt-price-summary__row--shipping .hdt-price-summary__shipping'
      );
      if (!shippingWrap || !cart) return;

      const feeFormatted = formatMoneyFromCartCents(SHIPPING_FEE_CENTS);
      if (getCartNetSubtotalCents(cart) > FREE_SHIPPING_THRESHOLD_CENTS) {
        shippingWrap.innerHTML =
          '<span class="hdt-price-summary__free">Free</span>' +
          '<span class="hdt-price-summary__shipping-cut hdt-money">' +
          feeFormatted +
          '</span>';
      } else {
        shippingWrap.innerHTML = '<span class="hdt-money">' + feeFormatted + '</span>';
      }
    }

    /** Keeps price summary “To pay” and sticky checkout bar amount in sync (both are separate DOM nodes). */
    function updateCartDrawerToPayDisplays(formattedText) {
      if (!formattedText) return;
      document
        .querySelectorAll('.hdt-price-summary__row--total .hdt-mini-cart__value')
        .forEach(function (el) {
          el.textContent = formattedText;
        });
      document.querySelectorAll('.hdt-mini-cart__checkout-pay-amount').forEach(function (el) {
        el.textContent = formattedText;
      });
    }

    function applyCartDrawerToPayFromCart(cart) {
      syncPriceSummaryFromCart(cart);
    }

    async function syncCartDrawerToPayFromShopifyCart(cartHint) {
      const shopifyCart = cartHint || state.lastCartData || lastCartData;
      if (shopifyCart && typeof shopifyCart.item_count !== 'undefined') {
        applyCartDrawerToPayFromCart(shopifyCart);
        return;
      }
      try {
        const r = await fetch('/cart.js');
        if (!r.ok) return;
        const cart = await r.json();
        cacheCartData(cart);
        applyCartDrawerToPayFromCart(cart);
      } catch (e) {
        /* ignore */
      }
    }

    function normalizeCouponLabelForDedupe(s) {
      return String(s || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ');
    }

    function trackCouponAnalyticsEvent(eventName, couponCode) {
      const normalizedCode = String(couponCode || '').trim();
      if (!normalizedCode) return;
      const payload = { coupon_name: normalizedCode, couponName:normalizedCode };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, payload));
      try {
        if (typeof window.trackME === 'function') {
          window.trackME(eventName, payload);
        }
      } catch (e) {
        console.warn('MoEngage track failed:', eventName, e);
      }
    }

    function pushCouponSuccessToDataLayer(couponCode) {
      trackCouponAnalyticsEvent('coupon_success', couponCode);
    }
    function pushCouponAppliedToDataLayer(couponCode) {
      trackCouponAnalyticsEvent('coupon_applied', couponCode);
      trackCouponAnalyticsEvent('applyCoupon', couponCode);
    }
    function pushCouponRemovedToDataLayer(couponCode) {
      trackCouponAnalyticsEvent('coupon_removed', couponCode);
    }
    window.pushCouponSuccessToDataLayer = pushCouponSuccessToDataLayer;
    window.pushCouponAppliedToDataLayer = pushCouponAppliedToDataLayer;
    window.pushCouponRemovedToDataLayer = pushCouponRemovedToDataLayer;

    /**
     * Price summary already lists Shopify `cart_level_discount_applications` from Liquid
     * (snippets/price-summary-card.liquid). We inject `.applied-coupon-discount` for remove UX.
     * Without this, the same code appears twice when titles differ only by case (e.g. double30 vs DOUBLE30).
     */
    function removeShopifyPriceSummaryRowsMatchingCoupon(subtotalContainer, couponCode, discountData) {
      const codeNorm = normalizeCouponLabelForDedupe(couponCode);
      const titleNorm = normalizeCouponLabelForDedupe(
        discountData &&
          (discountData.title || discountData.discount_title || discountData.message)
      );

      subtotalContainer
        .querySelectorAll('.hdt-price-summary__row--discount:not(.applied-coupon-discount)')
        .forEach(function (row) {
          const labelEl = row.querySelector('span');
          if (!labelEl) return;
          const labelNorm = normalizeCouponLabelForDedupe(labelEl.textContent);
          if (!labelNorm) return;
          if (codeNorm && labelNorm === codeNorm) {
            row.remove();
            return;
          }
          if (titleNorm && labelNorm === titleNorm) {
            row.remove();
          }
        });
    }

    // Persist coupon state; price summary + line items use display cart (updatedCart when active).
    function showDiscountInSubtotal(discountData, couponCode, updatedCart, appliedCoupon) {
      window.appliedDiscount = {
        code: couponCode,
        amount: (discountData && discountData.total_discount) || 0,
        total: (discountData && discountData.total_price) || 0,
        data: discountData,
      };

      saveDiscountToStorage(discountData, couponCode, updatedCart, appliedCoupon);
      restoreDiscount(state.lastCartData || lastCartData);
    }

    // Re-sync price summary from display cart (updatedCart when coupon active).
    function restoreDiscount(cartHint) {
      const shopifyCart = cartHint || state.lastCartData || lastCartData;
      if (shopifyCart && typeof shopifyCart.item_count !== 'undefined') {
        syncPriceSummaryFromCart(shopifyCart);
        return;
      }
      syncCartDrawerToPayFromShopifyCart();
    }

    /**
     * Re-apply the stored coupon against the current cart so coupon state stays valid
     * after qty add/remove. Price summary uses display cart via restoreDiscount.
     */
    function cancelRevalidateDebounce() {
      clearTimeout(state.discountRevalidateDebounceTimer);
      state.discountRevalidateDebounceTimer = null;
      // Pending revalidate will not run; allow the next price sync to paint HVC.
      if (state.highValueCartDeferForCoupon && !state.discountRevalidateInFlight) {
        state.highValueCartDeferForCoupon = false;
      }
    }

    /**
     * Clear a coupon that the apply API says is no longer valid for the current cart.
     * Used when cart changes (qty/items) invalidate a previously applied coupon.
     */
    // Only called from revalidateAppliedDiscount, which already holds the
    // coupon-removal barrier open for its full duration (including this call) -
    // no separate begin/end here to avoid closing it early.
    async function clearInvalidAppliedCoupon(couponCode, cartData) {
      cancelRevalidateDebounce();
      window.couponCheckInProgress = true;
      state.couponCheckInProgress = true;

      var compositionChanged = false;

      try {
        // Snapshot cart composition before clear
        const cartBeforeRemove = cartData;

        try {
          await removeCouponAPI(couponCode, cartData);
        } catch (e) {
          // Best effort — apply API already reported the coupon as invalid.
        }

        const updatedCart = await clearDiscountCartAttributes();

        // Check if cart composition changed
        compositionChanged = !isCartCompositionUnchanged(cartBeforeRemove, updatedCart || cartData);

        document.cookie = 'discount_code=; path=/; max-age=0';
        clearDiscountFromStorage();
        clearFreeProductsFromStorage();
        
        // Phase 1: Only reset cache if composition changed
        if (compositionChanged) {
          resetCouponListCache();
        } else {
          // Clear only the applied code, keep the list cache
          state.lastAppliedCode = '';
        }

        const discountRow = document.querySelector('.applied-coupon-discount');
        if (discountRow) discountRow.remove();
        hideFreeProductsInCart();
        window.appliedDiscount = null;

        restoreManualCouponInput();

        await refreshCart(updatedCart);
        await syncCartDrawerToPayFromShopifyCart(updatedCart || state.lastCartData);
      } finally {
        setTimeout(function () {
          window.couponCheckInProgress = false;
          state.couponCheckInProgress = false;

          // Phase 1: Only fetch fresh list if composition changed
          if (compositionChanged) {
            if (typeof window.loadCoupons === 'function') window.loadCoupons(true, state.lastCartData);
          } else {
            // Cart composition unchanged - re-render from cache without API call
            reRenderCouponsFromCacheAfterRemove();
          }
        }, 1000);
      }
    }

    // Single cold-start / drawer-open restore: localStorage + display cart — no apply API.
    function restoreCouponSession(cartHint, options) {
      const opts = options || {};
      const delay = opts.immediate ? 0 : 100;
      const cart = cartHint || state.lastCartData;

      rehydrateCouponsFromCache();

      if (cart && typeof cart.item_count !== 'undefined') {
        syncPriceSummaryFromCart(cart);
      } else {
        syncCartDrawerToPayDebounced();
      }

      setTimeout(restoreFreeProductsInCart, delay + 20);
      setTimeout(initManualCouponInput, delay + 50);
      setTimeout(restoreManualCouponInput, delay + 100);

      if (opts.skipListLoad) return;

      if (typeof window.loadCoupons === 'function') {
        window.loadCoupons(opts.forceListRefresh === true, cartHint || state.lastCartData);
      }
    }

    /**
     * Returns true when the stored coupon was actually reconciled against a
     * source of truth (the apply API, a fresh snapshot, or an emptied cart), and
     * false when nothing was decided — a transient guard, a superseded request,
     * or a network failure. Existing callers ignore the value; the cold-start
     * latch (revalidateAppliedDiscountOncePerSession) uses it to avoid spending
     * the session's one validation on a failure.
     */
    async function revalidateAppliedDiscount(cartHint) {
      const storedDiscount = getDiscountFromStorage();
      if (!storedDiscount || !storedDiscount.code) {
        flushHighValueCartAfterCouponSettle();
        return false;
      }
      if (state.discountRevalidateInFlight) return false;
      // Never revalidate while apply/remove is in flight — init + cart:refresh
      // fire during that window and were clearing a freshly applied coupon.
      if (window.couponCheckInProgress || state.couponCheckInProgress) {
        // Apply/remove owns the next price sync; don't leave HVC deferred.
        state.highValueCartDeferForCoupon = false;
        return false;
      }

      const couponCode = storedDiscount.code;
      const requestId = ++state.discountRevalidateRequestId;
      state.discountRevalidateInFlight = true;
      // Gate the whole revalidation, not just an eventual removal: a List API
      // call scheduled by the same cart change (see handleCartDataUpdate) must
      // wait for this to resolve either way, since it decides whether the
      // applied coupon (and therefore other coupons' stacking eligibility)
      // still holds.
      var releaseCouponRemovalBarrier = beginCouponRemovalBarrier();

      try {
        let cartData = cartHint || state.lastCartData || lastCartData;
        if (!cartData || typeof cartData.item_count === 'undefined') {
          const cartResponse = await fetch('/cart.js');
          if (!cartResponse.ok) throw new Error('Failed to fetch cart');
          cartData = await cartResponse.json();
        }
        if (requestId !== state.discountRevalidateRequestId) return false;

        cacheCartData(cartData);

        if (!cartData.item_count) {
          clearDiscountFromStorage();
          clearFreeProductsFromStorage();
          const discountRow = document.querySelector('.applied-coupon-discount');
          if (discountRow) discountRow.remove();
          hideFreeProductsInCart();
          window.appliedDiscount = null;
          await syncCartDrawerToPayFromShopifyCart(cartData);
          return true;
        }

        const snapshot = getAppliedCouponUpdatedCart();
        if (
          state.couponSnapshotRefreshedAt &&
          Date.now() - state.couponSnapshotRefreshedAt < 30000 &&
          snapshot &&
          isCouponSnapshotFresh(snapshot, cartData)
        ) {
          restoreDiscount(cartData);
          const storedForFree = getDiscountFromStorage();
          if (storedForFree && storedForFree.code) {
            const freeStored = getFreeProductsFromStorage();
            if (freeStored && freeStored.code === storedForFree.code) {
              syncFreeProductsUi(freeStored.items || [], storedForFree.code, cartData);
            }
          }
          renderOutsideCouponsFromCache();
          return true;
        }

        const result = await applyCouponAPI(couponCode, cartData);
        if (requestId !== state.discountRevalidateRequestId) return false;

        if (!result.success) {
          restoreDiscount(cartData);
          return false;
        }

        // Use the same helper function that all other apply flows use
        const appliedCoupon = resolveValidAppliedCoupon(result, couponCode);

        if (appliedCoupon) {
          const discountData = result.data?.updatedCart?.discount || appliedCoupon;

          // Always repaint — cart section re-renders wipe the discount row from the DOM.
          // Use stored updatedCart if API doesn't return one to ensure snapshot timestamp is updated
          const updatedCartForStorage = result.data?.updatedCart || storedDiscount.updatedCart || null;
          showDiscountInSubtotal(discountData, couponCode, updatedCartForStorage, appliedCoupon);

          const freeProducts = appliedCoupon.free_products || [];
          syncFreeProductsUi(freeProducts, couponCode, cartData);
          renderOutsideCouponsFromCache(couponCode);
          return true;
        }

        // Apply API succeeded but coupon is invalid for the current cart — remove stale UI/state.
        await clearInvalidAppliedCoupon(couponCode, cartData);
        return true;
      } catch (error) {
        console.error('Error revalidating applied discount:', error);
        restoreDiscount(state.lastCartData);
        return false;
      } finally {
        endCouponRemovalBarrier(releaseCouponRemovalBarrier);
        if (requestId === state.discountRevalidateRequestId) {
          state.discountRevalidateInFlight = false;
        }
        // Paint HVC once with post-revalidate display cart (skips early cart:change paints).
        flushHighValueCartAfterCouponSettle();
      }
    }

    function hasRunColdStartRevalidation() {
      try {
        if (sessionStorage.getItem(COLD_START_REVALIDATE_KEY) === '1') return true;
      } catch (e) {
        /* storage unavailable — fall through to the in-memory mirror */
      }
      return state.coldStartRevalidateDone === true;
    }

    function markColdStartRevalidationRun() {
      state.coldStartRevalidateDone = true;
      try {
        sessionStorage.setItem(COLD_START_REVALIDATE_KEY, '1');
      } catch (e) {
        /* ignore quota / private-mode failures */
      }
    }

    function unmarkColdStartRevalidationRun() {
      state.coldStartRevalidateDone = false;
      try {
        sessionStorage.removeItem(COLD_START_REVALIDATE_KEY);
      } catch (e) {
        /* ignore */
      }
    }

    /**
     * Cold-start revalidation, once per browsing session.
     *
     * Removing the 24h TTL from `applied_discount` means a stored coupon now
     * survives indefinitely — but revalidateAppliedDiscount is otherwise only
     * reached from the cart:change handler, so a returning user's coupon was
     * repainted from localStorage and never checked against the backend. A
     * coupon that expired while they were away stayed visually applied (with a
     * discount row and an inflated saving) until they happened to change the
     * cart. The TTL had been acting as an accidental revalidation trigger; this
     * replaces it with an explicit one.
     *
     * Called synchronously from initCouponsAndDiscount, deliberately: everything
     * in revalidateAppliedDiscount up to beginCouponRemovalBarrier() runs before
     * its first await, so calling it without awaiting still establishes the
     * barrier before restoreCouponSession reaches loadCoupons. Same ordering
     * requirement the cart:change handler documents at its own call site —
     * without it the List API can render a stale, coupon-still-applied list.
     *
     * Mutually exclusive with clearCartIfFreeItemHasNoCoupon by construction:
     * that one only proceeds when no coupon is stored, this one only when a
     * coupon is stored. They can never act on the same page load.
     */
    function revalidateAppliedDiscountOncePerSession(cartHint) {
      if (hasRunColdStartRevalidation()) {
        // Latch already spent this tab (typical after partnership checkout).
        // Still drop a leftover coupon sitting on an emptied cart so the next
        // add-to-cart cannot re-apply it or overlay its snapshot totals.
        discardCouponSessionIfCartEmpty(cartHint);
        return;
      }
      // Nothing stored to reconcile. Don't latch — a coupon applied later this
      // session is validated by the apply call itself, and re-reaching this
      // guard costs one localStorage read.
      if (!getDiscountFromStorage()?.code) return;
      // Transient — don't latch, the next navigation gets to try again.
      if (state.discountRevalidateInFlight) return;
      if (window.couponCheckInProgress || state.couponCheckInProgress) return;

      markColdStartRevalidationRun();
      state.highValueCartDeferForCoupon = true;
      Promise.resolve(revalidateAppliedDiscount(cartHint))
        .then(function (evaluated) {
          // A transient guard, superseded request or failed apply call decided
          // nothing. Release the latch so the coupon is still checked this
          // session rather than riding to checkout unvalidated.
          if (!evaluated) unmarkColdStartRevalidationRun();
        })
        .catch(function () {
          unmarkColdStartRevalidationRun();
        });
    }

    function revalidateAppliedDiscountDebounced() {
      if (!getDiscountFromStorage()?.code) return;
      if (window.couponCheckInProgress || state.couponCheckInProgress) return;
      clearTimeout(state.discountRevalidateDebounceTimer);
      state.discountRevalidateDebounceTimer = setTimeout(function () {
        state.discountRevalidateDebounceTimer = null;
        revalidateAppliedDiscount(state.lastCartData);
      }, DEBOUNCE_DELAY);
    }

    // The qty / remove handlers in global.js end the cart loader as soon as
    // change.js returns, but the coupon revalidate and /coupons/list refresh
    // that cart:change schedules only start DEBOUNCE_DELAY later. Without a
    // hold, the drawer shows stale savings / To Pay / offer copy for a few
    // seconds with no loader, then jumps. The loader is ref-counted, so taking
    // our own hold inside the cart:change dispatch (before the caller's
    // `finally` ends its own) keeps it up until the coupon work settles.
    const COUPON_SETTLE_POLL_MS = 100;
    const COUPON_SETTLE_MAX_MS = 6000;

    function couponSettleWorkPending() {
      return !!(
        state.discountRevalidateDebounceTimer ||
        state.discountRevalidateInFlight ||
        state.couponListQueued ||
        state.loadInFlight ||
        state.pendingReload ||
        state.couponRemovalBarrier
      );
    }

    function releaseCouponSettleLoader() {
      clearTimeout(state.couponSettleTimer);
      state.couponSettleTimer = null;
      if (state.couponSettleLoaderScope) {
        endCartActionLoader(state.couponSettleLoaderScope);
        state.couponSettleLoaderScope = null;
      }
    }

    function pollCouponSettle() {
      clearTimeout(state.couponSettleTimer);
      state.couponSettleTimer = setTimeout(function () {
        const timedOut = Date.now() - state.couponSettleStartedAt > COUPON_SETTLE_MAX_MS;
        if (couponSettleWorkPending() && !timedOut) {
          pollCouponSettle();
          return;
        }
        releaseCouponSettleLoader();
      }, COUPON_SETTLE_POLL_MS);
    }

    function holdCartLoaderUntilCouponsSettle() {
      if (!state.couponSettleLoaderScope) {
        const scope = startCartActionLoader(null, null);
        if (!scope) return;
        state.couponSettleLoaderScope = scope;
      }
      state.couponSettleStartedAt = Date.now();
      pollCouponSettle();
    }

    // Function to remove applied coupon
    window.removeCouponFn = async function (code, buttonElement, options) {
      
      // Get coupon code from parameter, button, or stored discount
      const couponCode =
        code ||
        (buttonElement && buttonElement.getAttribute('data-code')) ||
        (window.appliedDiscount && window.appliedDiscount.code) ||
        (getDiscountFromStorage() && getDiscountFromStorage().code);

      if (!couponCode) {
        return;
      }
      const fromPopup = !!(
        (buttonElement && buttonElement.closest && buttonElement.closest('#coupon_view_all_root')) ||
        isViewAllPopupOpen()
      );

      if (state.couponCelebrationTimer) {
        clearTimeout(state.couponCelebrationTimer);
        state.couponCelebrationTimer = null;
      }
      if (state.couponCelebration) {
        hideCouponApplyCelebration(state.couponCelebration.code);
        state.couponCelebration = null;
      }
      clearPopupTrayCelebrations();
      state.popupInputError = '';
      state.popupCardError = null;
      state.popupApplySource = null;

      // Re-entry guard: while we're removing, suppress the /coupons/list refetch
      // that the upcoming cart:refresh would trigger via the cart-event listeners.
      // The listeners still rehydrate the cached coupons over the section
      // re-render, so the user sees no skeleton flash; the cache is updated
      // once we have the post-refresh data instead of being clobbered mid-flight.
      cancelRevalidateDebounce();
      window.couponCheckInProgress = true;
      state.couponCheckInProgress = true;
      var releaseCouponRemovalBarrier = beginCouponRemovalBarrier();

      var silentRemoval = !!(options && options.silent);
      var cartLoaderScope = silentRemoval ? null : startCartActionLoader(null, buttonElement);
      if (fromPopup && !silentRemoval) startPopupOverlayLoader();
      var compositionChanged = false;

      // Show loading state on button if provided
      let originalText = 'Remove';
      if (buttonElement) {
        originalText = buttonElement.innerHTML;
        buttonElement.innerHTML = 'Removing...';
        buttonElement.style.pointerEvents = 'none';
      }

      try {
        // Fetch current cart data
        const cartResponse = await fetch('/cart.js');
        if (!cartResponse.ok) throw new Error('Failed to fetch cart');
        const cartData = await cartResponse.json();
        cacheCartData(cartData);

        // Snapshot cart composition before remove
        const cartBeforeRemove = cartData;

        // Call remove coupon API
        const result = await removeCouponAPI(couponCode, cartData);

        if (result.success) {
          // Check if the coupon was removed successfully
          const removedCoupon = result.data?.coupons?.find(
            (c) => c.code?.toLowerCase() === couponCode.toLowerCase() && c.removed
          );

          if (removedCoupon) {
            pushCouponRemovedToDataLayer(couponCode);
            cancelRevalidateDebounce();
            const updatedCart = await clearDiscountCartAttributes();

            // Check if cart composition changed (e.g., GWP removed)
            compositionChanged = !isCartCompositionUnchanged(cartBeforeRemove, updatedCart || cartData);

            // Clear cookie
            document.cookie = 'discount_code=; path=/; max-age=0';

            // Clear localStorage
            clearDiscountFromStorage();
            
            // Phase 1: Only reset cache if composition changed
            if (compositionChanged) {
              resetCouponListCache();
            } else {
              // Clear only the applied code, keep the list cache
              state.lastAppliedCode = '';
            }

            // Remove discount row from subtotal
            const discountRow = document.querySelector('.applied-coupon-discount');
            if (discountRow) discountRow.remove();

            // Drop any GWP / free product cards tied to this coupon
            clearFreeProductsFromStorage();
            hideFreeProductsInCart();

            // Clear global reference
            window.appliedDiscount = null;

            // Keep Removing... until the list/widget re-render. Setting "Apply"
            // here is what flashes the CTA on the still-applied row.
            state.widgetLastKey = '';
            refreshAvailableOffersWidgetFromCache('');

            // Refresh cart (this will trigger event listeners that reload coupons)
            await refreshCart(updatedCart);
            rehydrateCouponsFromCache();

            await syncCartDrawerToPayFromShopifyCart(updatedCart || state.lastCartData);

            if (isViewAllPopupOpen()) {
              syncViewAllPopupAppliedCode();
              syncViewAllPopupInputState();
              refreshViewAllPopupBodyIfOpen();
            }
          } else {
            // Coupon removal failed
            const failedCoupon = result.data?.coupons?.find((c) => c.code?.toLowerCase() === couponCode.toLowerCase());
            const errorMsg = failedCoupon?.error_message || 'Failed to remove coupon';

            if (buttonElement) {
              buttonElement.innerHTML = originalText;
              buttonElement.style.pointerEvents = 'auto';
            }
          }
        } else {
          throw new Error(result.error || 'Failed to remove coupon');
        }
      } catch (error) {
        console.error('Error removing coupon:', error);
        if (buttonElement) {
          buttonElement.innerHTML = originalText;
          buttonElement.style.pointerEvents = 'auto';
        }
      } finally {
        if (fromPopup) endPopupOverlayLoader();
        endCartActionLoader(cartLoaderScope);
        // Removal has finished - release any List API call that was waiting so
        // it now runs against the post-removal cart.
        endCouponRemovalBarrier(releaseCouponRemovalBarrier);
        // Hold the guard a touch longer than the section re-render + cart:drawer:render so
        // the trailing events use cache-rehydrate instead of re-fetching /coupons/list.
        setTimeout(() => {
          window.couponCheckInProgress = false;
          state.couponCheckInProgress = false;
          
          // Phase 1: Only fetch fresh list if composition changed
          if (compositionChanged) {
            if (typeof window.loadCoupons === 'function') window.loadCoupons(true);
          } else {
            // Cart composition unchanged - re-render from cache without API call
            reRenderCouponsFromCacheAfterRemove();
          }
        }, 1000);
      }
    };

    // Apply coupon function - exposed globally
    window.applyCouponFn = async function (code, buttonElement) {
      if (!code) return;
      if (!buttonElement) {
        console.warn('applyCouponFn: button element required');
        return;
      }

      const fromPopup = !!(buttonElement.closest && buttonElement.closest('#coupon_view_all_root'));
      var cartLoaderScope = startCartActionLoader(null, buttonElement);
      if (fromPopup) startPopupOverlayLoader();

      const originalText = buttonElement.innerHTML;
      buttonElement.innerHTML = 'Applying...';
      buttonElement.style.pointerEvents = 'none';

      cancelRevalidateDebounce();
      window.couponCheckInProgress = true;
      state.couponCheckInProgress = true;
      var compositionChanged = false;

      try {
        // Test mode: skip explicit remove and attempt applying the new code directly.
        // This allows validating backend/UI behavior when replacing an active coupon.

        // Fetch current cart data
        const cartResponse = await fetch('/cart.js');
        if (!cartResponse.ok) throw new Error('Failed to fetch cart');
        const cartData = await cartResponse.json();
        cacheCartData(cartData);
        const cartBeforeApply = cartData;

        // Call apply coupon API
        const result = await applyCouponAPI(code, cartData);

        if (result.success) {
          const appliedCoupon = resolveValidAppliedCoupon(result, code);

          if (appliedCoupon) {
            // Get discount info from the response
            const applyUpdatedCart = result.data?.updatedCart || null;
            const discountData = applyUpdatedCart?.discount || appliedCoupon;

            // Store the discount code in cookie for checkout
            document.cookie = `discount_code=${code}; path=/; max-age=${60 * 60 * 24 * 7}`;

            compositionChanged = !isCartCompositionUnchanged(cartBeforeApply, cartData);
            state.pendingApplyCompositionChanged = compositionChanged;

            // Show discount in subtotal area
            showDiscountInSubtotal(discountData, code, applyUpdatedCart, appliedCoupon);
            pushCouponAppliedToDataLayer(code);
            pushCouponSuccessToDataLayer(code);

            // GWP: render any free products bundled with this coupon
            const freeProducts = appliedCoupon.free_products || [];
            syncFreeProductsUi(freeProducts, code, cartData);

            let celebrationSavingsLine = '';
            if (state.lastCouponList) {
              const listCoupon = state.lastCouponList.find(function (c) {
                return String(c && c.code || '').toLowerCase() === code.toLowerCase();
              });
              if (listCoupon) celebrationSavingsLine = resolveCouponSavingsLine(listCoupon);
            }
            if (!celebrationSavingsLine) {
              const liveCard = findCouponCardElement(code);
              const savingsEl = liveCard && liveCard.querySelector('.coupon-savings');
              if (savingsEl) celebrationSavingsLine = savingsEl.textContent.trim();
            }

            // Update widget immediately before cart refresh to ensure sync with card state
            if (state.lastCouponList && state.lastCouponList.length) {
              renderAvailableOffersWidget(state.lastCouponList, 
                state.lastCouponList.filter(function (c) {
                  return String(c && c.offerType || '').toLowerCase() === 'store_offer';
                }), 
                code.toLowerCase()
              );
            }

            if (fromPopup) {
              state.popupApplySource = 'card';
              state.popupCardError = null;
              clearPopupInputError();

              let popupSavingsLine = celebrationSavingsLine;
              if (!popupSavingsLine) {
                const saved = formatCouponCelebrationSavings(discountData, '');
                if (saved) popupSavingsLine = 'You saved ' + saved;
              }

              state.popupCardCelebration = {
                code: code.toLowerCase(),
                until: Date.now() + COUPON_APPLY_CELEBRATION_MS,
                savingsLine: popupSavingsLine,
              };

              buttonElement.innerHTML = originalText;
              buttonElement.style.pointerEvents = 'auto';

              syncViewAllPopupAppliedCode();
              await refreshCart(cartData);
              refreshViewAllPopupBodyIfOpen();
              showPopupCardCelebration(code.toLowerCase(), popupSavingsLine);
              schedulePopupCardCelebrationEnd();
            } else {
              state.couponCelebration = {
                code: code.toLowerCase(),
                until: Date.now() + COUPON_APPLY_CELEBRATION_MS,
                discountData: discountData,
                savingsLine: celebrationSavingsLine,
              };

              buttonElement.innerHTML = originalText;
              buttonElement.style.pointerEvents = 'none';

              state.couponCelebrationPendingCart = cartData;
              showCouponApplyCelebration(code.toLowerCase(), discountData, celebrationSavingsLine);
              scheduleCouponCelebrationEnd();
            }
          } else {
            clearAllCouponApplyCelebrations();
            const invalidCoupon = findInvalidCouponEntry(result, code);
            const errorMsg = invalidCoupon?.error_message || 'Coupon could not be applied';

            if (fromPopup) {
              state.popupApplySource = 'card';
              state.popupCardError = { code: code.toLowerCase(), message: errorMsg };
              buttonElement.innerHTML = originalText;
              buttonElement.style.pointerEvents = 'auto';
              refreshViewAllPopupBodyIfOpen();
            } else {
              buttonElement.innerHTML = 'Failed';
              buttonElement.classList.add('cpnBtn-failed');

              setTimeout(() => {
                buttonElement.innerHTML = originalText;
                buttonElement.classList.remove('cpnBtn-failed');
                buttonElement.style.pointerEvents = 'auto';
              }, 2000);
            }
          }
        } else {
          throw new Error(result.error || 'Failed to apply coupon');
        }
      } catch (error) {
        console.error('Error applying coupon:', error);
        clearAllCouponApplyCelebrations();
        if (fromPopup) {
          state.popupApplySource = 'card';
          state.popupCardError = {
            code: String(code || '').toLowerCase(),
            message: error.message || 'Coupon could not be applied',
          };
          buttonElement.innerHTML = originalText;
          buttonElement.style.pointerEvents = 'auto';
          refreshViewAllPopupBodyIfOpen();
        } else {
          buttonElement.innerHTML = 'Failed';
          buttonElement.classList.add('cpnBtn-failed');

          setTimeout(() => {
            buttonElement.innerHTML = originalText;
            buttonElement.classList.remove('cpnBtn-failed');
            buttonElement.style.pointerEvents = 'auto';
          }, 2000);
        }
      } finally {
        if (fromPopup) endPopupOverlayLoader();
        endCartActionLoader(cartLoaderScope);
        setTimeout(function () {
          if (
            !isCouponCelebrationActive() &&
            !isPopupInputCelebrationActive() &&
            !isPopupCardCelebrationActive()
          ) {
            finalizeCouponApplyCelebration({ compositionChanged: compositionChanged });
          } else {
            window.couponCheckInProgress = false;
            state.couponCheckInProgress = false;
          }
        }, 1000);
      }
    };

    // Manual coupon apply function
    window.applyManualCouponFn = async function (buttonElement) {
      const fields =
        getManualCouponFieldsFromElement(buttonElement) ||
        getManualCouponFields(getCouponUiRoots()[0]);
      const inputField = fields && fields.inputField;
      const applyButton = fields && fields.applyButton;

      if (!inputField || !applyButton) {
        return;
      }

      const code = inputField.value.trim().toUpperCase();
      syncManualCouponInputs(code, inputField);

      if (
        applyButton.classList.contains('is-disabled') ||
        applyButton.getAttribute('aria-disabled') === 'true'
      ) {
        return;
      }

      if (!code) {
        inputField.focus();
        return;
      }

      var cartLoaderScope = startCartActionLoader(null, buttonElement);

      cancelRevalidateDebounce();
      window.couponCheckInProgress = true;
      state.couponCheckInProgress = true;

      clearManualCouponError(fields);

      let manualApplyHadError = false;

      applyButton.innerHTML = 'Applying...';
      applyButton.style.pointerEvents = 'none';
      inputField.disabled = true;

      try {
        // Test mode: skip explicit remove and attempt applying the new code directly.
        // This allows validating backend/UI behavior when replacing an active coupon.

        // Fetch current cart data
        const cartResponse = await fetch('/cart.js');
        if (!cartResponse.ok) throw new Error('Failed to fetch cart');
        const cartData = await cartResponse.json();
        cacheCartData(cartData);

        // Call apply coupon API
        const result = await applyCouponAPI(code, cartData);

        if (result.success) {
          const appliedCoupon = resolveValidAppliedCoupon(result, code);

          if (appliedCoupon) {
            // Get discount info from the response
            const applyUpdatedCart = result.data?.updatedCart || null;
            const discountData = applyUpdatedCart?.discount || appliedCoupon;

            // Store the discount code in cookie for checkout
            document.cookie = `discount_code=${code}; path=/; max-age=${60 * 60 * 24 * 7}`;

            // Show discount in subtotal area
            showDiscountInSubtotal(discountData, code, applyUpdatedCart, appliedCoupon);
            pushCouponAppliedToDataLayer(code);
            pushCouponSuccessToDataLayer(code);

            // GWP: render any free products bundled with this coupon
            const freeProducts = appliedCoupon.free_products || [];
            syncFreeProductsUi(freeProducts, code, cartData);

            let celebrationSavingsLine = '';
            const saved = formatCouponCelebrationSavings(discountData, '');
            if (saved) celebrationSavingsLine = 'You saved ' + saved;

            state.manualCouponCelebration = {
              code: code.toLowerCase(),
              until: Date.now() + COUPON_APPLY_CELEBRATION_MS,
              discountData: discountData,
              savingsLine: celebrationSavingsLine,
            };
            state.manualInputCardScrollLock = true;
            state.manualCouponCarouselRenderedFor = '';
            state.manualCouponCelebrationShown = false;

            // Update widget immediately before cart refresh to ensure sync with card state
            if (state.lastCouponList && state.lastCouponList.length) {
              renderAvailableOffersWidget(state.lastCouponList, 
                state.lastCouponList.filter(function (c) {
                  return String(c && c.offerType || '').toLowerCase() === 'store_offer';
                }), 
                code.toLowerCase()
              );
            }

            // Refresh cart first; celebration + applied input state render once
            // after the drawer section re-render settles (avoids a double celebration).
            await refreshCart(cartData);
            if (!carouselHasCouponCards()) {
              rehydrateCouponsFromCache();
            }
            await new Promise(function (resolve) {
              requestAnimationFrame(function () {
                requestAnimationFrame(resolve);
              });
            });
            finishManualCouponApplyPresentation();
          } else {
            clearAllCouponApplyCelebrations();
            const invalidCoupon = findInvalidCouponEntry(result, code);
            const errorMsg = invalidCoupon?.error_message || 'Coupon could not be applied';
            manualApplyHadError = true;

            applyButton.innerHTML = 'Apply';
            applyButton.classList.remove('cpnBtn-failed', 'cpnBtn-applied', 'cpnBtn-remove');
            applyButton.classList.add('cpnBtn');
            applyButton.style.pointerEvents = 'auto';
            applyButton.onclick = function () {
              window.applyManualCouponFn(this);
            };

            inputField.value = code;
            inputField.disabled = false;
            setManualCouponError(fields, errorMsg);
          }
        } else {
          throw new Error(result.error || 'Failed to apply coupon');
        }
      } catch (error) {
        console.error('Error applying manual coupon:', error);
        clearAllCouponApplyCelebrations();
        manualApplyHadError = true;

        applyButton.innerHTML = 'Apply';
        applyButton.classList.remove('cpnBtn-failed', 'cpnBtn-applied', 'cpnBtn-remove');
        applyButton.classList.add('cpnBtn');
        applyButton.style.pointerEvents = 'auto';
        applyButton.onclick = function () {
          window.applyManualCouponFn(this);
        };

        inputField.disabled = false;
        setManualCouponError(fields, error.message || 'Coupon could not be applied');
      } finally {
        endCartActionLoader(cartLoaderScope);
        setTimeout(function () {
          window.couponCheckInProgress = false;
          state.couponCheckInProgress = false;
          if (!isManualCouponCelebrationActive() && !manualApplyHadError) {
            if (typeof window.loadCoupons === 'function') window.loadCoupons(true);
          }
        }, 1000);
      }
    };

    // View-all popup coupon apply/remove — in-tray celebration (Next.js OffersTray parity).
    window.applyViewAllCouponFn = async function (buttonEl) {
      const els = getViewAllPopupElements();
      if (!els || !els.input || !buttonEl) return;

      const stored = getDiscountFromStorage();
      const appliedCode = stored && stored.code ? String(stored.code) : '';

      if (appliedCode) {
        var cartLoaderScope = startCartActionLoader(getPopupCartLoaderScope(), buttonEl);
        startPopupOverlayLoader();
        const originalText = buttonEl.textContent;
        buttonEl.textContent = 'Removing...';
        buttonEl.style.pointerEvents = 'none';
        try {
          clearPopupInputError();
          state.popupCardError = null;
          await window.removeCouponFn(appliedCode, null);
          els.input.value = '';
          els.input.disabled = false;
          els.input.classList.remove('coupon-full-input--error');
          buttonEl.textContent = 'Apply';
          buttonEl.classList.add('is-disabled');
          buttonEl.style.pointerEvents = 'none';
          syncViewAllPopupAppliedCode();
          refreshViewAllPopupBodyIfOpen();
        } finally {
          endPopupOverlayLoader();
          endCartActionLoader(cartLoaderScope);
          if (!getDiscountFromStorage()?.code) {
            buttonEl.textContent = 'Apply';
          }
        }
        return;
      }

      const code = String(els.input.value || '').trim().toUpperCase();
      if (!code) {
        els.input.focus();
        return;
      }

      var cartLoaderScope = startCartActionLoader(getPopupCartLoaderScope(), buttonEl);
      startPopupOverlayLoader();

      cancelRevalidateDebounce();
      window.couponCheckInProgress = true;
      state.couponCheckInProgress = true;
      clearPopupInputError();
      state.popupCardError = null;
      state.popupApplySource = 'text';

      const originalText = buttonEl.textContent;
      buttonEl.textContent = 'Applying...';
      buttonEl.style.pointerEvents = 'none';
      els.input.disabled = true;

      let popupApplyHadError = false;
      var compositionChanged = false;

      try {
        const storedDiscount = getDiscountFromStorage();
        const currentApplied = storedDiscount?.code;
        if (currentApplied && currentApplied.toLowerCase() !== code.toLowerCase()) {
          await window.removeCouponFn(currentApplied, null);
        }

        const cartResponse = await fetch('/cart.js');
        if (!cartResponse.ok) throw new Error('Failed to fetch cart');
        const cartData = await cartResponse.json();
        cacheCartData(cartData);
        const cartBeforeApply = cartData;

        const result = await applyCouponAPI(code, cartData);

        if (result.success) {
          const appliedCoupon = resolveValidAppliedCoupon(result, code);

          if (appliedCoupon) {
            const applyUpdatedCart = result.data?.updatedCart || null;
            const discountData = applyUpdatedCart?.discount || appliedCoupon;

            document.cookie = `discount_code=${code}; path=/; max-age=${60 * 60 * 24 * 7}`;

            compositionChanged = !isCartCompositionUnchanged(cartBeforeApply, cartData);
            state.pendingApplyCompositionChanged = compositionChanged;
            showDiscountInSubtotal(discountData, code, applyUpdatedCart, appliedCoupon);
            pushCouponAppliedToDataLayer(code);
            pushCouponSuccessToDataLayer(code);

            const freeProducts = appliedCoupon.free_products || [];
            syncFreeProductsUi(freeProducts, code, cartData);

            let celebrationSavingsLine = '';
            const saved = formatCouponCelebrationSavings(discountData, '');
            if (saved) celebrationSavingsLine = saved;

            state.popupInputCelebration = {
              code: code.toLowerCase(),
              until: Date.now() + COUPON_APPLY_CELEBRATION_MS,
              discountData: discountData,
              savingsLine: celebrationSavingsLine,
            };

            els.input.value = code;
            els.input.disabled = true;
            buttonEl.textContent = 'Remove';
            buttonEl.classList.remove('is-disabled');
            buttonEl.style.pointerEvents = 'auto';

            showPopupInputCelebration(code, discountData, celebrationSavingsLine);
            schedulePopupInputCelebrationEnd();

            // Update widget immediately before cart refresh to ensure sync with card state
            if (state.lastCouponList && state.lastCouponList.length) {
              renderAvailableOffersWidget(state.lastCouponList, 
                state.lastCouponList.filter(function (c) {
                  return String(c && c.offerType || '').toLowerCase() === 'store_offer';
                }), 
                code.toLowerCase()
              );
            }

            syncViewAllPopupAppliedCode();
            refreshViewAllPopupBodyIfOpen();
            await refreshCart(cartData);
          } else {
            clearAllCouponApplyCelebrations();
            const invalidCoupon = findInvalidCouponEntry(result, code);
            const errorMsg = invalidCoupon?.error_message || 'Coupon could not be applied';
            popupApplyHadError = true;
            els.input.value = code;
            els.input.disabled = false;
            setPopupInputError(errorMsg);
          }
        } else {
          throw new Error(result.error || 'Failed to apply coupon');
        }
      } catch (error) {
        console.error('View-all popup apply error:', error);
        clearAllCouponApplyCelebrations();
        popupApplyHadError = true;
        els.input.disabled = false;
        setPopupInputError(error.message || 'Coupon could not be applied');
      } finally {
        endPopupOverlayLoader();
        endCartActionLoader(cartLoaderScope);
        if (!isPopupInputCelebrationActive()) {
          if (popupApplyHadError) {
            buttonEl.textContent = 'Apply';
            const empty = !String(els.input.value || '').trim();
            buttonEl.classList.toggle('is-disabled', empty);
            buttonEl.style.pointerEvents = empty ? 'none' : 'auto';
          } else {
            syncViewAllPopupInputState();
          }
        }
        if (!isPopupInputCelebrationActive() && !isPopupCardCelebrationActive()) {
          setTimeout(function () {
            finalizeCouponApplyCelebration({ compositionChanged: compositionChanged });
          }, 1000);
        }
      }
    };

    // Manual coupon remove function
    window.removeManualCouponFn = async function (buttonElement) {
      const fields =
        getManualCouponFieldsFromElement(buttonElement) ||
        getManualCouponFields(getCouponUiRoots()[0]);
      const inputField = fields && fields.inputField;
      const applyButton = fields && fields.applyButton;

      // Get coupon code from input or stored discount
      const couponCode =
        inputField?.value?.trim() ||
        (getDiscountFromStorage() && getDiscountFromStorage().code);

      if (!couponCode) {
        return;
      }

      if (state.manualCouponCelebrationTimer) {
        clearTimeout(state.manualCouponCelebrationTimer);
        state.manualCouponCelebrationTimer = null;
      }
      state.manualCouponCelebration = null;
      state.manualInputCardScrollLock = false;
      state.manualCouponCarouselRenderedFor = '';
      state.manualCouponCelebrationShown = false;
      hideManualCouponCelebration();
      clearManualCouponError(fields);

      // Re-entry guard for the same reason as removeCouponFn.
      cancelRevalidateDebounce();
      window.couponCheckInProgress = true;
      state.couponCheckInProgress = true;

      var cartLoaderScope = startCartActionLoader(null, buttonElement);
      var compositionChanged = false;

      const originalText = buttonElement.innerHTML;
      buttonElement.innerHTML = 'Removing...';
      buttonElement.style.pointerEvents = 'none';

      try {
        // Fetch current cart data
        const cartResponse = await fetch('/cart.js');
        if (!cartResponse.ok) throw new Error('Failed to fetch cart');
        const cartData = await cartResponse.json();
        cacheCartData(cartData);

        // Snapshot cart composition before remove
        const cartBeforeRemove = cartData;

        // Call remove coupon API
        const result = await removeCouponAPI(couponCode, cartData);

        if (result.success) {
          // Check if the coupon was removed successfully
          const removedCoupon = result.data?.coupons?.find(
            (c) => c.code?.toLowerCase() === couponCode.toLowerCase() && c.removed
          );

          if (removedCoupon) {
            pushCouponRemovedToDataLayer(couponCode);
            cancelRevalidateDebounce();
            const updatedCart = await clearDiscountCartAttributes();

            // Check if cart composition changed (e.g., GWP removed)
            compositionChanged = !isCartCompositionUnchanged(cartBeforeRemove, updatedCart || cartData);

            // Clear cookie
            document.cookie = 'discount_code=; path=/; max-age=0';

            // Clear localStorage
            clearDiscountFromStorage();
            
            // Phase 1: Only reset cache if composition changed
            if (compositionChanged) {
              resetCouponListCache();
            } else {
              // Clear only the applied code, keep the list cache
              state.lastAppliedCode = '';
            }

            // Remove discount row from subtotal
            const discountRow = document.querySelector('.applied-coupon-discount');
            if (discountRow) discountRow.remove();

            // Drop any GWP / free product cards tied to this coupon
            clearFreeProductsFromStorage();
            hideFreeProductsInCart();

            // Clear global reference
            window.appliedDiscount = null;

            // Rebuild the idle widget in one innerHTML write. Do not swap this
            // button to "Apply" while "CODE + Applied" is still on the row.
            if (inputField) {
              inputField.value = '';
              inputField.disabled = false;
            }
            state.widgetLastKey = '';
            refreshAvailableOffersWidgetFromCache('');
            restoreManualCouponInput();

            // Refresh cart using cleared-attribute response — no extra cart.js fetch
            await refreshCart(updatedCart);
            rehydrateCouponsFromCache();
            refreshAvailableOffersWidgetFromCache('');
            restoreManualCouponInput();

            await syncCartDrawerToPayFromShopifyCart(updatedCart || state.lastCartData);
          } else {
            throw new Error('Failed to remove coupon');
          }
        } else {
          throw new Error(result.error || 'Failed to remove coupon');
        }
      } catch (error) {
        console.error('Error removing manual coupon:', error);
        buttonElement.innerHTML = originalText;
        buttonElement.style.pointerEvents = 'auto';
      } finally {
        endCartActionLoader(cartLoaderScope);
        setTimeout(() => {
          window.couponCheckInProgress = false;
          state.couponCheckInProgress = false;
          
          // Phase 1: Only fetch fresh list if composition changed
          if (compositionChanged) {
            if (typeof window.loadCoupons === 'function') window.loadCoupons(true);
          } else {
            // Cart composition unchanged - re-render from cache without API call
            reRenderCouponsFromCacheAfterRemove();
          }
        }, 1000);
      }
    };

    // Initialize manual coupon input field handlers (delegated so they survive coupon list re-renders)
    function initManualCouponInput() {
      getCouponUiRoots().forEach(function (root) {
        if (root.dataset.manualCouponDelegated === 'true') return;
        root.dataset.manualCouponDelegated = 'true';

        root.addEventListener('input', function (e) {
          const inputField = e.target && e.target.closest ? e.target.closest('.manual-coupon-code') : null;
          if (!inputField || !root.contains(inputField)) return;

          const storedDiscount = getDiscountFromStorage();
          if (storedDiscount && storedDiscount.code) return;

          inputField.value = inputField.value.toUpperCase();
          syncManualCouponInputs(inputField.value, inputField);
          const fields = getManualCouponFields(root);
          clearManualCouponError(fields);
          syncManualApplyButtonStyle(fields);
        });

        root.addEventListener('keypress', function (e) {
          if (e.key !== 'Enter') return;
          const inputField = e.target && e.target.closest ? e.target.closest('.manual-coupon-code') : null;
          if (!inputField || !root.contains(inputField)) return;
          e.preventDefault();
          const fields = getManualCouponFields(root);
          if (
            fields &&
            fields.applyButton &&
            !fields.applyButton.classList.contains('is-disabled') &&
            !fields.applyButton.classList.contains('cpnBtn-disabled')
          ) {
            fields.applyButton.click();
          }
        });
      });

      const widget = document.getElementById('available_offers_widget');
      if (widget && widget.dataset.partnershipCouponDelegated !== 'true') {
        widget.dataset.partnershipCouponDelegated = 'true';
        widget.addEventListener('input', function (e) {
          const inputField =
            e.target && e.target.closest
              ? e.target.closest('.available-offers-widget__partnership-input')
              : null;
          if (!inputField || !widget.contains(inputField)) return;
          const storedDiscount = getDiscountFromStorage();
          if (storedDiscount && storedDiscount.code) return;
          inputField.value = inputField.value.toUpperCase();
          syncManualCouponInputs(inputField.value, inputField);
          const fields = getPartnershipWidgetCouponFields();
          clearManualCouponError(fields);
          syncManualApplyButtonStyle(fields);
          syncPartnershipWidgetIdleState(fields);
        });
        widget.addEventListener('keypress', function (e) {
          if (e.key !== 'Enter') return;
          const inputField =
            e.target && e.target.closest
              ? e.target.closest('.available-offers-widget__partnership-input')
              : null;
          if (!inputField || !widget.contains(inputField)) return;
          e.preventDefault();
          const fields = getPartnershipWidgetCouponFields();
          if (
            fields &&
            fields.applyButton &&
            !fields.applyButton.classList.contains('is-disabled')
          ) {
            fields.applyButton.click();
          }
        });
      }
    }

    // Keep manual + View All cards the same height as coupon cards
    // Card heights are equalised by flex stretch in copy-code.css. Pinning a
    // measured px height here fought that: the manual card got the coupon
    // cards' height even when its own content was taller, and the pinned value
    // never shrank back. Just clear any inline heights left from earlier.
    function syncCouponCarouselHeights() {
      document
        .querySelectorAll('.coupon-input-card .coupon-wrapper, .coupon-view-all-card')
        .forEach(function (el) {
          el.style.height = '';
          el.style.minHeight = '';
        });
    }

    window.couponViewAllFn = function () {
      openCouponViewAllSheet();
    };

    window.closeCouponViewAllFn = function () {
      closeCouponViewAllSheet();
    };

    window.isCouponViewAllSheetOpenFn = function () {
      return isCouponViewAllSheetOpen();
    };

    // Build the coupons-container HTML + count text from already-resolved data,
    // and only swap innerHTML when the data actually changes (render-key dedup).
    // This is the equivalent of bblunt's data-couponRenderKey trick and is the
    // single biggest anti-jitter lever: after a cart:change echo, when the
    // section re-render restores the persistent skeleton, we render once from
    // cache and then subsequent API responses that produce identical output
    // become no-op DOM writes (no flash, no reflow, no height re-measure).
    function renderCouponsList(coupons, storeCarouselCoupons, appliedCouponCode) {
      const parts = getAllCouponUiParts();
      if (!parts.length) return false;

      const celebrationCode =
        state.manualCouponCelebration && state.manualCouponCelebration.code
          ? String(state.manualCouponCelebration.code).toLowerCase()
          : '';
      if (
        isManualCouponCelebrationActive() &&
        celebrationCode &&
        state.manualCouponCarouselRenderedFor === celebrationCode &&
        carouselHasCouponCards()
      ) {
        return refreshManualCouponCarouselUi(coupons, storeCarouselCoupons, appliedCouponCode);
      }

      const container = parts[0].container;
      const countText = parts[0].countText;

      const carouselAppliedCode = getCarouselAppliedCodeForRender(appliedCouponCode || '');
      const orderedCarouselCoupons = orderCarouselCouponsWithAppliedFirst(
        storeCarouselCoupons,
        carouselAppliedCode
      );

      // Heading count should show TOTAL store offers, not only applicable ones.
      const couponCount = (storeCarouselCoupons || []).length;

      if (!coupons || coupons.length === 0) {
        parts.forEach(function (p) {
          p.root.style.display = 'none';
        });
        renderAvailableOffersWidget([], [], appliedCouponCode || '');
        state.lastRenderedHtml = '';
        state.lastRenderKey = '';
        return true;
      }

      parts.forEach(function (p) {
        p.root.style.display = '';
      });
      const newCountText = 'Available offer' + (couponCount > 1 ? 's' : '') + ' for you (' + couponCount + ')';

      const partnershipCouponTypeFirst = shouldShowPartnershipCouponTypeFirst();

      // Stable key from the inputs that affect the rendered output.
      // If the key matches what's already in the DOM, skip the innerHTML swap entirely.
      const renderKey = JSON.stringify({
        applied: appliedCouponCode || '',
        celebrating: isCouponCelebrationActive() ? state.couponCelebration.code || '' : '',
        count: couponCount,
        carousel: orderedCarouselCoupons.map(function (c) {
          return {
            code: c.code || '',
            title: c.title || '',
            message: c.message || '',
            isApplicable: c.isApplicable !== false,
            savingsLine: resolveCouponSavingsLine(c),
          };
        }),
        nector: !!(window.Shopify && window.Shopify.nectorCoupon),
        partnershipFirst: partnershipCouponTypeFirst,
        total: coupons.length,
      });

      // Reset sheet metadata cache before re-collecting it during card build.
      state.couponSheetData = {};

      const manualInputCardHTML = `
        <div class="coupon-input-card is-disabled">
          <div class="coupon-wrapper">
            <div class="coupon-panel">
              <div class="coupon-content">
                <h3>Have a coupon code</h3>
                <div class="coupon-input-field">
                  <input
                    type="text"
                    class="coupon-input manual-coupon-code"
                    placeholder="Enter coupon code"
                    autocomplete="off"
                  >
                  <div class="manual-coupon-display" hidden>
                    <span class="manual-coupon-display__code"></span>
                    <span class="manual-coupon-display__status">
                      <img class="manual-coupon-display__icon" src="${COUPON_TICK_ICON_URL}" width="12" height="12" alt="" aria-hidden="true">Applied
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="coupon-code-area manual-coupon-code-area">
              <div class="coupon-row manual-coupon-footer-row">
                <div class="manual-coupon-error-message" data-manual-coupon-error hidden aria-live="polite"></div>
                <span class="cpnBtn manual-apply-btn cpnBtn-disabled is-disabled" aria-disabled="true" onclick="window.applyManualCouponFn(this)">Apply</span>
              </div>
            </div>
          </div>
        </div>
      `;

      const viewAllCardHTML =
        '<div class="coupon-view-all-card gXMwoP">' +
        '<button type="button" class="coupon-view-all-btn" aria-label="View all offers" onclick="window.couponViewAllFn && window.couponViewAllFn()">' +
        '<span class="coupon-view-all-title">View All Offers</span>' +
        '<span class="coupon-view-all-icon" aria-hidden="true">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">' +
        '<g id="Group 38116">' +
        '<circle id="Ellipse 813" cx="11.5" cy="11.5" r="10.75" fill="white" stroke="#00AEEF" stroke-width="1.5"/>' +
        '<path id="Vector 53" d="M10.3867 8.16113L14.097 11.8714L10.3867 15.5816" stroke="#00AEEF" stroke-width="1.6" stroke-linecap="round"/>' +
        '</g>' +
        '</svg>' +
        '</span>' +
        '</button>' +
        '</div>';

      let couponsHTML = '';
      if (window.Shopify && window.Shopify.nectorCoupon) {
        couponsHTML += window.Shopify.nectorCoupon;
      }
      // Partnership + AB ON: Coupon Type ("Have a coupon code") before store-offer cards.
      // Shared path for Cart Page + Cart Drawer.
      if (partnershipCouponTypeFirst) {
        couponsHTML += manualInputCardHTML;
      }
      orderedCarouselCoupons.forEach(function (coupon) {
        const isApplied = carouselAppliedCode && coupon.code?.toLowerCase() === carouselAppliedCode;
        couponsHTML += buildCouponCard(coupon, isApplied);
      });
      state.viewAllCoupons = coupons;
      state.viewAllAppliedCouponCode = appliedCouponCode;

      if (!partnershipCouponTypeFirst) {
        couponsHTML += manualInputCardHTML;
      }
      couponsHTML += viewAllCardHTML;

      // Bail-out: identical key AND container still shows the real coupon cards
      // (not the server-rendered skeleton). If we're sitting on the skeleton,
      // we always swap so the user gets real content even when key matches a
      // previous render from a stale namespace.
      const allRootsUpToDate = parts.every(function (p) {
        const hasRealCards = p.container.querySelector('.coupon-card') !== null;
        return (
          hasRealCards &&
          state.lastRenderKey === renderKey &&
          p.container.dataset.couponRenderKey === renderKey
        );
      });
      if (allRootsUpToDate) {
        parts.forEach(function (p) {
          if (p.countText.textContent !== newCountText) p.countText.textContent = newCountText;
          p.container.setAttribute('aria-busy', 'false');
        });
        resumeCouponCelebrationAfterRender();
        resumeManualCouponCelebrationAfterRender();
        return false;
      }

      if (isManualCouponCelebrationActive() && celebrationCode) {
        state.manualCouponCarouselRenderedFor = celebrationCode;
      }

      const preserveManualInputScroll =
        state.manualInputCardScrollLock || isManualCouponCelebrationActive();
      parts.forEach(function (p) {
        p.countText.textContent = newCountText;
        const savedScroll = preserveManualInputScroll ? p.container.scrollLeft : 0;
        p.container.innerHTML = couponsHTML;
        if (preserveManualInputScroll) {
          p.container.scrollLeft = savedScroll;
        }
        p.container.dataset.couponRenderKey = renderKey;
        p.container.setAttribute('aria-busy', 'false');
      });
      state.lastRenderedHtml = couponsHTML;
      state.lastRenderKey = renderKey;
      state.lastCountText = newCountText;

      renderAvailableOffersWidget(coupons, storeCarouselCoupons, appliedCouponCode);
      refreshViewAllPopupBodyIfOpen();

      // Only run the expensive height-sync after we actually wrote new HTML.
      // Skipping this when the render was a no-op removes the most visible
      // reflow on every cart:change echo.
      setTimeout(() => {
        syncCouponCarouselHeights();
        if (!state.manualCouponCelebrationShown) {
          initManualCouponInput();
          restoreManualCouponInput();
        }
        if (isManualCouponCelebrationActive() && !state.manualCouponCelebrationShown) {
          resumeManualCouponCelebrationAfterRender();
        } else if (state.manualInputCardScrollLock || isManualCouponCelebrationActive()) {
          ensureManualCouponInputCardInView('auto');
        }
      }, 50);
      setTimeout(syncCouponCarouselHeights, 180);
      resumeCouponCelebrationAfterRender();
      if (!isManualCouponCelebrationActive()) {
        resumeManualCouponCelebrationAfterRender();
      }
      return true;
    }

    // Synchronously rehydrate the coupons container from in-memory cache.
    // Called when the cart-drawer section re-render restores the placeholder
    // skeleton — we paint over it with the last-known coupons before any
    // network fetch resolves, so the user never sees the skeleton flash.
    function rehydrateCouponsFromCache() {
      restoreCouponListFromPersistentCache();
      if (!state.lastCouponList || !state.lastCouponList.length) return false;
      const parts = getAllCouponUiParts();
      if (!parts.length) return false;

      const storedDiscount = getDiscountFromStorage();
      const appliedCouponCode = (storedDiscount && storedDiscount.code) ? storedDiscount.code.toLowerCase() : '';

      const allRootsCurrent = parts.every(function (p) {
        return (
          p.container.dataset.couponRenderKey === state.lastRenderKey &&
          p.container.querySelector('.coupon-card') !== null &&
          state.lastAppliedCode === appliedCouponCode &&
          !isCouponCelebrationActive() &&
          !isManualCouponCelebrationActive()
        );
      });
      if (allRootsCurrent) {
        resumeCouponCelebrationAfterRender();
        resumeManualCouponCelebrationAfterRender();
        return true;
      }

      const storeCarouselCoupons = state.lastCouponList.filter(function (coupon) {
        return String(coupon && coupon.offerType || '').toLowerCase() === 'store_offer';
      });
      state.lastAppliedCode = appliedCouponCode;

      if (isManualCouponCelebrationActive() && carouselHasCouponCards()) {
        return refreshManualCouponCarouselUi(state.lastCouponList, storeCarouselCoupons, appliedCouponCode);
      }

      // Force the dedup to allow a write since we're rehydrating into a fresh
      // (post-section-render) DOM that lost the data-couponRenderKey marker.
      state.lastRenderKey = '';
      renderCouponsList(state.lastCouponList, storeCarouselCoupons, appliedCouponCode);
      return true;
    }

    // Main function to load and display coupons (with debouncing and request deduplication)
    async function loadCoupons(forceRefresh = false, cartHint = null) {
      // Keep carousel stable while the success popup is up.
      // Any requested refresh is queued and handled once celebration finalizes.
      if (isCouponCelebrationActive()) {
        state.pendingReload = true;
        return;
      }

      // Prevent multiple concurrent calls (window-level so re-renders don't start duplicate requests).
      // If a load is already in flight, queue a follow-up so the latest DOM gets rendered
      // once the in-flight call resolves. Without this, the cart-drawer re-render after a
      // coupon apply can leave the carousel stuck on "Loading offers...".
      if (state.loadInFlight || isLoadingCoupons) {
        state.pendingReload = true;
        return;
      }

      const parts = getAllCouponUiParts();
      if (!parts.length) {
        scheduleOutsideCouponsLoadRetry(150, cartHint);
        return;
      }
      state.outsideRetryCount = 0;

      const container = parts[0].container;
      const countText = parts[0].countText;

      // Show the skeleton ONLY when we have literally nothing to show:
      // - no rendered coupon cards in the DOM, AND
      // - no server-rendered placeholder skeleton, AND
      // - no in-memory cache to rehydrate from.
      // After the first successful load, every subsequent cart:change keeps
      // the existing cards (or the server skeleton) until the render-key
      // dedup decides a swap is warranted.
      const hasExistingCoupons = parts.some(function (p) {
        return p.container.querySelector('.coupon-card') !== null;
      });
      const hasServerSkeleton = parts.some(function (p) {
        return p.container.querySelector('[data-coupon-skeleton]') !== null;
      });
      const canRehydrate = !!(state.lastCouponList && state.lastCouponList.length);

      if (!hasExistingCoupons && !hasServerSkeleton && !canRehydrate) {
        const shimmerHTML = createShimmerUI();
        parts.forEach(function (p) {
          p.container.innerHTML = shimmerHTML;
          p.countText.textContent = 'Loading offers...';
        });
      } else if (!hasExistingCoupons && canRehydrate) {
        rehydrateCouponsFromCache();
      }

      isLoadingCoupons = true;
      state.loadInFlight = true;

      try {
        // state.lastCartData first, like every other reader: this script re-runs on
        // each drawer render and window.loadCoupons is the newest copy, whose own
        // lastCartData only moves when that copy caches — state always has the latest.
        let cartData = cartHint || state.lastCartData || lastCartData;
        const epochAtStart = state.cartCacheEpoch || 0;
        if (!cartData || typeof cartData.item_count === 'undefined') {
          const response = await fetch('/cart.js');
          if (!response.ok) throw new Error('Failed to fetch cart');
          const fetchedCart = await response.json();
          // A cart:change may have landed while /cart.js was in flight (empty →
          // first add). Prefer the event-sourced cache over a stale empty response.
          if (
            (state.cartCacheEpoch || 0) > epochAtStart &&
            state.lastCartData &&
            typeof state.lastCartData.item_count !== 'undefined'
          ) {
            cartData = state.lastCartData;
          } else {
            cartData = fetchedCart;
            cacheCartData(cartData);
          }
        } else if (cartHint) {
          // Hints are captured when a call is scheduled (drawer re-boot, debounce,
          // retry), so the cart may have changed since. Building the list from a
          // superseded hint shows offers for the old cart, and caching it would
          // undo the newer cart (an empty pre-add hint brought back Order Total ₹0).
          if (isSupersededCartHint(cartHint)) {
            cartData = state.lastCartData;
          } else {
            cacheCartData(cartData);
          }
        }

        // Empty→add race: our resolved snapshot is empty but a newer cart with
        // items already arrived via cart:change — use that so /coupons/list runs.
        if (
          (Number(cartData.item_count) || 0) === 0 &&
          state.lastCartData &&
          (Number(state.lastCartData.item_count) || 0) > 0 &&
          (state.cartCacheEpoch || 0) > epochAtStart
        ) {
          cartData = state.lastCartData;
        }

        // A coupon-removal flow (auto-revalidate or manual) may be in progress
        // (e.g. this call was scheduled by the same qty-change that also
        // triggered revalidation). Wait for it to finish so this request runs
        // against the post-removal cart instead of racing ahead of it, then
        // re-read the latest snapshot since it will have changed underneath us.
        if (state.couponRemovalBarrier) {
          await state.couponRemovalBarrier;
          cartData = state.lastCartData || cartData;
        }

        if (cartData.item_count === 0) {
          parts.forEach(function (p) {
            p.root.style.display = 'none';
          });
          const emptyWidget = document.getElementById('available_offers_widget');
          if (emptyWidget) {
            emptyWidget.hidden = true;
            emptyWidget.innerHTML = '';
          }
          // Clear cache so a future re-fill doesn't rehydrate stale offers.
          state.lastCouponList = null;
          state.lastAppliedCode = '';
          state.lastRenderKey = '';
          state.lastRenderedHtml = '';
          clearCouponListCache();
          return;
        }

        // Check if a coupon is already applied
        const storedDiscount = getDiscountFromStorage();
        const appliedCouponCode = storedDiscount?.code?.toLowerCase() || '';

        // Fetch coupons from API (includes both store_offer and payment_offer types).
        // fetchCouponsFromAPI returns null when this call has been superseded by a
        // newer request — bail out so we don't overwrite fresher state.
        const coupons = await fetchCouponsFromAPI(cartData);
        if (coupons === null) return;

        let resolvedCoupons = coupons;
        if (!resolvedCoupons || !resolvedCoupons.length) {
          if (appliedCouponCode) {
            restoreCouponListFromPersistentCache();
            if (appliedCouponCode && state.lastCouponList && state.lastCouponList.length) {
              resolvedCoupons = state.lastCouponList;
            }
          } else {
            resetCouponListCache();
            // Post-remove / post-qty cart may not be settled on the first list call.
            if (forceRefresh) {
              try {
                const freshResponse = await fetch('/cart.js');
                if (freshResponse.ok) {
                  const freshCart = await freshResponse.json();
                  cacheCartData(freshCart);
                  const retryCoupons = await fetchCouponsFromAPI(freshCart);
                  if (retryCoupons !== null && retryCoupons.length) {
                    resolvedCoupons = retryCoupons;
                    cartData = freshCart;
                  }
                }
              } catch (retryErr) {
                console.error('Coupon list retry after cart refresh failed:', retryErr);
              }
            }
          }
        }

        // The cart-drawer carousel (outside the View-All popup) should only show
        // store offers. Payment offers are surfaced inside the popup's
        // "Payment offers" section only.
        const storeCarouselCoupons = resolvedCoupons.filter(function (coupon) {
          return String(coupon && coupon.offerType || '').toLowerCase() === 'store_offer';
        });

        // Cache the resolved data for instant rehydrate on the next section re-render.
        if (resolvedCoupons && resolvedCoupons.length) {
          state.lastCouponList = resolvedCoupons;
          saveCouponListCache(resolvedCoupons);
        } else if (!appliedCouponCode) {
          resetCouponListCache();
        }
        state.lastAppliedCode = appliedCouponCode;

        // Force repaint after coupon removal so stale render-key dedup cannot skip the swap.
        if (!appliedCouponCode) {
          state.lastRenderKey = '';
        }

        // Delegate to the dedup-aware renderer. If the rendered output is identical
        // to what's already on screen, this is a true no-op (no innerHTML write,
        // no reflow, no animation restart) — that's the smoothness win.
        const rendered = renderCouponsList(resolvedCoupons, storeCarouselCoupons, appliedCouponCode);
        if (!rendered && !getAllCouponUiParts().length) {
          scheduleOutsideCouponsLoadRetry(150, cartData);
        }

        // Consumers outside the cart (contextual offers sheet) read the list
        // from state instead of calling /coupons/list a second time.
        document.dispatchEvent(
          new CustomEvent('coupons:list-updated', {
            detail: { coupons: resolvedCoupons, appliedCouponCode: appliedCouponCode },
          })
        );
      } catch (error) {
        console.error('Error loading coupons:', error);
        parts.forEach(function (p) {
          p.container.innerHTML = '<div class="coupon-error">Unable to load offers</div>';
        });
      } finally {
        isLoadingCoupons = false;
        state.loadInFlight = false;
        // If another loadCoupons was requested while this one was in flight,
        // flush it now so the latest DOM gets rendered.
        if (state.pendingReload) {
          state.pendingReload = false;
          setTimeout(function () {
            if (typeof window.loadCoupons === 'function') {
              window.loadCoupons(true, state.lastCartData);
            }
          }, 50);
        }
      }
    }

    // Single shared debounced function (on window) so after add.js/cart.js + drawer re-render we only call API once.
    // Call window.loadCoupons so we always use the latest function after script re-runs (drawer re-render).
    // Pass the cart from cart:change so a stale empty cache cannot skip /coupons/list after first ATC.
    if (!window[COUPONS_NS].loadCouponsDebounced) {
      window[COUPONS_NS].loadCouponsDebounced = debounce(function (cartHint) {
        // loadCoupons flips loadInFlight synchronously, so the settle hold sees no gap.
        state.couponListQueued = false;
        if (typeof window.loadCoupons !== 'function') return;
        let hint = cartHint;
        if (
          hint &&
          (Number(hint.item_count) || 0) === 0 &&
          state.lastCartData &&
          (Number(state.lastCartData.item_count) || 0) > 0
        ) {
          hint = state.lastCartData;
        } else if (!hint || typeof hint.item_count === 'undefined') {
          hint = state.lastCartData;
        }
        window.loadCoupons(true, hint);
      }, DEBOUNCE_DELAY, 'loadCoupons');
    }
    const loadCouponsDebounced = window[COUPONS_NS].loadCouponsDebounced;

    if (!window[COUPONS_NS].syncCartDrawerToPayDebounced) {
      window[COUPONS_NS].syncCartDrawerToPayDebounced = debounce(function () {
        if (typeof window.syncCartDrawerToPayFromShopifyCart === 'function') {
          window.syncCartDrawerToPayFromShopifyCart(state.lastCartData);
        }
      }, DEBOUNCE_DELAY, 'syncCartDrawerToPay');
    }
    const syncCartDrawerToPayDebounced = window[COUPONS_NS].syncCartDrawerToPayDebounced;

    // Function to restore manual coupon input state
    function restoreManualCouponInput() {
      forEachManualCouponRoot(function (fields) {
        const inputField = fields.inputField;
        const applyButton = fields.applyButton;
        if (!inputField || !applyButton) return;

        const applyLabel = 'Apply';
        const storedDiscount = getDiscountFromStorage();
        if (storedDiscount && storedDiscount.code) {
          clearManualCouponError(fields);
          inputField.value = storedDiscount.code.toUpperCase();
          inputField.disabled = true;
          // Applied display first so the Apply CTA cannot paint over "CODE + Applied".
          syncManualCouponAppliedDisplay(fields, storedDiscount.code);
          applyButton.innerHTML = 'Remove';
          applyButton.classList.add('cpnBtn', 'cpnBtn-remove');
          applyButton.onclick = function () {
            window.removeManualCouponFn(this);
          };
        } else {
          if (state.manualCouponError) {
            setManualCouponError(fields, state.manualCouponError);
          } else {
            clearManualCouponError(fields);
          }
          syncManualCouponAppliedDisplay(fields, '');
          inputField.disabled = false;
          applyButton.innerHTML = applyLabel;
          applyButton.classList.remove(
            'cpnBtn-remove',
            'available-offers-widget__partnership-apply--remove'
          );
          applyButton.classList.add('cpnBtn');
          applyButton.onclick = function () {
            window.applyManualCouponFn(this);
          };
        }
        syncManualApplyButtonStyle(fields);
      });
      resumeManualCouponCelebrationAfterRender();
    }

    // Combined initialization function
    function initCouponsAndDiscount() {
      // Chained so each step reuses the cart the previous one already fetched
      // instead of issuing its own /cart.js.
      //
      // Strip before clear, deliberately: stripping an unknown code reverts a
      // zeroed GWP line to full price, so a cart that would otherwise have been
      // emptied by the fallback below is left intact. The clear only fires if
      // the code survives /cart/update.js — i.e. it is bound to the token more
      // deeply than that endpoint reaches.
      Promise.resolve(ensureDiscountCartAttributesClean(state.lastCartData))
        .then(function (cart) {
          const known = cart || state.lastCartData;
          return Promise.resolve(stripUnknownDiscountCodes(known)).then(function (stripped) {
            return stripped || known;
          });
        })
        .then(function (cart) {
          const known = cart || state.lastCartData;
          discardCouponSessionIfCartEmpty(known);
          return clearCartIfFreeItemHasNoCoupon(known);
        })
        .catch(function () {
          /* each helper already logs its own failures */
        });
      rehydrateCouponsFromCache();

      // Fire before the restoreCouponSession branches below: those reach
      // loadCoupons, which must see the coupon-removal barrier this opens.
      revalidateAppliedDiscountOncePerSession(state.lastCartData);

      if (!state.listenersAttached) {
        if (getDiscountFromStorage()?.code) {
          restoreCouponSession(state.lastCartData, { forceListRefresh: false });
        } else {
          loadCoupons(false, state.lastCartData);
          if (state.lastCartData) {
            syncPriceSummaryFromCart(state.lastCartData);
          } else {
            syncCartDrawerToPayDebounced();
          }
          setTimeout(restoreFreeProductsInCart, 120);
          setTimeout(initManualCouponInput, 150);
          setTimeout(restoreManualCouponInput, 200);
        }
        return;
      }

      syncStaleCouponRoots();
      if (getDiscountFromStorage()?.code) {
        const hasCouponCards = getAllCouponUiParts().some(function (p) {
          return p.container && p.container.querySelector('.coupon-card');
        });
        restoreCouponSession(state.lastCartData, {
          forceListRefresh: !hasCouponCards,
          skipListLoad: hasCouponCards,
        });
      } else {
        if (state.lastCartData) syncPriceSummaryFromCart(state.lastCartData);
        setTimeout(restoreFreeProductsInCart, 120);
        setTimeout(initManualCouponInput, 150);
        setTimeout(restoreManualCouponInput, 200);
      }
    }

    function bootCopyCodeCouponUi() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCouponsAndDiscount);
      } else {
        initCouponsAndDiscount();
      }

      attachCouponSheetUiOnce();
      schedulePreloadCouponSuccessAssets();
    }

    window.__copyCodeCouponUiBoot = bootCopyCodeCouponUi;
    bootCopyCodeCouponUi();

    // Attach cart listeners only once globally - prevents multiple coupons/list calls after every add.js and cart.js
    if (!state.listenersAttached) {
      state.listenersAttached = true;
      if (!state.manualHeightListenerAttached) {
        state.manualHeightListenerAttached = true;
        window.addEventListener('resize', debounce(syncCouponCarouselHeights, 120, 'couponCarouselHeight'));
      }
      // Re-entry guard: while an apply/remove is mid-flight, the cart:refresh
      // it triggers should NOT cause a second /coupons/list fetch. Same trick
      // as bblunt's window.couponCheckInProgress flag — we still rehydrate
      // from cache so any new section markup gets repainted with the cached
      // coupons, but we skip the network round-trip.
      function handleCartDataUpdate(event) {
        const cart = event?.detail?.cart;
        if (window.couponCheckInProgress || state.couponCheckInProgress) {
          rehydrateCouponsFromCache();
          if (cart && typeof cart === 'object' && Array.isArray(cart.items)) {
            cacheCartData(cart);
          }
          setTimeout(function () {
            restoreDiscount(cart || state.lastCartData);
          }, 100);
          setTimeout(restoreFreeProductsInCart, 120);
          return;
        }
        const previousCart = state.lastCartData;
        const cartCompositionUnchanged =
          cart &&
          typeof cart === 'object' &&
          Array.isArray(cart.items) &&
          previousCart &&
          isCartCompositionUnchanged(previousCart, cart);
        if (
          cart &&
          previousCart &&
          !cartCompositionUnchanged &&
          !getDiscountFromStorage()?.code
        ) {
          clearStaleCouponInputErrors();
        }
        if (getDiscountFromStorage()?.code) {
          state.highValueCartDeferForCoupon = true;
        }
        if (cart && typeof cart === 'object' && Array.isArray(cart.items)) {
          cacheCartData(cart);
          syncPriceSummaryFromCart(cart);
        } else {
          syncCartDrawerToPayDebounced();
        }
        if (cartCompositionUnchanged) {
          rehydrateCouponsFromCache();
        }
        // Schedule the revalidation debounce BEFORE the list-refresh debounce.
        // Both use the same DEBOUNCE_DELAY, and setTimeout callbacks with equal
        // delay fire in registration order - so revalidateAppliedDiscount's
        // timer runs first and opens the coupon-removal barrier (see
        // beginCouponRemovalBarrier) in time for the loadCoupons call below to
        // see and await it. Without this ordering the barrier doesn't exist
        // yet when loadCoupons' own timer fires, so it fetches immediately and
        // can still render a stale, coupon-still-applied list.
        if (getDiscountFromStorage()?.code) {
          revalidateAppliedDiscountDebounced();
        } else {
          state.highValueCartDeferForCoupon = false;
          setTimeout(function () {
            restoreDiscount(cart || state.lastCartData);
          }, 100);
          setTimeout(restoreFreeProductsInCart, 120);
        }
        if (!cartCompositionUnchanged) {
          state.couponListQueued = true;
          loadCouponsDebounced(cart || state.lastCartData);
        }
        // b1g1:entitlements runs with the loader stubbed out (runQuiet), so a
        // hold taken there would never be matched by a real start.
        if (
          event?.detail?.baseEvent !== 'b1g1:entitlements' &&
          (getDiscountFromStorage()?.code || !cartCompositionUnchanged)
        ) {
          holdCartLoaderUntilCouponsSettle();
        }
      }

      // A bare cart:refresh (no detail.cart) means something outside the theme
      // changed the cart — e.g. the Helium chat calling /cart/add.js directly.
      // lastCartData is then stale (often the empty boot cart), and painting from
      // it showed Order Total ₹0 / To pay = shipping only. Refetch, then rerun.
      // global.js already fetches /cart.js on a bare cart:refresh via
      // createCartPromise(), which reuses its in-flight request — so this
      // shares that call instead of adding one. The fresh cart goes through the
      // cart:change path, not the refresh one: an outside add is a composition
      // change, so the offers list must reload (a stale empty hint may already
      // have hidden it) — handleCartDataUpdate skips that when nothing changed.
      function refetchCartAndRestore() {
        const pending =
          typeof window.createCartPromise === 'function'
            ? window.createCartPromise()
            : fetch('/cart.js').then(function (r) {
                return r.json();
              });
        return Promise.resolve(pending)
          .then(function (fresh) {
            if (fresh && Array.isArray(fresh.items)) {
              handleCartDataUpdate({ detail: { cart: fresh } });
            }
          })
          .catch(function () {
            /* keep the current paint; the next cart event will resync */
          });
      }

      // cart:refresh (drawer re-render, post-apply echo) — restore UI only, no apply revalidate.
      function handleCartRefreshRestore(event) {
        const cart = event?.detail?.cart;
        if (
          !(cart && typeof cart === 'object' && Array.isArray(cart.items)) &&
          !(window.couponCheckInProgress || state.couponCheckInProgress)
        ) {
          refetchCartAndRestore();
          return;
        }
        if (window.couponCheckInProgress || state.couponCheckInProgress) {
          if (cart && typeof cart === 'object' && Array.isArray(cart.items)) {
            cacheCartData(cart);
          }
          rehydrateCouponsFromCache();
          setTimeout(function () {
            restoreDiscount(cart || state.lastCartData);
          }, 100);
          setTimeout(restoreFreeProductsInCart, 120);
          return;
        }
        if (cart && typeof cart === 'object' && Array.isArray(cart.items)) {
          cacheCartData(cart);
          if (maybeNormalizeSplitPaidLines(cart)) return;
          syncPriceSummaryFromCart(cart);
        }
        rehydrateCouponsFromCache();
        setTimeout(function () {
          restoreDiscount(cart || state.lastCartData);
        }, 100);
        setTimeout(restoreFreeProductsInCart, 120);
        setTimeout(restoreManualCouponInput, 200);
        setTimeout(function () {
          if (cart && !state.splitLineNormalizationInFlight) {
            maybeNormalizeSplitPaidLines(cart);
          }
        }, 500);
      }

      function handleCartDrawerRender() {
        // Run first so fresh drawer DOM gets HVC alert/checkout state once per render
        // (before coupon restore / early returns). See reapplyHighValueCartRestrictionOnDrawerRender.
        reapplyHighValueCartRestrictionOnDrawerRender();

        const cart = state.lastCartData;
        if (window.couponCheckInProgress || state.couponCheckInProgress) {
          rehydrateCouponsFromCache();
          setTimeout(function () {
            restoreDiscount(cart);
          }, 100);
          setTimeout(restoreFreeProductsInCart, 120);
          return;
        }
        if (getDiscountFromStorage()?.code) {
          if (cart && maybeNormalizeSplitPaidLines(cart)) return;
          restoreCouponSession(cart, { skipListLoad: true });
        } else {
          rehydrateCouponsFromCache();
          if (cart) syncPriceSummaryFromCart(cart);
          setTimeout(restoreFreeProductsInCart, 120);
          setTimeout(restoreManualCouponInput, 200);
        }
      }

      document.addEventListener('cart:change', handleCartDataUpdate);
      document.addEventListener('cart:refresh', handleCartRefreshRestore);
      document.addEventListener('cart:drawer:render', handleCartDrawerRender);
    }

    // For HS Slide Cart compatibility (if used)
    window.HS_SLIDE_CART_LOADED = initCouponsAndDiscount;
    window.HS_SLIDE_CART_UPDATED = initCouponsAndDiscount;
    window.HS_SLIDE_CART_OPENED = initCouponsAndDiscount;

    // Expose functions globally for side cart integration
    window.fetchCouponsFromAPI = fetchCouponsFromAPI;
    window.getDiscountFromStorage = getDiscountFromStorage;
    window.buildCouponCard = buildCouponCard;
    window.loadCoupons = loadCoupons;
    window.rehydrateCouponsFromCache = rehydrateCouponsFromCache;
    window.restoreCouponSession = restoreCouponSession;
    window.resetCouponListCache = resetCouponListCache;
    window.showDiscountInSubtotal = showDiscountInSubtotal;
    window.revalidateAppliedDiscount = revalidateAppliedDiscount;
    window.saveDiscountToStorage = saveDiscountToStorage;
    window.clearDiscountFromStorage = clearDiscountFromStorage;
    window.clearCouponSessionState = clearCouponSessionState;
    window.clearDiscountCartAttributes = clearDiscountCartAttributes;
    window.ensureDiscountCartAttributesClean = ensureDiscountCartAttributesClean;
    window.closeCouponOfferSheet = closeCouponOfferSheet;
    window.syncCartDrawerToPayFromShopifyCart = syncCartDrawerToPayFromShopifyCart;
    window.syncPriceSummaryFromCart = syncPriceSummaryFromCart;
    window.getCartTotals = getCartTotals;
    window.getDisplayCart = getDisplayCart;
    window.showFreeProductsInCart = showFreeProductsInCart;
    window.hideFreeProductsInCart = hideFreeProductsInCart;
    window.restoreFreeProductsInCart = restoreFreeProductsInCart;
    window.saveFreeProductsToStorage = saveFreeProductsToStorage;
    window.getFreeProductsFromStorage = getFreeProductsFromStorage;
    window.clearFreeProductsFromStorage = clearFreeProductsFromStorage;
    window.forEachManualCouponRoot = forEachManualCouponRoot;
    window.maybeNormalizeSplitPaidLines = maybeNormalizeSplitPaidLines;
  })();
